export const fr = {
  'common.signOut': 'Se déconnecter',
  'profile.menu': 'Mon profil',
  'profile.title': 'Mon profil',
  'profile.subtitle': 'Vos informations personnelles : adresse, IBAN, photo et plus.',
  'profile.address': 'Adresse',
  'profile.zip': 'NPA',
  'profile.city': 'Localité',
  'profile.nationality': 'Nationalité',
  'profile.iban': 'IBAN',
  'profile.birthDate': 'Date de naissance',
  'profile.phone': 'Numéro de téléphone',
  'profile.uploadPhoto': 'Télécharger une photo',
  'profile.removePhoto': 'Supprimer la photo',
  'profile.noPhoto': 'Pas de photo',
  'profile.photoError': 'L’image n’a pas pu être traitée.',
  'profile.saved': 'Profil enregistré',
  'common.signIn': 'Se connecter',
  'common.email': 'E-mail',
  'common.password': 'Mot de passe',
  'common.search': 'Rechercher',
  'common.cancel': 'Annuler',
  'common.save': 'Enregistrer',
  'common.create': 'Créer',
  'common.new': 'Nouveau',
  'pdf.preview': 'Aperçu',
  'common.edit': 'Modifier',
  'common.back': 'Retour',
  'picker.product.placeholder': 'Rechercher un produit (référence ou nom)…',
  'picker.product.empty': 'Aucun produit trouvé',
  'picker.product.create': 'Créer un nouveau produit',
  'picker.product.required': 'Veuillez choisir un produit pour chaque ligne.',
  'common.delete': 'Supprimer',

  // Invoice print / PDF
  'invoice.print.viewPdf': 'Voir / PDF',
  'invoice.print.printOrSave': 'Imprimer / Enregistrer en PDF',
  'invoice.print.downloadPdf': 'Télécharger le PDF',
  'email.title': 'Envoyer par e-mail',
  'email.intro': 'Le document est joint en PDF et envoyé via votre serveur SMTP configuré.',
  'email.to': 'Destinataire',
  'email.subject': 'Objet',
  'email.send': 'Envoyer par e-mail',
  'email.message': 'Message',
  'email.body': 'Bonjour\n\nveuillez trouver le document en pièce jointe.\n\nCordialement',
  'attachments.title': 'Pièces jointes',
  'attachments.upload': 'Téléverser un fichier',
  'attachments.hint': 'PDF, images ou fichiers Office jusqu’à 10 Mo.',
  'attachments.empty': 'Aucune pièce jointe.',
  'attachments.delete': 'Supprimer',
  'invoice.print.sendMail': 'Envoyer par e-mail',
  'invoice.print.heading': 'Facture',
  'order.pdf.heading': 'Confirmation de commande',
  'quote.pdf.heading': 'Devis',
  'quote.pdf.to': 'Devis à',
  'quote.pdf.intro': 'Nous vous remercions de votre demande et vous soumettons l’offre suivante :',
  'quote.pdf.vatNote': 'Tous les prix en {currency}, hors TVA.',
  'quote.pdf.validity': 'Ce devis est valable jusqu’au {date}.',
  'quote.pdf.closing': 'Meilleures salutations',
  'quote.email.title': 'Envoyer le devis au client',
  'quote.email.subject': 'Devis {number}',
  'quote.email.body': 'Bonjour\n\nNous avons le plaisir de vous soumettre notre devis {number}, valable jusqu’au {validUntil}. Vous trouverez le document en pièce jointe.\n\nNous restons à votre disposition pour toute question.\n\nMeilleures salutations',
  'quote.email.markOnly': 'Marquer comme envoyé uniquement',
  'order.email.title': 'Envoyer la confirmation de commande au client',
  'order.email.subject': 'Confirmation de commande {number}',
  'order.email.body': 'Bonjour\n\nNous vous remercions de votre commande. Vous trouverez ci-joint la confirmation de commande {number}.\n\nNous restons à votre disposition pour toute question.\n\nMeilleures salutations',
  'delivery.email.title': 'Envoyer le bulletin de livraison au client',
  'delivery.email.subject': 'Bulletin de livraison {number}',
  'delivery.email.body': 'Bonjour\n\nVotre livraison est en route. Vous trouverez ci-joint le bulletin de livraison {number}.\n\nNous restons à votre disposition pour toute question.\n\nMeilleures salutations',
  'delivery.email.tracking': 'Suivi de l’envoi : {tracking}',
  'invoice.email.title': 'Envoyer la facture au client',
  'invoice.email.subject': 'Facture {number}',
  'invoice.email.body': 'Bonjour\n\nVous trouverez ci-joint notre facture {number} d’un montant de {amount}, payable jusqu’au {dueDate}.\n\nNous vous remercions de votre confiance.\n\nMeilleures salutations',
  'po.pdf.heading': 'Bon de commande',
  'po.pdf.to': 'Fournisseur',
  'po.pdf.intro': 'Nous souhaitons commander les articles suivants :',
  'po.email.title': 'Envoyer le bon de commande au fournisseur',
  'po.email.subject': 'Bon de commande {number}',
  'po.email.body': 'Bonjour\n\nVous trouverez ci-joint notre bon de commande {number}. Merci de nous en confirmer la réception.\n\nMerci beaucoup.\n\nMeilleures salutations',
  'po.email.expected': 'Date de livraison souhaitée : {date}',
  'inv.po.action.email': 'Envoyer au fournisseur',
  'hr.payslips.title': 'Fiches de salaire',
  'hr.payslips.action': 'Fiches de salaire',
  'hr.payslips.employee': 'Collaborateur',
  'hr.payslips.empty': 'Aucune fiche de salaire dans ce cycle.',
  'payslip.pdf.heading': 'Fiche de salaire',
  'payslip.pdf.employee': 'Collaborateur',
  'payslip.pdf.employeeNumber': 'Numéro de personnel',
  'payslip.pdf.period': 'Période de paie',
  'payslip.pdf.baseSalary': 'Salaire de base',
  'payslip.pdf.allowances': 'Indemnités',
  'payslip.pdf.gross': 'Salaire brut',
  'payslip.pdf.tax': 'Impôt à la source',
  'payslip.pdf.deductions': 'Autres déductions',
  'payslip.pdf.net': 'Salaire net',
  'payslip.pdf.confidential': 'Confidentiel - réservé au destinataire.',
  'projects.billing.title': 'Facturation',
  'projects.billing.rate': 'Taux horaire',
  'projects.billing.unbilledTime': 'Heures non facturées',
  'projects.billing.expenses': 'Frais refacturables',
  'projects.billing.total': 'À facturer',
  'projects.billing.action': 'Créer la facture',
  'projects.billing.empty': 'Rien en attente - toutes les positions approuvées sont facturées.',
  'projects.billing.noCustomer': 'Aucun client n’est associé à ce projet - attribuez-en un pour activer la facturation.',
  'projects.billing.noRevenueAccount': 'Aucun compte de produits trouvé.',
  'projects.billing.lineTime': 'Prestations du projet {code} - {hours} h',
  'projects.billing.lineExpenses': 'Frais du projet {code}',
  'projects.billing.done': 'Facture {number} créée',
  'projects.billing.markFailed': 'La facture {number} a été créée mais le marquage des positions a échoué - ne refacturez PAS ce projet !',
  'inv.products.modal.skuHint': 'p. ex. ART-0001',
  'inv.products.modal.skuHintService': 'p. ex. SRV-0001',
  'inv.products.modal.editTitle': 'Modifier le produit',
  'inv.products.modal.active': 'Actif',
  'inv.products.modal.type': 'Type de produit',
  'inv.products.modal.typeGood': 'Article (géré en stock)',
  'inv.products.modal.typeService': 'Prestation (sans gestion de stock)',
  'inv.products.modal.serviceHint': 'Les prestations sont gérées sans stock - stock minimal, traçabilité et mouvements de marchandises ne s’appliquent pas.',
  'product.type.GOOD': 'Article',
  'product.type.SERVICE': 'Prestation',
  'uom.short.EACH': 'pce',
  'uom.short.BOX': 'boîte',
  'uom.short.KG': 'kg',
  'uom.short.L': 'l',
  'uom.short.M': 'm',
  'uom.short.HOUR': 'h',
  'uom.short.DAY': 'jours',
  'uom.short.FLAT': 'forfait',
  'uom.unit.EACH': 'Pièce',
  'uom.unit.BOX': 'Boîte',
  'uom.unit.KG': 'Kilogramme',
  'uom.unit.L': 'Litre',
  'uom.unit.M': 'Mètre',
  'uom.unit.HOUR': 'Heure',
  'uom.unit.DAY': 'Jour',
  'uom.unit.FLAT': 'Forfait',
  'order.pdf.to': 'Client',
  'pdf.draftMark': 'Brouillon - non contractuel',
  'invoice.print.billTo': 'Facturé à',
  'invoice.print.total': 'Montant total',
  'invoice.print.mailSubject': 'Facture',
  'invoice.print.mailGreeting': 'Bonjour,',
  'invoice.print.mailBody': 'veuillez trouver ci-joint notre facture',
  'invoice.print.qrMissing': 'Pour générer le code QR, saisissez d’abord le nom de l’entreprise et l’IBAN sous Paramètres → Entreprise & coordonnées bancaires.',
  'invoice.print.qrError': 'Le code QR n’a pas pu être généré. Veuillez vérifier l’IBAN dans les paramètres.',

  // Settings → company / bank
  'settings.company.title': 'Entreprise & coordonnées bancaires',
  'settings.company.intro': 'Ces informations apparaissent sur les factures et dans le code QR suisse.',
  'settings.company.name': 'Nom de l’entreprise',
  'settings.company.address': 'Adresse',
  'settings.company.zip': 'NPA',
  'settings.company.city': 'Ville',
  'settings.company.email': 'E-mail',
  'settings.company.phone': 'Téléphone',
  'settings.company.bank': 'Coordonnées bancaires',
  'settings.company.iban': 'IBAN',
  'settings.company.bankName': 'Banque',
  'settings.company.vat': 'Numéro de TVA',
  'settings.company.saved': 'Enregistré.',
  'settings.smtp.title': 'Envoi d’e-mails (SMTP)',
  'settings.smtp.intro': 'Serveur de messagerie pour l’envoi automatique des factures/rappels. Le mot de passe est stocké de façon sécurisée et jamais affiché.',
  'settings.smtp.host': 'Serveur SMTP',
  'settings.smtp.port': 'Port',
  'settings.smtp.user': 'Utilisateur',
  'settings.smtp.password': 'Mot de passe',
  'settings.smtp.passwordKeep': '•••••• (défini - laisser vide pour conserver)',
  'settings.smtp.from': 'Adresse expéditeur',
  'settings.smtp.secure': 'Utiliser SSL/TLS (port 465)',

  // CSV import/export
  'csv.export': 'Exporter CSV',
  'csv.import': 'Importer CSV',
  'csv.import.intro': 'Téléchargez un fichier CSV. Les colonnes sont mappées automatiquement (point-virgule ou virgule).',
  'csv.import.expectedColumns': 'Colonnes attendues',
  'csv.import.file': 'Fichier CSV',
  'csv.import.preview': 'Aperçu',
  'csv.import.rows': 'lignes',
  'csv.import.start': 'Importer',
  'csv.import.running': 'Importation',
  'csv.import.done': 'Terminé',
  'csv.import.imported': 'importé(s)',
  'csv.import.failedCount': 'échoué(s)',
  'csv.import.line': 'Ligne',
  'csv.import.empty': 'Le fichier ne contient aucune ligne de données.',
  'csv.import.parseError': 'Le fichier n’a pas pu être lu.',
  'csv.import.missingColumns': 'Colonnes obligatoires manquantes',
  'common.confirm': 'Confirmer',
  'common.actions': 'Actions',
  'common.all': 'Tous',
  'common.searchPlaceholder': 'Rechercher…',
  'common.loadError': 'Impossible de charger les données',

  'col.code': 'Code',
  'col.number': 'Numéro',
  'col.name': 'Nom',
  'col.type': 'Type',
  'col.email': 'E-mail',
  'col.date': 'Date',
  'col.due': 'Échéance',
  'col.total': 'Total',
  'col.paid': 'Payé',
  'col.status': 'Statut',
  'col.balance': 'Solde',
  'col.unit': 'Unité',
  'col.product': 'Produit',
  'col.warehouse': 'Entrepôt',
  'col.amount': 'Montant',
  'col.actions': '',

  'aria.hauptnavigation': 'Navigation principale',
  'aria.menueOeffnen': 'Ouvrir le menu',
  'aria.menueSchliessen': 'Fermer le menu',
  'aria.laedt': 'Chargement',
  'aria.schliessen': 'Fermer',
  'empty.default': 'Aucune donnée',
  'empty.invoices': 'Aucune facture',
  'empty.accounts': 'Aucun compte',
  'empty.employees': 'Aucun employé',
  'empty.leave':    'Aucune demande de congé',
  'empty.payroll':  'Aucune paie',
  'empty.products': 'Aucun produit',
  'empty.lowStock': 'Tous les stocks sont sains - aucune alerte.',
  'empty.po':       'Aucune commande d’achat',
  'empty.customers':'Aucun client',
  'empty.orders':   'Aucune commande de vente',
  'empty.opps':     'Aucune opportunité',

  'status.PROCESSED': 'Traité',
  'status.EXPIRED': 'Expiré',
  'status.CREDIT_HOLD': 'Blocage crédit',
  'status.SUBMITTED': 'Soumis',
  'status.REQUESTED': 'Demandé',
  'status.PROPOSED': 'Proposé',
  'status.UNMATCHED': 'Non rapproché',
  'status.IN_STOCK': 'En stock',
  'status.ACTIVE': 'Actif',
  'status.INACTIVE': 'Inactif',
  'status.BLOCKED': 'Bloqué',
  'status.DRAFT': 'Brouillon',
  'status.POSTED': 'Comptabilisé',
  'status.PAID': 'Payé',
  'status.CANCELLED': 'Annulé',
  'status.CONFIRMED': 'Confirmé',
  'status.FULFILLED': 'Exécuté',
  'status.INVOICED': 'Facturé',
  'status.PARTIAL': 'Partiel',
  'status.PENDING': 'En attente',
  'nav.myTime': 'Mon temps',
  'weekday.mon': 'Lundi',
  'weekday.tue': 'Mardi',
  'weekday.wed': 'Mercredi',
  'weekday.thu': 'Jeudi',
  'weekday.fri': 'Vendredi',
  'weekday.sat': 'Samedi',
  'weekday.sun': 'Dimanche',
  'time.my.title': 'Mon temps',
  'time.my.subtitle': 'Saisir l’arrivee et le depart ou ajouter des heures ensuite. Les jours manquants ressortent.',
  'time.week.loading': 'Chargement de la semaine…',
  'time.week.prev': 'Semaine precedente',
  'time.week.next': 'Semaine suivante',
  'time.week.thisWeek': 'Cette semaine',
  'time.week.of': 'sur {target} h',
  'time.week.off': 'libre',
  'time.week.holiday': 'Jour ferie',
  'time.week.missing': 'manquant',
  'time.week.add': 'Saisir',
  'time.balance.target': 'Cible',
  'time.balance.actual': 'Reel',
  'time.balance.balance': 'Solde',
  'time.add.cta': 'Saisir le temps',
  'time.add.title': 'Saisir le temps',
  'time.add.date': 'Jour',
  'time.add.modeClock': 'Arrivee et depart',
  'time.add.modeHours': 'Ajouter des heures',
  'time.add.start': 'Arrivee',
  'time.add.end': 'Depart',
  'time.add.break': 'Pause (min.)',
  'time.add.hours': 'Heures',
  'time.add.overnight': 'L’equipe se poursuit apres minuit',
  'time.add.submit': 'Saisir',
  'time.add.saving': 'Enregistrement…',
  'time.add.failed': 'Saisie impossible',
  'nav.section.self': 'Mes donnees',
  'nav.myLeave': 'Mes vacances',
  'roles.employee': 'Collaborateur',
  'self.title': 'Mes vacances',
  'self.subtitle': 'Connecte en tant que {name}. Cette page ne montre que ce qui vous concerne.',
  'self.loading': 'Chargement…',
  'self.noLink': 'Votre compte n’est pas encore lie a un dossier du personnel. Les ressources humaines doivent creer le lien ; votre solde apparaitra ensuite ici.',
  'self.balances.title': 'Mon solde',
  'self.balances.of': 'sur {granted} jours, {used} pris',
  'self.balances.empty': 'Aucun droit enregistre pour cette annee.',
  'self.requests.title': 'Mes demandes',
  'self.requests.empty': 'Vous n’avez encore soumis aucune demande.',
  'self.requests.col.period': 'Periode',
  'self.requests.col.days': 'Jours',
  'self.requests.col.status': 'Etat',
  'self.requests.col.reason': 'Motif',
  'self.requests.col.note': 'Reponse',
  'self.leave.request': 'Demander des vacances',
  'self.leave.type': 'Type',
  'self.leave.typePlaceholder': 'Veuillez choisir',
  'self.leave.from': 'Du',
  'self.leave.to': 'Au',
  'self.leave.reason': 'Motif (facultatif)',
  'self.leave.submit': 'Soumettre la demande',
  'self.leave.submitting': 'Envoi…',
  'self.leave.submit.failed': 'La demande n’a pas pu etre soumise',
  'self.leave.withdraw': 'Retirer',
  'self.leave.withdraw.failed': 'Retrait impossible',
  'self.leave.orderHint': 'La date de fin precede la date de debut.',
  'self.leave.workdayHint': 'Seuls les jours ouvrables comptent. Les week-ends et jours feries ne sont pas deduits.',
  'status.PENDING_APPROVAL': 'En attente d’approbation',
  'status.APPROVED': 'Approuvé',
  'status.REJECTED': 'Rejeté',
  'status.RECEIVED': 'Reçu',
  'status.OPEN': 'Ouvert',
  'status.PAUSED': 'En pause',
  'status.CLOSED': 'Fermé',
  'status.ON_LEAVE': 'En congé',
  'status.TERMINATED': 'Résilié',
  'status.SUSPENDED': 'Suspendu',
  'status.SENT': 'Envoyé',
  'status.ACCEPTED': 'Accepté',
  'status.CONVERTED': 'Converti',
  'status.OVERDUE': 'En retard',
  'status.HIRED': 'Embauché',

  'accountType.ASSET': 'Actif',
  'accountType.LIABILITY': 'Passif',
  'accountType.EQUITY': 'Capitaux propres',
  'accountType.REVENUE': 'Produit',
  'accountType.EXPENSE': 'Charge',

  'invoiceType.SALES': 'Vente',
  'invoiceType.PURCHASE': 'Achat',

  'finance.accounts.title': 'Plan comptable',
  'finance.accounts.subtitle': 'Tous les comptes du grand livre avec leur solde courant.',

  'finance.invoices.title': 'Factures',
  'finance.invoices.subtitle': 'Clients + fournisseurs. La comptabilisation d’un brouillon génère l’écriture comptable.',
  'finance.invoices.insight.status': 'Statut',
  'finance.invoices.insight.open': 'Factures ouvertes',
  'finance.invoices.insight.outstanding': 'Montant dû',
  'finance.invoices.insight.overdue': 'En retard',
  'finance.invoices.insight.balance': 'Solde (Revenus − Dépenses)',
  'finance.invoices.cat.income': 'Revenus (Ventes)',
  'finance.invoices.cat.expense': 'Dépenses (Achats)',
  'finance.invoices.filterType.all': 'Tous les types',
  'finance.invoices.filterType.sales': 'Ventes (clients)',
  'finance.invoices.filterType.purchase': 'Achats (fournisseurs)',
  'finance.invoices.filterStatus.all': 'Tous les statuts',
  'finance.invoices.action.post': 'Comptabiliser',
  'finance.invoices.action.delete': 'Supprimer',
  'finance.invoices.action.cancel': 'Annuler',
  'finance.invoices.confirmDelete': 'Supprimer vraiment ce brouillon de facture ?',
  'finance.invoices.confirmCancel': 'Annuler vraiment cette facture ? Une écriture de contre-passation sera comptabilisée.',

  'finance.reports.title': 'Rapports',
  'finance.reports.subtitle': 'Balance, compte de résultat, bilan.',
  'finance.reports.trialBalance': 'Balance',
  'finance.reports.income': 'Compte de résultat',
  'finance.reports.balanceSheet': 'Bilan',
  'finance.reports.totals.debits': 'Débits',
  'finance.reports.totals.credits': 'Crédits',
  'finance.reports.totals.balanced': '✓ équilibré',
  'finance.reports.totals.unbalanced': '⚠ déséquilibré',
  'finance.reports.totals.assetsEquation': '✓ Actif = Passif + Capitaux propres',
  'finance.reports.col.debit': 'Débit',
  'finance.reports.col.credit': 'Crédit',
  'finance.reports.metric.revenue': 'Produits',
  'finance.reports.metric.expenses': 'Charges',
  'finance.reports.metric.netIncome': 'Résultat net',
  'finance.reports.metric.assets': 'Actif',
  'finance.reports.metric.liabilities': 'Passif',
  'finance.reports.metric.equity': 'Capitaux propres',

  // Finance - décompte TVA
  'vat.title': 'Décompte TVA',
  'vat.subtitle': 'Décompte trimestriel selon les contre-prestations convenues (méthode effective).',
  'vat.quarter': 'Trimestre',
  'vat.year': 'Année',
  'vat.col.code': 'Chiffre',
  'vat.col.label': 'Désignation',
  'vat.col.base': 'Chiffre d’affaires (CHF)',
  'vat.col.tax': 'Impôt (CHF)',
  'vat.row.total': 'Total des contre-prestations convenues',
  'vat.row.exempt': 'Dont exonéré (0 %)',
  'vat.row.rate': 'Prestations à',
  'vat.row.outputTax': 'Total de l’impôt dû',
  'vat.row.inputTax': 'Impôt préalable',
  'vat.row.payable': 'Montant à payer',
  'vat.row.credit': 'Solde en votre faveur',
  'vat.counts': '{sales} factures de vente · {purchases} factures d’achat · {credits} avoirs',
  'vat.net': 'Net',
  'vat.tax': 'TVA',
  'vat.rateCol': 'TVA %',

  'hr.employees.title': 'Employés',
  'hr.employees.subtitle': 'Tous les employés avec leur statut et leur palier salarial.',
  'hr.employees.col.hired': 'Embauche',
  'hr.employees.col.salary': 'Salaire de base',
  'hr.leave.title': 'Demandes de congé',
  'hr.leave.subtitle': 'Approuve ou rejette les demandes en attente ; les soldes se mettent à jour automatiquement.',
  'hr.leave.tab.requests': 'Demandes',
  'hr.leave.tab.balances': 'Soldes',
  'hr.leave.tab.calendar': 'Calendrier',
  'hr.leave.col.employee': 'Employé',
  'hr.leave.col.type': 'Type',
  'hr.leave.col.start': 'Début',
  'hr.leave.col.end': 'Fin',
  'hr.leave.col.days': 'Jours',
  'hr.leave.col.reason': 'Motif',
  'hr.leave.action.approve': 'Approuver',
  'hr.leave.action.reject': 'Rejeter',
  'hr.leave.entitlement.action': 'Définir le droit',
  'hr.leave.entitlement.title': 'Définir le droit aux congés',
  'hr.leave.entitlement.year': 'Année',
  'hr.leave.entitlement.days': 'Droit (jours)',
  'hr.leave.entitlement.allTypes': 'Tous les types',
  'hr.leave.balance.entitled': 'Droit',
  'hr.leave.balance.used': 'Utilisé',
  'hr.leave.balance.remaining': 'Restant',
  'hr.leave.balance.empty': 'Aucun solde pour cette année',
  'hr.leave.calendar.absences': 'Absences',
  'hr.leave.calendar.empty': 'Aucune absence approuvée',
  'hr.leave.calendar.holidays': 'Jours fériés',
  'hr.leave.calendar.noHolidays': 'Aucun jour férié enregistré',
  'hr.payroll.title': 'Cycles de paie',
  'hr.payroll.subtitle': 'Cycles de paie mensuels avec totaux brut/impôt/net.',
  'hr.payroll.col.period': 'Période',
  'hr.payroll.col.gross': 'Brut',
  'hr.payroll.col.tax': 'Impôt',
  'hr.payroll.col.deductions': 'Déductions',
  'hr.payroll.col.net': 'Net',

  'inv.products.title': 'Produits',
  'inv.products.subtitle': 'Catalogue principal avec prix et seuils de réapprovisionnement.',
  'inv.products.action.new': 'Nouveau produit',
  'inv.products.search': 'Rechercher SKU ou nom…',
  'inv.products.col.sku': 'Référence',
  'inv.products.col.price': 'Prix catalogue',
  'inv.products.col.reorder': 'Seuil',
  'inv.products.modal.title': 'Nouveau produit',
  'inv.products.modal.listPrice': 'Prix catalogue',
  'inv.products.modal.reorderPoint': 'Seuil de réapprovisionnement',
  'inv.lowStock.title': 'Stock bas',
  'inv.lowStock.subtitle': 'Articles à ou sous leur seuil. Réapprovisionne ou émets un bon de commande.',
  'inv.lowStock.col.onHand': 'En stock',
  'inv.lowStock.col.severity': 'Sévérité',
  'inv.lowStock.sev.out': 'Rupture',
  'inv.lowStock.sev.critical': 'Critique',
  'inv.lowStock.sev.low': 'Bas',
  'inv.po.title': 'Commandes d’achat',
  'inv.po.subtitle': 'Confirme les brouillons puis enregistre la réception - la facture fournisseur est créée automatiquement.',
  'inv.po.insight.dist': 'Commandes d’achat par statut',
  'inv.po.insight.open': 'Commandes ouvertes',
  'inv.po.insight.openValue': 'Valeur ouverte',
  'inv.po.insight.awaiting': 'En attente de réception',
  'inv.po.insight.received': 'Reçu',
  'inv.po.col.date': 'Date de commande',
  'inv.po.col.expected': 'Prévu',
  'inv.po.action.confirm': 'Confirmer',
  'inv.po.action.approve': 'Approuver',
  'inv.po.action.reject': 'Rejeter',
  'inv.po.approval.title': 'Approbation',
  'inv.po.approval.submitted': 'Soumis pour approbation - un admin doit approuver.',
  'inv.po.approval.confirmReject': 'Vraiment rejeter cette commande ?',
  'inv.po.approval.requestedBy': 'Demandé par',
  'inv.po.approval.decidedBy': 'Décidé par',
  'inv.po.approval.decidedAt': 'Décidé le',
  'inv.po.approval.note': 'Note de rejet',

  'sales.customers.title': 'Clients',
  'sales.customers.subtitle': 'Fiches clients avec limites de crédit.',
  'sales.customers.insight.revenue': 'Répartition du chiffre d’affaires',
  'sales.customers.insight.others': 'Autres',
  'sales.customers.insight.total': 'Clients au total',
  'sales.customers.insight.active': 'Actifs',
  'sales.customers.insight.withOpenOrders': 'Avec commandes ouvertes',
  'sales.customers.insight.avgRevenue': 'CA moyen/client',
  'sales.customers.action.new': 'Nouveau client',
  'sales.customers.search': 'Rechercher nom ou code…',
  'sales.customers.col.creditLimit': 'Limite de crédit',
  'sales.customers.modal.title': 'Nouveau client',
  'sales.customers.modal.currency': 'Devise',
  'sales.customers.modal.creditLimit': 'Limite de crédit (0 = illimité)',
  'sales.orders.title': 'Commandes de vente',
  'sales.orders.subtitle': 'La confirmation d’une commande déclenche la sortie de stock → exécution → facture client via événements.',
  'sales.orders.insight.dist': 'Commandes par statut',
  'sales.orders.insight.open': 'Commandes ouvertes',
  'sales.orders.insight.openValue': 'Valeur ouverte',
  'sales.orders.insight.toFulfill': 'À exécuter',
  'sales.orders.insight.booked': 'Valeur confirmée',
  'sales.orders.col.fulfillment': 'Exécution',
  'sales.orders.action.confirm': 'Confirmer',
  'sales.orders.action.cancel': 'Annuler',
  'sales.pipeline.title': 'Pipeline',
  'sales.pipeline.subtitle': 'Transitions de stage via le menu déroulant de chaque carte.',
  'sales.pipeline.action.new': 'Nouvelle opportunité',
  'sales.pipeline.stage.LEAD': 'Lead',
  'sales.pipeline.stage.QUALIFY': 'Qualification',
  'sales.pipeline.stage.PROPOSAL': 'Proposition',
  'sales.pipeline.stage.NEGOTIATE': 'Négociation',
  'sales.pipeline.stage.CLOSED_WON': 'Gagnée',
  'sales.pipeline.stage.CLOSED_LOST': 'Perdue',
  'sales.pipeline.modal.title': 'Nouvelle opportunité',
  'sales.pipeline.modal.titleField': 'Titre',
  'sales.pipeline.modal.amount': 'Montant',
  'sales.pipeline.modal.stage': 'Stage',
  'sales.pipeline.modal.customer': 'Client',
  'sales.pipeline.modal.customer.none': '- Aucun -',
  'sales.pipeline.modal.close': 'Clôture prévue',
  'sales.reports.title': 'Rapports de vente',
  'sales.reports.subtitle': 'Chiffre d’affaires comptabilisé par client / produit, plus le funnel pipeline.',
  'sales.reports.funnel': 'Funnel pipeline',
  'sales.reports.byCustomer': 'Ventes par client',
  'sales.reports.byProduct': 'Ventes par produit',
  'sales.reports.col.stage': 'Stage',
  'sales.reports.col.count': 'Nombre',
  'sales.reports.col.pipeline': 'Pipeline',
  'sales.reports.col.weighted': 'Pondéré',
  'sales.reports.col.orders': 'Commandes',
  'sales.reports.col.revenue': 'Revenu',
  'sales.reports.col.units': 'Unités',

  'login.title': 'Connexion',
  'login.hint':  'Utilise ton e-mail professionnel et ton mot de passe.',
  'login.cta':   'Se connecter',
  'login.cta.loading': 'Connexion…',
  'login.failed':'Échec de la connexion',
  'login.askAdmin':'Besoin d’un compte ? Demande à ton administrateur de le créer.',

  'nav.section.overview': 'Aperçu',
  'nav.section.finance':  'Finances',
  'nav.section.hr':       'RH',
  'nav.section.inventory':'Stock',
  'nav.section.sales':    'Ventes',
  'nav.section.account':  'Compte',
  'nav.section.automation': 'Automatisation',
  'nav.rules': 'Règles',
  'nav.alerts': 'Alertes',

  // Automatisation / moteur de règles
  'auto.title': 'Règles d’automatisation',
  'auto.subtitle': 'Quand un événement survient et que la condition est remplie, une alerte est levée.',
  'auto.empty': 'Aucune règle définie.',
  'auto.col.name': 'Règle',
  'auto.col.trigger': 'Déclencheur',
  'auto.col.condition': 'Condition',
  'auto.col.severity': 'Niveau',
  'auto.col.fired': 'Déclenchée',
  'auto.col.enabled': 'Active',
  'auto.col.message': 'Message',
  'auto.col.time': 'Heure',
  'auto.always': 'toujours',
  'auto.on': 'Activée',
  'auto.off': 'Désactivée',
  'auto.severity.INFO': 'Info',
  'auto.severity.WARNING': 'Avertissement',
  'auto.severity.CRITICAL': 'Critique',
  'auto.action.new': 'Nouvelle règle',
  'auto.action.delete': 'Supprimer',
  'auto.action.markRead': 'Marquer lu',
  'auto.action.markAll': 'Tout marquer lu',
  'auto.metric.rules': 'Règles',
  'auto.metric.active': 'Actives',
  'auto.metric.alerts': 'Alertes ouvertes',
  'auto.field.name': 'Nom',
  'auto.field.trigger': 'Événement déclencheur',
  'auto.field.condition': 'Condition (facultatif)',
  'auto.field.noCondition': 'Sans condition (toujours)',
  'auto.field.value': 'Valeur',
  'auto.field.severity': 'Niveau',
  'auto.field.message': 'Message',
  'auto.field.messageHint': 'Variables en {…} disponibles :',
  'auto.op.lt': 'inférieur à',
  'auto.op.lte': 'au plus',
  'auto.op.gt': 'supérieur à',
  'auto.op.gte': 'au moins',
  'auto.op.eq': 'égal à',
  'auto.op.neq': 'différent de',
  'auto.op.contains': 'contient',
  'auto.op.exists': 'existe',
  'auto.modal.title': 'Nouvelle règle d’automatisation',
  'auto.error.required': 'Nom, déclencheur et message requis.',
  'auto.alerts.title': 'Alertes',
  'auto.alerts.subtitle': 'Notifications générées par vos règles.',
  'auto.alerts.empty': 'Aucune alerte.',

  'nav.dashboard':        'Tableau de bord',
  'nav.inbox':            'Boîte d’actions',
  'nav.calendar':         'Calendrier',

  // Vue calendrier
  'cal.title': 'Calendrier',
  'cal.subtitle': 'Échéances sur tous les modules : factures, maintenance, commandes, congés.',
  'cal.today': 'Aujourd’hui',
  'cal.type.invoice': 'Facture échue',
  'cal.type.maintenance': 'Maintenance',
  'cal.type.order': 'Commande',
  'cal.type.leave': 'Congé',
  'cal.type.event': 'Événement',
  'event.order.confirmed': 'Commande confirmée',
  'event.order.credit_hold': 'Commande bloquée (crédit)',
  'event.order.fulfilled': 'Commande exécutée',
  'event.order.invoiced': 'Commande facturée',
  'event.return.received': 'Retour reçu',
  'event.stock.low': 'Stock sous le seuil',
  'event.po.received': 'Marchandise reçue (commande)',
  'event.po.confirmed': 'Bon de commande confirmé',
  'event.po.approval.requested': 'Commande à approuver',
  'event.po.approval.decided': 'Approbation de commande décidée',
  'event.invoice.posted': 'Facture comptabilisée',
  'event.payment.received': 'Paiement reçu',
  'event.work_order.completed': 'Ordre de fabrication terminé',
  'event.work_order.confirmed': 'Ordre de fabrication confirmé',
  'event.payroll.processed': 'Paie traitée',
  'event.leave.requested': 'Absence demandée',
  'event.leave.decided': 'Absence décidée',
  'event.expense.requested': 'Frais soumis',
  'event.expense.decided': 'Frais décidés',
  'event.employee.created': 'Collaborateur créé',
  'event.employee.terminated': 'Collaborateur sorti',
  'field.orderNumber': 'Numéro de commande',
  'field.orderId': 'ID de commande',
  'field.returnNumber': 'Numéro de retour',
  'field.returnId': 'ID de retour',
  'field.productId': 'ID produit',
  'field.sku': 'Référence',
  'field.productSku': 'Référence',
  'field.quantity': 'Quantité',
  'field.confirmedQuantity': 'Quantité confirmée',
  'field.reorderPoint': 'Stock minimal',
  'field.poNumber': 'Numéro de commande fournisseur',
  'field.totalAmount': 'Montant',
  'field.amount': 'Montant',
  'field.approved': 'Approuvé (oui/non)',
  'field.invoiceNumber': 'Numéro de facture',
  'field.type': 'Type',
  'field.periodYear': 'Année',
  'field.periodMonth': 'Mois',
  'field.payslipCount': 'Nombre de fiches',
  'field.employeeId': 'ID collaborateur',
  'field.employeeName': 'Collaborateur',
  'field.days': 'Jours',
  'field.status': 'Statut',
  'field.terminationDate': 'Date de sortie',
  'cal.day.empty': 'Aucune entrée ce jour.',
  'cal.day.open': 'Ouvrir',
  'cal.event.add': 'Ajouter une entrée',
  'cal.event.new': 'Nouvelle entrée (visible par tous)',
  'cal.event.title': 'Titre',
  'cal.event.date': 'Date',
  'cal.event.endDate': 'Jusqu’au (optionnel)',
  'cal.event.description': 'Description',
  'cal.event.createdBy': 'Ajouté par {name}',

  // Boîte d’actions centrale
  'inbox.title': 'Boîte d’actions',
  'inbox.subtitle': 'Toutes les approbations en attente et les alertes au même endroit.',
  'inbox.empty': 'Rien à faire - tout est traité. 🎉',
  'inbox.metric.total': 'En attente',
  'inbox.days': 'jours',
  'inbox.viewAll': 'Tout afficher',
  'inbox.action.approve': 'Approuver',
  'inbox.action.reject': 'Rejeter',
  'inbox.action.read': 'Marquer lu',
  'inbox.kind.po': 'Commande',
  'inbox.kind.req': 'Demande d’achat',
  'inbox.kind.leave': 'Congé',
  'inbox.kind.expense': 'Frais',
  'inbox.kind.alert': 'Alerte',
  'inbox.section.po': 'Commandes à approuver',
  'inbox.section.req': 'Demandes d’achat',
  'inbox.section.leave': 'Demandes de congé',
  'inbox.section.expense': 'Frais à approuver',
  'inbox.section.alert': 'Alertes d’automatisation',
  'nav.accounts':         'Plan comptable',
  'nav.invoices':         'Factures',
  'nav.dunning':          'Relances',
  'nav.creditNotes': 'Avoirs',
  'nav.recurring':        'Abonnements',
  'nav.costCenters':      'Centres de coûts',
  'nav.controlling':      'Contrôle de gestion',
  'nav.profitCenters':    'Centres de profit',
  'nav.downPayments':     'Acomptes',
  'nav.intercompany':     'Intercompany',
  'nav.budgets':          'Budget',
  'nav.cashJournal':      'Livre de caisse',
  'nav.recurringJournals': 'Écritures récurrentes',
  'nav.paymentTerms':     'Conditions de paiement',
  'nav.collectiveInvoice': 'Facture collective',

  // Facturation collective
  'ci.title': 'Facturation collective',
  'ci.subtitle': 'Regrouper plusieurs factures de vente brouillon d’un client en une seule facture.',
  'ci.empty': 'Aucune facture de vente brouillon ouverte.',
  'ci.draftsWord': 'brouillons',
  'ci.metric.drafts': 'Brouillons',
  'ci.metric.customers': 'Clients',
  'ci.metric.selected': 'Sélectionnés',
  'ci.col.number': 'N°',
  'ci.col.date': 'Date',
  'ci.col.total': 'Total',
  'ci.combineTitle': 'Regrouper {n} factures',
  'ci.invoiceDate': 'Date facture',
  'ci.dueDate': 'Échéance',
  'ci.action.combine': 'Regrouper',
  'ci.error.min': 'Sélectionnez au moins deux factures.',
  'ci.error.dates': 'Date de facture et échéance requises.',

  // Conditions de paiement / escompte
  'pt.title': 'Conditions de paiement',
  'pt.subtitle': 'Délai net + escompte ; le calculateur détermine l’escompte et le montant à payer selon la date.',
  'pt.empty': 'Aucune condition de paiement.',
  'pt.days': 'jours',
  'pt.col.code': 'Code',
  'pt.col.name': 'Désignation',
  'pt.col.net': 'Délai net',
  'pt.col.discount': 'Escompte',
  'pt.action.new': 'Nouvelle condition',
  'pt.action.calc': 'Calculateur d’escompte',
  'pt.modal.title': 'Nouvelle condition de paiement',
  'pt.field.netDays': 'Jours nets',
  'pt.field.discountDays': 'Jours escompte',
  'pt.field.discountPercent': 'Escompte %',
  'pt.error.required': 'Code, désignation et délai net requis.',
  'pt.calc.title': 'Calculateur d’escompte',
  'pt.calc.term': 'Condition',
  'pt.calc.base': 'Montant facture',
  'pt.calc.invoiceDate': 'Date facture',
  'pt.calc.paymentDate': 'Date paiement',
  'pt.calc.due': 'Échéance',
  'pt.calc.deadline': 'Escompte jusqu’au',
  'pt.calc.discount': 'Escompte',
  'pt.calc.payable': 'À payer',
  'pt.calc.within': 'Escompte accordé',
  'pt.calc.outside': 'Pas d’escompte (délai dépassé)',
  'pt.error.calcRequired': 'Condition, montant et les deux dates requis.',

  // Écritures récurrentes
  'rj.title': 'Écritures récurrentes',
  'rj.subtitle': 'Modèles d’écriture équilibrés ; une exécution comptabilise une écriture réelle et reprogramme.',
  'rj.empty': 'Aucun modèle.',
  'rj.active': 'Actif',
  'rj.inactive': 'Inactif',
  'rj.col.description': 'Description',
  'rj.col.frequency': 'Fréquence',
  'rj.col.next': 'Prochaine',
  'rj.col.last': 'Dernière',
  'rj.freq.MONTHLY': 'Mensuelle',
  'rj.freq.QUARTERLY': 'Trimestrielle',
  'rj.freq.YEARLY': 'Annuelle',
  'rj.action.new': 'Nouveau modèle',
  'rj.action.run': 'Comptabiliser',
  'rj.action.runDue': 'Comptabiliser dues',
  'rj.action.activate': 'Activer',
  'rj.action.deactivate': 'Désactiver',
  'rj.metric.active': 'Actifs',
  'rj.metric.total': 'Modèles',
  'rj.modal.title': 'Nouveau modèle d’écriture',
  'rj.field.nextRun': 'Première exécution',
  'rj.field.lines': 'Lignes d’écriture',
  'rj.field.addLine': '+ Ligne',
  'rj.debit': 'Débit',
  'rj.credit': 'Crédit',
  'rj.error.required': 'Description et date requises.',
  'rj.error.unbalanced': 'Débits = crédits requis (et > 0).',

  // Livre de caisse (FBCJ)
  'cb.title': 'Livre de caisse',
  'cb.subtitle': 'Caisses avec encaissements/décaissements et solde courant (pas de caisse négative).',
  'cb.empty': 'Aucune écriture.',
  'cb.col.number': 'N°',
  'cb.col.date': 'Date',
  'cb.col.type': 'Type',
  'cb.col.description': 'Libellé',
  'cb.col.amount': 'Montant',
  'cb.col.balance': 'Solde',
  'cb.type.RECEIPT': 'Encaissement',
  'cb.type.PAYMENT': 'Décaissement',
  'cb.action.newJournal': 'Nouvelle caisse',
  'cb.action.post': 'Écriture',
  'cb.metric.balance': 'Solde de caisse',
  'cb.metric.entries': 'Écritures',
  'cb.metric.currency': 'Devise',
  'cb.journal.title': 'Nouvelle caisse',
  'cb.field.code': 'Code',
  'cb.field.name': 'Nom',
  'cb.field.currency': 'Devise',
  'cb.field.category': 'Catégorie',
  'cb.field.reference': 'Référence',
  'cb.error.journalRequired': 'Code et nom requis.',
  'cb.post.title': 'Écriture de caisse',
  'cb.error.entryRequired': 'Libellé et montant requis.',

  // Budget & contrôle de disponibilité
  'bud.title': 'Budget',
  'bud.subtitle': 'Budgets par compte/période avec réel et disponibilité ; les écritures manuelles au-delà du budget sont bloquées.',
  'bud.empty': 'Aucun budget pour cette année.',
  'bud.over': 'Dépassé',
  'bud.within': 'Dans le budget',
  'bud.col.account': 'Compte',
  'bud.col.period': 'Période',
  'bud.col.budgeted': 'Budget',
  'bud.col.actual': 'Réel',
  'bud.col.available': 'Disponible',
  'bud.action.set': 'Définir le budget',
  'bud.action.check': 'Vérifier la disponibilité',
  'bud.metric.budgeted': 'Budget total',
  'bud.metric.actual': 'Réel total',
  'bud.metric.over': 'Dépassé',
  'bud.modal.title': 'Définir le budget',
  'bud.field.year': 'Année',
  'bud.field.month': 'Mois',
  'bud.field.amount': 'Montant du budget',
  'bud.error.required': 'Compte et montant requis.',
  'bud.check.title': 'Contrôle de disponibilité',
  'bud.check.amount': 'Montant de l’écriture',
  'bud.check.exceed': 'Dépasserait le budget',
  'bud.check.ok': 'Dans le budget',
  'bud.check.uncontrolled': 'Aucun budget défini - non contrôlé.',
  'bud.error.checkRequired': 'Compte et montant requis.',

  // Écritures intercompany
  'ic.title': 'Écritures intercompany',
  'ic.subtitle': 'Sociétés et écritures entre elles ; créance/dette en miroir (solde du groupe nul).',
  'ic.col.company': 'Société',
  'ic.col.receivable': 'Créance',
  'ic.col.payable': 'Dette',
  'ic.col.net': 'Net',
  'ic.col.doc': 'Document',
  'ic.col.date': 'Date',
  'ic.col.flow': 'De → Vers',
  'ic.col.description': 'Description',
  'ic.col.amount': 'Montant',
  'ic.action.newCompany': 'Nouvelle société',
  'ic.action.newPosting': 'Nouvelle écriture',
  'ic.metric.companies': 'Sociétés',
  'ic.metric.receivable': 'Créances',
  'ic.metric.payable': 'Dettes',
  'ic.metric.net': 'Solde du groupe',
  'ic.reconciliation': 'Rapprochement par société',
  'ic.postings': 'Écritures',
  'ic.noCompanies': 'Aucune société.',
  'ic.noPostings': 'Aucune écriture.',
  'ic.company.title': 'Nouvelle société',
  'ic.field.name': 'Nom',
  'ic.field.currency': 'Devise',
  'ic.error.companyRequired': 'Code et nom requis.',
  'ic.posting.title': 'Nouvelle écriture intercompany',
  'ic.posting.from': 'Société source',
  'ic.posting.to': 'Société cible',
  'ic.posting.needTwo': 'Au moins deux sociétés sont requises.',
  'ic.error.postingRequired': 'Les deux sociétés et un montant sont requis.',
  'ic.error.distinct': 'La société source et cible doivent différer.',

  // Acomptes (down payments)
  'dp.title': 'Acomptes',
  'dp.subtitle': 'Demander des acomptes, enregistrer leur réception et les imputer à la facture finale.',
  'dp.empty': 'Aucun acompte.',
  'dp.col.number': 'N°',
  'dp.col.party': 'Tiers',
  'dp.col.amount': 'Montant',
  'dp.partyType.CUSTOMER': 'Client',
  'dp.partyType.VENDOR': 'Fournisseur',
  'dp.status.REQUESTED': 'Demandé',
  'dp.status.RECEIVED': 'Reçu',
  'dp.status.APPLIED': 'Imputé',
  'dp.action.new': 'Nouvel acompte',
  'dp.action.receive': 'Enregistrer la réception',
  'dp.action.apply': 'Imputer',
  'dp.field.partyType': 'Type',
  'dp.field.party': 'Nom',
  'dp.field.description': 'Description',
  'dp.modal.title': 'Nouvel acompte',
  'dp.error.required': 'Nom et montant requis.',
  'dp.apply.title': 'Imputer l’acompte',
  'dp.apply.hint': 'Imputer l’acompte de {amount} de {party} à une facture ouverte.',
  'dp.apply.invoice': 'Facture finale',
  'dp.apply.open': 'ouvert',
  'dp.apply.noInvoices': 'Aucune facture comptabilisée ouverte disponible.',
  'dp.error.invoiceRequired': 'Veuillez sélectionner une facture.',

  // Comptabilité par centre de profit (CO)
  'pc.title': 'Centres de profit',
  'pc.subtitle': 'Données de base des centres de profit avec écritures produits/charges et résultat par centre.',
  'pc.empty': 'Aucun centre de profit.',
  'pc.inactive': 'Inactif',
  'pc.col.code': 'Code',
  'pc.col.name': 'Désignation',
  'pc.col.revenue': 'Produits',
  'pc.col.expense': 'Charges',
  'pc.col.result': 'Résultat',
  'pc.action.new': 'Nouveau centre',
  'pc.action.post': 'Écriture',
  'pc.metric.revenue': 'Produits totaux',
  'pc.metric.expense': 'Charges totales',
  'pc.metric.result': 'Résultat total',
  'pc.modal.title': 'Nouveau centre de profit',
  'pc.field.description': 'Description',
  'pc.error.required': 'Code et désignation requis.',
  'pc.post.title': 'Écriture de centre de profit',
  'pc.post.type': 'Type',
  'pc.error.postRequired': 'Centre de profit et montant requis.',
  'pc.type.REVENUE': 'Produits',
  'pc.type.EXPENSE': 'Charges',
  'nav.reportBuilder':    'Générateur de rapports',

  // Générateur de rapports
  'rb.title': 'Générateur de rapports',
  'rb.subtitle': 'Composez vos propres rapports, enregistrez-les et exportez en CSV.',
  'rb.source': 'Source de données',
  'rb.groupBy': 'Grouper par',
  'rb.noGroup': '- sans regroupement -',
  'rb.limit': 'Limite',
  'rb.fields': 'Champs',
  'rb.filters': 'Filtres',
  'rb.value': 'Valeur',
  'rb.addFilter': '+ Filtre',
  'rb.run': 'Exécuter',
  'rb.save': 'Enregistrer',
  'rb.savePrompt': 'Nom du rapport :',
  'rb.exportCsv': 'Exporter CSV',
  'rb.noRows': 'Aucun enregistrement.',
  'rb.saved': 'Rapports enregistrés',
  'rb.load': 'Charger',
  'rb.delete': 'Supprimer',
  'rb.src.invoices': 'Factures',
  'rb.src.cost_center_postings': 'Écritures CO',
  'rb.op.eq': 'égal à',
  'rb.op.neq': 'différent de',
  'rb.op.gt': 'supérieur à',
  'rb.op.gte': 'au moins',
  'rb.op.lt': 'inférieur à',
  'rb.op.lte': 'au plus',
  'rb.op.contains': 'contient',

  // Contrôle de gestion (CO) - plan/réel/écart
  'co.title': 'Contrôle de gestion',
  'co.subtitle': 'Plan vs. réel des centres de coûts avec écart par exercice.',
  'co.empty': 'Aucun centre de coûts.',
  'co.col.code': 'Centre de coûts',
  'co.col.name': 'Libellé',
  'co.col.plan': 'Plan',
  'co.col.actual': 'Réel',
  'co.col.variance': 'Écart',
  'co.metric.plan': 'Plan total',
  'co.metric.actual': 'Réel total',
  'co.metric.variance': 'Écart',
  'co.action.setPlan': 'Définir le plan',
  'co.action.postCost': 'Saisir un coût',
  'co.field.costCenter': 'Centre de coûts',
  'co.field.plannedAmount': 'Montant planifié',
  'co.field.date': 'Date de saisie',
  'co.field.amount': 'Montant',
  'co.field.description': 'Description',
  'co.field.reference': 'Référence',
  'co.plan.title': 'Plan annuel',
  'co.post.title': 'Saisie de coût',
  'co.error.required': 'Centre de coûts et montant planifié requis.',
  'co.error.postRequired': 'Centre de coûts, date et montant positif requis.',
  'nav.bank':             'Rapprochement bancaire',
  'nav.paymentRuns':      'Programme de paiement',

  // Programme de paiement (F110)
  'pr.title': 'Programme de paiement',
  'pr.subtitle': 'Regrouper les factures fournisseurs ouvertes et les régler en un cycle.',
  'pr.empty': 'Aucun cycle de paiement.',
  'pr.col.number': 'N°',
  'pr.col.paymentDate': 'Date de paiement',
  'pr.col.dueBy': 'Échéance jusqu’au',
  'pr.col.count': 'Postes',
  'pr.col.total': 'Total',
  'pr.status.PROPOSED': 'Proposition',
  'pr.status.EXECUTED': 'Exécuté',
  'pr.status.CANCELLED': 'Annulé',
  'pr.action.new': 'Nouveau cycle',
  'pr.action.view': 'Ouvrir',
  'pr.action.execute': 'Exécuter',
  'pr.action.cancel': 'Annuler',
  'pr.metric.proposed': 'Propositions',
  'pr.metric.executed': 'Exécutés',
  'pr.field.dueBy': 'Échéance jusqu’au',
  'pr.modal.title': 'Créer une proposition de paiement',
  'pr.modal.hint': 'Les factures fournisseurs CHF ouvertes échues à la date choisie sont proposées.',
  'pr.modal.propose': 'Créer la proposition',
  'pr.modal.creating': 'Création',
  'pr.error.required': 'Date de paiement et date d’échéance requises.',
  'pr.detail.executed': '{n} facture(s) payée(s).',
  'pr.detail.noItems': 'Aucune facture échue.',
  'pr.item.invoice': 'Facture',
  'pr.item.amount': 'Montant',
  'pr.item.state': 'État',
  'pr.item.paid': 'Payée',
  'pr.item.failed': 'Échec',
  'pr.item.pending': 'Proposée',
  'nav.vat':              'Décompte TVA',
  'bank.title': 'Rapprochement bancaire',
  'bank.subtitle': 'Importer les relevés bancaires et associer les paiements aux factures',
  'bank.loading': 'Chargement',
  'bank.tab.unmatched': 'Ouvert',
  'bank.tab.matched': 'Associé',
  'bank.tab.ignored': 'Ignoré',
  'bank.col.date': 'Date',
  'bank.col.direction': 'Sens',
  'bank.col.amount': 'Montant',
  'bank.col.reference': 'Référence',
  'bank.col.counterparty': 'Contrepartie',
  'bank.col.suggestion': 'Suggestion',
  'bank.dir.credit': 'Entrée',
  'bank.dir.debit': 'Sortie',
  'bank.action.import': 'Importer un relevé',
  'bank.action.match': 'Associer',
  'bank.action.ignore': 'Ignorer',
  'bank.empty.unmatched': 'Aucune opération ouverte',
  'bank.empty.matched': 'Aucune opération associée pour le moment',
  'bank.empty.ignored': 'Aucune opération ignorée',
  'bank.import.title': 'Importer un relevé bancaire',
  'bank.import.fileLabel': 'Fichier (CAMT.053 XML ou CSV)',
  'bank.import.formatLabel': 'Format',
  'bank.import.formatCamt': 'CAMT.053 (XML)',
  'bank.import.formatCsv': 'CSV',
  'bank.import.action': 'Importer',
  'bank.import.success': '{count} opérations importées',
  'bank.import.fileRequired': 'Veuillez d’abord sélectionner un fichier',
  'bank.match.title': 'Associer l’opération',
  'bank.match.invoiceLabel': 'Facture',
  'bank.match.placeholder': 'Sélectionner une facture …',
  'bank.match.open': 'Solde',
  'bank.match.confirm': 'Associer',
  'bank.match.noCandidates': 'Aucune facture ouverte correspondante trouvée',
  'bank.match.selectRequired': 'Veuillez sélectionner une facture',
  'bank.ignore.title': 'Ignorer l’opération',
  'bank.ignore.message': 'Cette opération sera marquée comme ignorée et retirée de la liste des opérations ouvertes.',
  'cc.title': 'Centres de coûts',
  'cc.subtitle': 'Budget vs. réel par centre de coûts',
  'cc.action.new': 'Nouveau centre',
  'cc.action.edit': 'Modifier',
  'cc.empty': 'Aucun centre de coûts',
  'cc.active': 'Actif',
  'cc.inactive': 'Inactif',
  'cc.metric.count': 'Centres de coûts',
  'cc.metric.budget': 'Budget total',
  'cc.metric.actual': 'Réel total',
  'cc.metric.utilization': 'Utilisation',
  'cc.col.code': 'Code',
  'cc.col.name': 'Nom',
  'cc.col.budget': 'Budget',
  'cc.col.actual': 'Réel',
  'cc.col.remaining': 'Restant',
  'cc.col.utilization': 'Utilisation',
  'cc.modal.title': 'Nouveau centre de coûts',
  'cc.modal.editTitle': 'Modifier le centre de coûts',
  'cc.field.code': 'Code',
  'cc.field.name': 'Nom',
  'cc.field.budget': 'Budget annuel',
  'cc.field.parent': 'Centre de coûts parent',
  'cc.field.noParent': '- aucun -',
  'cc.field.currency': 'Devise',
  'cc.field.active': 'Actif',
  'cc.field.notes': 'Notes',
  'dunning.title': 'Relances',
  'dunning.subtitle': 'Détecter les factures en retard et envoyer des rappels',
  'dunning.tab.overdue': 'En retard',
  'dunning.tab.notices': 'Rappels',
  'dunning.level': 'Niveau',
  'dunning.maxReached': 'Niveau max atteint',
  'dunning.action.create': 'Rappel niveau',
  'dunning.action.markPaid': 'Payé',
  'dunning.action.view': 'Voir',
  'dunning.print.heading': 'Rappel de paiement',
  'dunning.print.greeting': 'Madame, Monsieur',
  'dunning.print.body': "Malgré l'échéance, la facture ci-dessous est toujours ouverte. Merci de régler le montant dû, frais de rappel inclus, d'ici la date indiquée ci-dessous.",
  'dunning.print.amountDue': 'Montant de facture ouvert',
  'dunning.print.total': 'À payer (frais inclus)',
  'dunning.print.payBy': 'Payable jusqu’au',
  'dunning.print.closing': 'Pour toute question, nous restons à disposition. Cordialement',
  'dunning.action.cancel': 'Annuler',
  'dunning.empty.overdue': 'Aucune facture en retard 🎉',
  'dunning.empty.notices': 'Aucun rappel',
  'dunning.metric.overdue': 'Factures en retard',
  'dunning.metric.outstanding': 'Montant dû',
  'dunning.metric.openNotices': 'Rappels ouverts',
  'dunning.metric.totalNotices': 'Total des rappels',
  'dunning.col.invoice': 'Facture',
  'dunning.col.daysOverdue': 'Jours de retard',
  'dunning.col.outstanding': 'Dû',
  'dunning.col.lastLevel': 'Dernier niveau',
  'dunning.col.date': 'Date',
  'dunning.col.level': 'Niveau',
  'dunning.col.fee': 'Frais',
  'dunning.status.OPEN': 'Ouvert',
  'dunning.status.PAID': 'Payé',
  'dunning.status.CANCELLED': 'Annulé',
  'nav.reports':          'Rapports',
  'nav.employees':        'Employés',
  'nav.leave':            'Congés',
  'nav.payroll':          'Paie',
  'nav.products':         'Produits',
  'nav.lowStock':         'Stock bas',
  'nav.purchaseOrders':   'Commandes',
  'nav.customers':        'Clients',
  'nav.orders':           'Commandes',
  'nav.creditManagement': 'Gestion du crédit',

  // Gestion du crédit
  'cm.title': 'Gestion du crédit',
  'cm.subtitle': 'Libérer/refuser les commandes bloquées ; limite et encours de crédit par client.',
  'cm.empty': 'Aucune commande bloquée.',
  'cm.holds': 'File de blocage crédit',
  'cm.lookup': 'Aperçu du crédit par client',
  'cm.selectCustomer': 'Choisir un client…',
  'cm.col.order': 'Commande',
  'cm.col.customer': 'Client',
  'cm.col.amount': 'Montant',
  'cm.col.date': 'Date',
  'cm.action.release': 'Libérer',
  'cm.action.reject': 'Refuser',
  'cm.metric.holds': 'Commandes bloquées',
  'cm.metric.blocked': 'Valeur bloquée',
  'cm.limit': 'Limite de crédit',
  'cm.exposure': 'Encours (ouvert)',
  'cm.available': 'Disponible',
  'cm.unlimited': 'Illimité',
  'cm.within': 'Dans la limite',
  'cm.exceeded': 'Limite dépassée',
  'nav.deliveries': 'Bons de livraison',
  'delivery.title': 'Bons de livraison',
  'delivery.subtitle': 'Toutes les livraisons des commandes exécutées.',
  'delivery.empty': 'Aucun bon de livraison.',
  'delivery.shipping': 'Détails d’expédition',
  'delivery.carrier': 'Transporteur / mode',
  'delivery.tracking': 'N° de suivi',
  'delivery.packages': 'Colis',
  'delivery.weight': 'Poids (kg)',
  'delivery.deliveryDate': 'Date de livraison',
  'delivery.shippingDate': 'Date d’expédition',
  'delivery.qtyDelivered': 'Qté livrée',
  'delivery.print.heading': 'Bon de livraison',
  'delivery.print.shipTo': 'Adresse de livraison',
  'nav.pipeline':         'Pipeline',
  'nav.settings':         'Paramètres',

  'dashboard.title':       'Tableau de bord',
  'dashboard.subtitle':    'Aperçu en direct du chiffre d’affaires, de la trésorerie, des créances/dettes et du pipeline.',
  'dashboard.config.button': 'Personnaliser',
  'dashboard.config.title':  'Personnaliser le tableau de bord',
  'dashboard.config.intro':  'Choisissez les indicateurs et graphiques à afficher.',
  'dashboard.config.all':    'Tout',
  'dashboard.revenue':     'Chiffre d’affaires (période)',
  'dashboard.expenses':    'Charges (période)',
  'dashboard.netProfit':   'Résultat net',
  'dashboard.cash':        'Trésorerie disponible',
  'dashboard.ar':          'Créances clients',
  'dashboard.ap':          'Dettes fournisseurs',
  'dashboard.openSales':   'Factures clients ouvertes',
  'dashboard.openPurchases': 'Factures fournisseurs ouvertes',
  'dashboard.overdue':       'En retard (créances)',
  'dashboard.forecast':    'Prévision pipeline',
  'dashboard.chartTitle':  'Chiffre d’affaires vs charges',
  'dashboard.deltaPrevMonth': 'vs mois précédent',

  // Tableau de bord : centre d’action + états vides
  'dashboard.actions.title': 'À traiter',
  'dashboard.actions.creditHolds': 'commandes bloquées (crédit)',
  'dashboard.actions.backordersReady': 'reliquats prêts à livrer',
  'dashboard.actions.poApprovals': 'commandes à approuver',
  'dashboard.actions.banfPending': 'DA à approuver',
  'dashboard.actions.overdueAr': 'factures en retard',
  'dashboard.actions.recurringDue': 'écritures récurrentes dues',
  'dashboard.actions.toInbox': 'Toutes les tâches →',
  'dashboard.empty.trend': 'Aucune écriture - créez votre première facture.',
  'dashboard.empty.trendCta': 'Créer une facture',
  'dashboard.empty.pipeline': 'Aucune opportunité dans le pipeline.',
  'dashboard.empty.pipelineCta': 'Créer une opportunité',
  'dashboard.empty.agingGood': 'Aucune créance en retard - tout est en ordre.',

  // Barres d'insight (génériques) + métriques de détail
  'insight.byStatus': 'Par statut',
  'insight.byType': 'Par type',
  'insight.bySeverity': 'Par criticité',
  'insight.bySource': 'Par source',
  'insight.byStage': 'Par étape',
  'insight.byCarrier': 'Par transporteur',
  'insight.byDirection': 'Par sens',
  'insight.count': 'Nombre',
  'insight.active': 'Actifs',
  'insight.inactive': 'Inactifs',
  'insight.total': 'Total',
  'insight.open': 'Ouverts',
  'inv.products.insight.avgPrice': 'Prix catalogue moyen',
  'inv.suppliers.insight.withEmail': 'Avec e-mail',
  'inv.movements.insight.totalValue': 'Valeur totale des biens',
  'inv.movements.insight.inflow': 'Entrées',
  'inv.movements.insight.outflow': 'Sorties',
  'inv.lowStock.insight.affected': 'Articles concernés',
  'inv.lowStock.insight.outOfStock': 'En rupture',
  'inv.lowStock.insight.shortfall': 'Manque total',
  'hr.employees.insight.headcount': 'Effectif',
  'hr.employees.insight.payrollSum': 'Masse salariale',
  'hr.employees.insight.avgSalary': 'Salaire moyen',
  'hr.payroll.insight.runs': 'Cycles de paie',
  'hr.payroll.insight.gross': 'Brut total',
  'hr.payroll.insight.net': 'Net total',
  'hr.payroll.insight.deductions': 'Déductions',
  'hr.leave.insight.requests': 'Demandes',
  'hr.leave.insight.days': 'Jours au total',
  'rec.candidates.insight.sources': 'Sources',
  'rec.candidates.insight.withPhone': 'Avec téléphone',
  'rec.applications.insight.hireRate': "Taux d'embauche",
  'projects.insight.budget': 'Budget total',
  'projects.insight.spent': 'Consommé',
  'finance.accounts.insight.types': 'Types de comptes',
  'creditNote.insight.postedSum': 'Comptabilisées (total)',
  'delivery.insight.thisMonth': 'Ce mois-ci',
  'delivery.insight.withTracking': 'Avec suivi',
  'delivery.insight.carriers': 'Transporteurs',
  'bank.insight.inflow': 'Encaissements',
  'bank.insight.outflow': 'Décaissements',
  'bank.insight.balance': 'Solde',
  'detail.metric.total': 'Total',
  'detail.metric.paid': 'Payé',
  'detail.metric.outstanding': 'En attente',
  'detail.metric.dueInDays': 'Échéance dans (jours)',
  'detail.metric.overdueDays': 'En retard (jours)',
  'detail.metric.date': 'Date',
  'detail.metric.validUntil': "Valable jusqu'au",
  'detail.metric.expected': 'Attendu le',
  'detail.metric.creditLimit': 'Limite de crédit',

  'settings.title':        'Paramètres',
  'settings.subtitle':     'Paramètres personnels de ton compte.',
  'settings.nav.general':       'Général',
  'settings.nav.general.desc':  'Apparence, langue et devise.',
  'settings.nav.company':       'Entreprise',
  'settings.nav.users':         'Utilisateurs & rôles',
  'settings.nav.currencies': 'Devises & cours',
  'settings.nav.currencies.desc': 'Activer les devises étrangères et gérer les cours de change.',
  'settings.appearance':   'Apparence',
  'settings.appearance.intro':       'Choisis le rendu de l’interface.',
  'settings.appearance.active':      'Actif :',
  'settings.appearance.followsSystem':'(suit ton système)',
  'settings.theme.light':       'Clair',
  'settings.theme.light.desc':  'Surfaces claires, texte sombre.',
  'settings.theme.dark':        'Sombre',
  'settings.theme.dark.desc':   'Fond sombre, agréable pour les yeux la nuit.',
  'settings.theme.system':      'Système',
  'settings.theme.system.desc': 'Suit le réglage de ton appareil.',
  'settings.language':          'Langue',
  'settings.language.intro':    'Langue de l’interface.',
  'settings.language.de':       'Deutsch',
  'settings.language.de.desc':  'Standard.',
  'settings.language.en':       'English',
  'settings.language.en.desc':  'English interface.',
  'settings.language.fr':       'Français',
  'settings.language.fr.desc':  'Interface en français.',
  'settings.currency':          'Devise',
  'settings.currency.intro':    'Devise d’affichage pour tous les montants.',
  'settings.currency.CHF':      'Franc suisse (CHF)',
  'settings.currency.CHF.desc': 'Par défaut.',
  'settings.currency.EUR':      'Euro (EUR)',
  'settings.currency.EUR.desc': 'Afficher les montants en euros.',
  'settings.currency.USD':      'Dollar américain (USD)',
  'settings.currency.USD.desc': 'Afficher les montants en dollars américains.',
  'settings.currency.GBP':      'Livre sterling (GBP)',
  'settings.currency.GBP.desc': 'Afficher les montants en livres.',

  'finance.accounts.action.new': 'Nouveau compte',
  'finance.accounts.modal.title': 'Nouveau compte',
  'finance.accounts.modal.parent': 'Compte parent (optionnel)',
  'finance.invoices.action.new': 'Nouvelle facture',
  'finance.invoices.modal.title': 'Nouvelle facture',
  'finance.invoices.modal.customer': 'Client',
  'finance.invoices.modal.vendor': 'Fournisseur',
  'finance.invoices.modal.invoiceDate': 'Date de facture',
  'finance.invoices.modal.dueDate': 'Échéance',
  'finance.invoices.modal.notes': 'Notes',
  'finance.invoices.modal.lines': 'Lignes de facture',
  'finance.invoices.modal.addLine': 'Ajouter une ligne',
  'finance.invoices.modal.removeLine': 'Supprimer',
  'finance.invoices.modal.account': 'Compte',
  'finance.invoices.modal.lineDescription': 'Description',
  'finance.invoices.modal.quantity': 'Quantité',
  'finance.invoices.modal.unitPrice': 'Prix unitaire',
  'finance.invoices.modal.lineTotal': 'Total ligne',
  'finance.invoices.modal.invoiceTotal': 'Total facture',
  'finance.invoices.modal.pickCounterparty': '- Veuillez choisir -',
  'finance.invoices.modal.searchCounterparty': 'Rechercher (code, nom, e-mail)…',
  'finance.invoices.modal.noCounterparty': 'Aucun résultat',
  'finance.invoices.action.pay': 'Payer',
  'finance.invoices.pay.title': 'Enregistrer le paiement',
  'finance.invoices.pay.outstanding': 'Solde',
  'finance.invoices.pay.amount': 'Montant',
  'finance.invoices.pay.date': 'Date de paiement',

  // Rapprochement à 3 voies (commande <-> réception <-> facture fournisseur)
  'match.title': '3-Way-Match',
  'match.status.MATCHED': 'Concordant',
  'match.status.OVER_BILLED': 'Surfacturé',
  'match.status.UNDER_BILLED': 'Sous-facturé',
  'match.status.NO_RECEIPT': 'Aucune réception',
  'match.receivedAt': 'Reçu le',
  'match.receivedValue': 'Valeur reçue',
  'match.billedNet': 'Facturé (net)',
  'match.difference': 'Différence',
  'match.unitCost': 'Coût unitaire',
  'match.lineValue': 'Valeur',
  'match.poSelect': 'Commande (rapprochement à 3 voies)',
  'match.poNone': 'Aucune',
  'match.overWarning': 'La facture dépasse la valeur reçue de {diff}.',
  'match.forceLabel': 'Payer malgré l’écart (forcer)',
  'match.underHint': 'La facture est inférieure à la valeur reçue.',
  'match.noReceiptHint': 'Aucun rapprochement possible (aucune réception complète enregistrée).',
  'match.okHint': 'Concordant avec la réception des marchandises.',
  'match.alreadyBilled': 'La facture {number} existe déjà pour cette commande.',

  'hr.employees.action.new': 'Nouvel employé',
  'hr.employees.action.terminate': 'Résilier',
  'hr.employees.modal.title': 'Nouvel employé',
  'hr.employees.modal.firstName': 'Prénom',
  'hr.employees.modal.lastName': 'Nom',
  'hr.employees.modal.phone': 'Téléphone',
  'hr.employees.modal.hireDate': 'Date d’embauche',
  'hr.employees.modal.department': 'Département',
  'hr.employees.modal.position': 'Poste',
  'hr.employees.modal.baseSalary': 'Salaire de base',
  'hr.employees.modal.currency': 'Devise',
  'hr.employees.modal.optional': '- Aucun -',
  'hr.employees.terminate.title': 'Résilier l’employé',
  'hr.employees.terminate.date': 'Date de résiliation',
  'hr.employees.terminate.confirm': 'Confirmer la résiliation de',
  'hr.leave.action.new': 'Nouvelle demande',
  'hr.leave.modal.title': 'Nouvelle demande de congé',
  'hr.leave.modal.employee': 'Employé',
  'hr.leave.modal.leaveType': 'Type de congé',
  'hr.leave.modal.startDate': 'Date de début',
  'hr.leave.modal.endDate': 'Date de fin',
  'hr.leave.modal.reason': 'Motif',
  'hr.payroll.action.new': 'Nouvelle paie',
  'hr.payroll.modal.title': 'Nouveau cycle de paie',
  'hr.payroll.modal.year': 'Année',
  'hr.payroll.modal.month': 'Mois',
  'hr.payroll.modal.note': 'Le cycle traite tous les employés actifs pour la période choisie.',

  'month.1': 'Janvier',
  'month.2': 'Février',
  'month.3': 'Mars',
  'month.4': 'Avril',
  'month.5': 'Mai',
  'month.6': 'Juin',
  'month.7': 'Juillet',
  'month.8': 'Août',
  'month.9': 'Septembre',
  'month.10': 'Octobre',
  'month.11': 'Novembre',
  'month.12': 'Décembre',

  'nav.suppliers': 'Fournisseurs',
  'nav.stockMovements': 'Mouvements de stock',

  'inv.suppliers.title': 'Fournisseurs',
  'inv.suppliers.subtitle': 'Fiches fournisseurs pour les commandes d’achat.',
  'inv.suppliers.action.new': 'Nouveau fournisseur',
  'inv.suppliers.modal.title': 'Nouveau fournisseur',
  'inv.suppliers.modal.address': 'Adresse',
  'inv.suppliers.modal.phone': 'Téléphone',

  'inv.po.action.new': 'Nouvelle commande',
  'inv.po.action.receive': 'Réception',
  'inv.po.action.cancel': 'Annuler',
  'inv.po.modal.title': 'Nouvelle commande d’achat',
  'inv.po.modal.supplier': 'Fournisseur',
  'inv.po.modal.warehouse': 'Entrepôt',
  'inv.po.modal.orderDate': 'Date de commande',
  'inv.po.modal.expectedDate': 'Date prévue',
  'inv.po.modal.notes': 'Notes',
  'inv.po.modal.lines': 'Lignes',
  'inv.po.modal.product': 'Produit',
  'inv.po.modal.quantity': 'Quantité',
  'inv.po.modal.unitCost': 'Prix unitaire',
  'inv.po.modal.lineTotal': 'Total ligne',
  'inv.po.modal.poTotal': 'Total commande',
  'inv.po.modal.pickProduct': '- Choisir un produit -',
  'inv.po.receive.title': 'Enregistrer la réception',
  'inv.po.receive.intro': 'Confirme la quantité réellement reçue pour chaque ligne. Vide ou 0 = rien reçu.',
  'inv.po.receive.ordered': 'Commandé',
  'inv.po.receive.alreadyReceived': 'Déjà reçu',
  'inv.po.receive.outstanding': 'Reste',
  'inv.po.receive.thisReceipt': 'Reçu maintenant',

  'inv.movements.title': 'Mouvements de stock',
  'inv.movements.subtitle': 'Toutes les réceptions, sorties, transferts et corrections.',
  'inv.movements.action.receive': 'Réception',
  'inv.movements.action.issue': 'Sortie',
  'inv.movements.action.transfer': 'Transfert',
  'inv.movements.action.adjust': 'Correction',
  'inv.movements.col.date': 'Date',
  'inv.movements.col.product': 'Produit',
  'inv.movements.col.warehouse': 'Entrepôt',
  'inv.movements.col.type': 'Type',
  'inv.movements.col.quantity': 'Quantité',
  'inv.movements.col.unitCost': 'Coût unitaire',
  'inv.movements.col.totalCost': 'Coût total',
  'inv.movements.col.notes': 'Notes',
  'inv.movements.type.IN': 'Entrée',
  'inv.movements.type.OUT': 'Sortie',
  'inv.movements.type.TRANSFER_IN': 'Transfert entrée',
  'inv.movements.type.TRANSFER_OUT': 'Transfert sortie',
  'inv.movements.type.ADJUSTMENT': 'Correction',
  'inv.movements.empty': 'Aucun mouvement',
  'inv.movements.receive.title': 'Réception de stock',
  'inv.movements.issue.title': 'Sortie de stock',
  'inv.movements.transfer.title': 'Transfert de stock',
  'inv.movements.adjust.title': 'Correction de stock',
  'inv.movements.modal.product': 'Produit',
  'inv.movements.modal.warehouse': 'Entrepôt',
  'inv.movements.modal.fromWarehouse': 'Entrepôt source',
  'inv.movements.modal.toWarehouse': 'Entrepôt cible',
  'inv.movements.modal.quantity': 'Quantité',
  'inv.movements.modal.delta': 'Variation (+/-)',
  'inv.movements.modal.unitCost': 'Coût unitaire',
  'inv.movements.modal.notes': 'Note',
  'inv.movements.adjust.note': 'Valeurs positives = réapprovisionnement (coût requis). Négatives = perte / dépréciation.',

  'nav.quotes': 'Devis',

  'sales.quotes.title': 'Devis',
  'sales.quotes.subtitle': 'Devis à tes clients : créer, envoyer, saisir leur décision et convertir en commandes.',
  'sales.quotes.insight.dist': 'Devis par statut',
  'sales.quotes.insight.open': 'Devis ouverts',
  'sales.quotes.insight.openValue': 'Valeur ouverte',
  'sales.quotes.insight.acceptance': 'Taux d’acceptation',
  'sales.quotes.insight.expiring': 'Bientôt expiré',
  'sales.quotes.action.new': 'Nouveau devis',
  'sales.quotes.action.send': 'Envoyer au client',
  'sales.quotes.action.accept': 'Acceptée par le client',
  'sales.quotes.action.reject': 'Refusée par le client',
  'sales.quotes.action.convert': 'Convertir en commande',
  'sales.quotes.col.validUntil': 'Valide jusqu’au',
  'sales.quotes.empty': 'Aucun devis',
  'sales.quotes.modal.title': 'Nouveau devis',
  'sales.quotes.modal.editTitle': 'Modifier le devis',
  'sales.quotes.modal.customer': 'Client',
  'sales.quotes.modal.quoteDate': 'Date du devis',
  'sales.quotes.modal.validUntil': 'Valide jusqu’au',
  'sales.quotes.modal.notes': 'Notes',
  'sales.quotes.modal.lines': 'Lignes du devis',
  'sales.quotes.modal.product': 'Produit',
  'sales.quotes.modal.description': 'Description',
  'sales.quotes.modal.quantity': 'Quantité',
  'sales.quotes.modal.unitPrice': 'Prix de vente',
  'sales.quotes.modal.lineTotal': 'Total ligne',
  'sales.quotes.modal.quoteTotal': 'Total devis',
  'sales.quotes.convert.title': 'Convertir le devis en commande',
  'sales.quotes.convert.intro': 'La commande est créée à partir de ce devis. Tu peux ajuster la date de commande et la date de livraison souhaitée.',
  'sales.quotes.convert.orderDate': 'Date de commande',
  'sales.quotes.convert.requiredDate': 'Date souhaitée',

  'sales.orders.action.new': 'Nouvelle commande',
  'sales.orders.action.fulfill': 'Exécuter',
  'sales.orders.action.email': 'Envoyer la confirmation',
  'sales.orders.modal.title': 'Nouvelle commande de vente',
  'sales.orders.modal.customer': 'Client',
  'sales.orders.modal.orderDate': 'Date de commande',
  'sales.orders.modal.requiredDate': 'Date souhaitée',
  'sales.orders.modal.notes': 'Notes',
  'sales.orders.modal.lines': 'Lignes de commande',
  'sales.orders.modal.product': 'Produit',
  'sales.orders.modal.description': 'Description',
  'sales.orders.modal.quantity': 'Quantité',
  'sales.orders.modal.unitPrice': 'Prix de vente',
  'sales.orders.modal.lineTotal': 'Total ligne',
  'sales.orders.modal.orderTotal': 'Total commande',
  'sales.orders.fulfill.title': 'Enregistrer l’exécution',
  'sales.orders.fulfill.intro': 'Indique la quantité expédiée par ligne. Quand toutes les lignes sont expédiées, la commande passe à FULFILLED et la facture client est générée automatiquement.',
  'sales.orders.fulfill.ordered': 'Commandé',
  'sales.orders.fulfill.already': 'Déjà',
  'sales.orders.fulfill.outstanding': 'Restant',
  'sales.orders.fulfill.now': 'Exécuté maintenant',

  'detail.back': 'Retour',
  'detail.header': 'En-tête',
  'detail.lines': 'Lignes',
  'detail.related': 'Liens',
  'flow.title': 'Flux de documents',
  'flow.quote': 'Devis',
  'flow.order': 'Commande',
  'flow.delivery': 'Livraison',
  'flow.invoice': 'Facture',
  'flow.creditNote': 'Avoir',
  'flow.return': 'Retour',
  'flow.none': '-',
  'detail.actions': 'Actions',
  'detail.created': 'Créé',
  'detail.updated': 'Mis à jour',
  'detail.postedAt': 'Comptabilisé',
  'detail.fulfilledAt': 'Exécuté',
  'detail.confirmedAt': 'Confirmé',
  'detail.receivedAt': 'Reçu',
  'detail.invoicedAt': 'Facturé',
  'detail.closedAt': 'Clôturé',
  'detail.subtotal': 'Sous-total',
  'detail.outstanding': 'Restant',
  'detail.notes': 'Notes',
  'detail.fromQuote': 'Issu du devis',
  'detail.toInvoice': 'Facture',
  'detail.fromOrder': 'Issu de la commande',
  'detail.fromPO': 'Issu de la commande d’achat',
  'detail.linkedInvoice': 'Facture liée',
  'detail.lineDescription': 'Description',
  'detail.lineQty': 'Quantité',
  'detail.lineFulfilled': 'Exécuté',
  'detail.lineReceived': 'Reçu',
  'detail.lineUnitPrice': 'Prix unitaire',
  'detail.lineUnitCost': 'Coût unitaire',
  'detail.lineTotal': 'Total',
  'detail.lineAccount': 'Compte',
  'detail.lineProduct': 'Produit',

  'nav.section.recruitment': 'Recrutement',
  'nav.jobPostings': 'Postes',
  'nav.candidates': 'Candidats',
  'nav.applications': 'Candidatures',

  'stage.APPLIED': 'Postulé',
  'stage.SCREEN': 'Présélection',
  'stage.INTERVIEW': 'Entretien',
  'stage.OFFER': 'Offre',
  'stage.HIRED': 'Embauché',
  'stage.REJECTED': 'Refusé',

  'rec.postings.title': 'Offres d’emploi',
  'rec.postings.subtitle': 'Postes ouverts et fermés.',
  'rec.postings.action.new': 'Nouvelle offre',
  'rec.postings.col.title': 'Titre',
  'rec.postings.col.opens': 'Ouverture',
  'rec.postings.col.closes': 'Clôture',
  'rec.postings.empty': 'Aucune offre',
  'rec.postings.action.pause': 'Suspendre',
  'rec.postings.action.reopen': 'Rouvrir',
  'rec.postings.action.close': 'Fermer',
  'rec.postings.modal.title': 'Nouvelle offre d’emploi',
  'rec.postings.modal.titleField': 'Titre',
  'rec.postings.modal.department': 'Département',
  'rec.postings.modal.position': 'Poste',
  'rec.postings.modal.description': 'Description',
  'rec.postings.modal.opensAt': 'Date d’ouverture',
  'rec.postings.modal.closesAt': 'Date de clôture',

  'rec.candidates.title': 'Candidats',
  'rec.candidates.subtitle': 'Vivier de candidats pour toutes les offres.',
  'rec.candidates.action.new': 'Nouveau candidat',
  'rec.candidates.col.source': 'Source',
  'rec.candidates.col.phone': 'Téléphone',
  'rec.candidates.empty': 'Aucun candidat',
  'rec.candidates.modal.title': 'Nouveau candidat',
  'rec.candidates.modal.firstName': 'Prénom',
  'rec.candidates.modal.lastName': 'Nom',
  'rec.candidates.modal.phone': 'Téléphone',
  'rec.candidates.modal.source': 'Source',
  'rec.candidates.modal.resumeUrl': 'URL du CV',
  'rec.candidates.modal.notes': 'Notes',

  'rec.applications.title': 'Candidatures',
  'rec.applications.subtitle': 'Candidatures avec leur stage de pipeline par offre.',
  'rec.applications.action.new': 'Nouvelle candidature',
  'rec.applications.col.candidate': 'Candidat',
  'rec.applications.col.posting': 'Offre',
  'rec.applications.col.stage': 'Stage',
  'rec.applications.empty': 'Aucune candidature',
  'rec.applications.filterStage.all': 'Tous les stages',
  'rec.applications.modal.title': 'Nouvelle candidature',
  'rec.applications.modal.posting': 'Offre d’emploi',
  'rec.applications.modal.candidate': 'Candidat',
  'rec.applications.modal.notes': 'Notes',
  'nav.financeDashboard': 'Aperçu',
  'common.noData': 'Aucune donnée pour cette période',
  'finance.dashboard.title': 'Aperçu financier',
  'finance.dashboard.subtitle': 'Indicateurs et tendances en un coup d’œil',
  'finance.dashboard.lastMonths': '{count} derniers mois',
  'finance.chart.trend': 'Revenus, coûts et bénéfices',
  'finance.chart.trendSub': 'Tendance mensuelle',
  'finance.chart.aging': 'Créances en souffrance (échéance)',
  'finance.chart.openAr': 'Créances ouvertes',
  'finance.chart.expenseBreakdown': 'Répartition des dépenses',
  'finance.chart.invoiceStatus': 'Factures par statut',
  'finance.chart.invoiceCount': 'Nombre de factures',
  'nav.salesDashboard': 'Aperçu',
  'sales.dashboard.title': 'Aperçu des ventes',
  'sales.dashboard.subtitle': 'Commandes, pipeline et meilleurs clients en un coup d’œil',
  'sales.dashboard.lastMonths': '{count} derniers mois',
  'sales.metric.revenue': 'Chiffre d’affaires',
  'sales.metric.orders': 'Commandes',
  'sales.metric.openPipeline': 'Pipeline ouvert',
  'sales.metric.weighted': 'Pipeline pondéré',
  'sales.chart.bookings': 'Prises de commandes',
  'sales.chart.bookingsSub': 'Chiffre d’affaires mensuel',
  'sales.chart.revenue': 'Chiffre d’affaires',
  'sales.chart.pipeline': 'Pipeline par étape',
  'sales.chart.pipelineAmount': 'Montant du pipeline',
  'sales.chart.orderStatus': 'Commandes par statut',
  'sales.chart.topCustomers': 'Meilleurs clients par CA',
  'nav.inventoryDashboard': 'Aperçu',
  'inventory.dashboard.title': 'Aperçu des stocks',
  'inventory.dashboard.subtitle': 'Valeur du stock, mouvements et commandes en un coup d’œil',
  'inventory.dashboard.lastMonths': '{count} derniers mois',
  'inventory.metric.stockValue': 'Valeur du stock',
  'inventory.metric.openPo': 'Commandes ouvertes (valeur)',
  'inventory.metric.openPoCount': 'Commandes ouvertes',
  'inventory.metric.categories': 'Catégories',
  'inventory.chart.movements': 'Mouvements de stock',
  'inventory.chart.movementsSub': 'Entrées et sorties par mois',
  'inventory.chart.inbound': 'Entrées',
  'inventory.chart.outbound': 'Sorties',
  'inventory.chart.stockValue': 'Valeur du stock par catégorie',
  'inventory.chart.poStatus': 'Commandes par statut',
  'inventory.chart.poCount': 'Nombre de commandes',
  'inventory.chart.topProducts': 'Meilleurs produits par valeur',
  'nav.hrDashboard': 'Aperçu',
  'hr.dashboard.title': 'Aperçu RH',
  'hr.dashboard.subtitle': 'Effectifs, coûts salariaux et recrutement en un coup d’œil',
  'hr.dashboard.lastMonths': '{count} derniers mois',
  'hr.metric.headcount': 'Effectif actif',
  'hr.metric.payroll': 'Coût salarial (dernier traitement)',
  'hr.metric.applications': 'Candidatures',
  'hr.metric.hired': 'Embauchés',
  'hr.chart.payroll': 'Évolution des coûts salariaux',
  'hr.chart.payrollSub': 'Brut, net et impôt par mois',
  'hr.chart.gross': 'Brut',
  'hr.chart.net': 'Net',
  'hr.chart.tax': 'Impôt',
  'hr.chart.headcount': 'Effectif par département',
  'hr.chart.employeeStatus': 'Employés par statut',
  'hr.chart.recruitment': 'Entonnoir de recrutement',
  'hr.chart.applications': 'Candidatures',
  'dashboard.pipeline': 'Pipeline commercial',

  // Projects
  'nav.section.projects': 'Projets',
  'nav.projectsDashboard': 'Aperçu',
  'nav.projectsList': 'Projets',

  // Production (PP)
  'nav.section.production': 'Production',
  'nav.productionDashboard': 'Aperçu',
  'nav.boms': 'Nomenclatures',
  'nav.workCenters': 'Postes de travail',
  'nav.workOrders': 'Ordres de fabrication',
  'nav.mrp': 'Planification MRP',
  'nav.capacity': 'Capacité',

  // Planification des capacités (PP)
  'cap.title': 'Planification des capacités',
  'cap.subtitle': 'Charge des postes de travail : charge planifiée des ordres ouverts vs. capacité.',
  'cap.empty': 'Aucun poste de travail.',
  'cap.col.code': 'Poste',
  'cap.col.name': 'Désignation',
  'cap.col.perDay': 'Cap./jour (h)',
  'cap.col.available': 'Disponible',
  'cap.col.load': 'Charge (ouverte)',
  'cap.col.utilization': 'Charge',
  'cap.overloaded': 'Surchargé',
  'cap.horizon': 'Horizon : {n} jours',
  'cap.metric.available': 'Disponible total',
  'cap.metric.load': 'Charge totale',
  'cap.metric.utilization': 'Charge',
  'cap.metric.overloaded': 'Surchargés',
  'production.mrp.title': 'Calcul des besoins (MRP)',
  'production.mrp.subtitle': 'Décomposer une nomenclature et comparer au stock',
  'production.mrp.run': 'Lancer le calcul',
  'production.mrp.buy': 'Composants à acheter',
  'production.mrp.make': 'Sous-ensembles à produire',
  'production.mrp.empty': 'Aucun composant à acheter requis',
  'production.mrp.onHand': 'En stock',
  'production.mrp.shortage': 'Manquant',
  'common.status': 'Statut',
  'common.active': 'Actif',
  'common.inactive': 'Inactif',
  'common.select': 'Sélectionner…',
  'common.error': 'Une erreur est survenue',
  'production.dashboard.title': 'Aperçu de la production',
  'production.dashboard.subtitle': 'Ordres, capacité et production en un coup d’œil',
  'production.metric.active': 'Ordres actifs',
  'production.metric.draft': 'Brouillons',
  'production.metric.completed': 'Ordres terminés',
  'production.metric.completedValue': 'Valeur terminée',
  'production.centers.title': 'Postes de travail',
  'production.centers.subtitle': 'Où la production a lieu - base du coût de main-d’œuvre',
  'production.centers.new': 'Nouveau poste de travail',
  'production.centers.empty': 'Aucun poste de travail',
  'production.centers.code': 'Code',
  'production.centers.name': 'Nom',
  'production.centers.description': 'Description',
  'production.centers.hourlyRate': 'Taux horaire',
  'production.centers.capacity': 'Capacité / jour',
  'production.boms.title': 'Nomenclatures',
  'production.boms.subtitle': 'Composition de chaque produit fini',
  'production.boms.new': 'Nouvelle nomenclature',
  'production.boms.empty': 'Aucune nomenclature',
  'production.boms.code': 'Code',
  'production.boms.name': 'Nom',
  'production.boms.product': 'Produit',
  'production.boms.outputQuantity': 'Quantité produite',
  'production.boms.components': 'Composants',
  'production.boms.explode': 'Décomposer',
  'production.boms.explodeTitle': 'Décomposition de nomenclature',
  'production.boms.structure': 'Structure multi-niveaux',
  'production.boms.requirements': 'Besoins totaux (matières)',
  'production.boms.component': 'Composant',
  'production.boms.quantity': 'Quantité',
  'production.boms.material': 'Matière',
  'production.boms.totalQty': 'Qté totale',
  'production.boms.addComponent': 'Ajouter un composant',
  'production.orders.title': 'Ordres de fabrication',
  'production.orders.subtitle': 'Fabriquer des produits finis - consomme les composants, reçoit la production',
  'production.orders.new': 'Nouvel ordre de fabrication',
  'production.orders.empty': 'Aucun ordre de fabrication',
  'production.orders.number': 'Numéro',
  'production.orders.bom': 'Nomenclature',
  'production.orders.quantity': 'Quantité',
  'production.orders.warehouse': 'Entrepôt',
  'production.orders.workCenter': 'Poste de travail',
  'production.orders.laborHours': 'Heures de travail',
  'production.orders.materialPreview': 'Besoins en matières (MRP)',
  'production.orders.required': 'Requis',
  'production.orders.totalCost': 'Coût total',
  'production.orders.unitCost': 'Coût unitaire',
  'production.orders.materialCost': 'Coût matières',
  'production.orders.laborCost': 'Coût main-d’œuvre',
  'production.orders.componentsTitle': 'Composants',
  'production.orders.noComponents': 'Cet ordre n’a aucun composant',
  'production.orders.consumed': 'Consommé',
  'production.orders.release': 'Lancer',
  'production.orders.start': 'Démarrer',
  'production.orders.complete': 'Terminer',

  // Confirmation de production (partielle)
  'pc2.title': 'Confirmation',
  'pc2.action.button': 'Confirmer qté',
  'pc2.action.confirm': 'Confirmer',
  'pc2.confirmed': 'Confirmé',
  'pc2.remaining': 'Restant',
  'pc2.quantity': 'Quantité',
  'pc2.scrap': 'Rebut',
  'pc2.labor': 'Heures',
  'pc2.history': 'Confirmations précédentes',
  'pc2.col.number': 'N°',
  'pc2.col.time': 'Heure',
  'pc2.error.qty': 'Quantité requise.',
  'pc2.error.over': 'Dépasse la quantité restante ({remaining}).',
  'production.orders.cancel': 'Annuler',
  'production.orders.completedToast': 'Ordre terminé - stock mis à jour',
  'production.status.DRAFT': 'Brouillon',
  'production.status.RELEASED': 'Lancé',
  'production.status.IN_PROGRESS': 'En cours',
  'production.status.COMPLETED': 'Terminé',
  'production.status.CANCELLED': 'Annulé',
  'common.none': '-',
  'projects.dashboard.title': 'Aperçu des projets',
  'projects.dashboard.subtitle': 'Statut, budget et tâches en un coup d’œil',
  'projects.metric.active': 'Projets actifs',
  'projects.metric.budget': 'Budget total',
  'projects.metric.actual': 'Réel total',
  'projects.metric.openTasks': 'Tâches ouvertes',
  'projects.chart.budget': 'Budget vs. Réel',
  'projects.chart.budgetSub': 'Par projet actif',
  'projects.chart.budgetPlanned': 'Budget',
  'projects.chart.budgetActual': 'Réel',
  'projects.chart.status': 'Projets par statut',
  'projects.chart.tasks': 'Tâches par statut',
  'projects.chart.taskCount': 'Nombre de tâches',
  'projects.list.title': 'Projets',
  'projects.list.subtitle': 'Tous les projets en cartes',
  'projects.list.new': 'Nouveau projet',
  'projects.list.empty': 'Aucun projet',
  'projects.create.title': 'Nouveau projet',
  'projects.create.name': 'Nom du projet',
  'projects.create.customer': 'Client',
  'projects.create.owner': 'Responsable',
  'projects.create.start': 'Date de début',
  'projects.create.end': 'Date de fin',
  'projects.create.budget': 'Budget',
  'projects.detail.owner': 'Responsable',
  'projects.detail.spent': 'Dépensé',
  'projects.detail.tasksDone': 'Tâches terminées',
  'projects.detail.nextMilestone': 'Prochain jalon',
  'projects.detail.board': 'Tableau des tâches',
  'projects.detail.milestones': 'Jalons',
  'projects.detail.notFound': 'Projet introuvable',
  'projects.detail.noTasks': 'Aucune tâche',
  'projects.detail.noMilestones': 'Aucun jalon',
  'projects.status.PLANNED': 'Planifié',
  'projects.status.ACTIVE': 'Actif',
  'projects.status.PAUSED': 'En pause',
  'projects.status.COMPLETED': 'Terminé',
  'projects.status.CANCELLED': 'Annulé',
  'task.status.TODO': 'À faire',
  'task.status.IN_PROGRESS': 'En cours',
  'task.status.REVIEW': 'Revue',
  'task.status.DONE': 'Terminé',
  'task.priority.LOW': 'Basse',
  'task.priority.MEDIUM': 'Moyenne',
  'task.priority.HIGH': 'Haute',

  // Time tracking
  'nav.projectsTime': 'Temps de projet',
  'nav.projectsExpenses': 'Frais',
  'expense.title': 'Frais & déplacements',
  'expense.subtitle': 'Saisir, approuver et facturer les justificatifs',
  'expense.action.new': 'Ajouter un frais',
  'expense.action.approve': 'Approuver',
  'expense.action.reject': 'Rejeter',
  'expense.action.reimburse': 'Remboursé',
  'expense.action.delete': 'Supprimer',
  'expense.empty': 'Aucun frais saisi',
  'expense.metric.total': 'Montant total',
  'expense.metric.billable': 'Facturable',
  'expense.metric.open': 'Ouvert',
  'expense.metric.count': 'Justificatifs',
  'expense.col.date': 'Date',
  'expense.col.employee': 'Employé',
  'expense.col.category': 'Catégorie',
  'expense.col.amount': 'Montant',
  'expense.col.billable': 'Facturable',
  'expense.col.receipt': 'Justificatif',
  'expense.receiptLink': 'Ouvrir',
  'expense.status.OPEN': 'Ouvert',
  'expense.status.APPROVED': 'Approuvé',
  'expense.status.REJECTED': 'Rejeté',
  'expense.status.REIMBURSED': 'Remboursé',
  'expense.modal.title': 'Ajouter un frais',
  'expense.field.date': 'Date',
  'expense.field.category': 'Catégorie',
  'expense.field.amount': 'Montant',
  'expense.field.employee': 'Employé',
  'expense.field.project': 'Projet (optionnel)',
  'expense.field.description': 'Description',
  'expense.field.receipt': 'Lien du justificatif',
  'expense.field.billable': 'Facturable',
  'expense.category.TRAVEL': 'Voyage',
  'expense.category.MEALS': 'Repas',
  'expense.category.ACCOMMODATION': 'Hébergement',
  'expense.category.TRANSPORT': 'Transport',
  'expense.category.SUPPLIES': 'Fournitures',
  'expense.category.OTHER': 'Autre',
  'time.title': 'Temps de projet',
  'time.subtitle': 'Enregistrer le temps de travail sur les projets et tâches',
  'time.action.new': 'Saisir le temps',
  'time.action.approve': 'Approuver',
  'time.action.delete': 'Supprimer',
  'time.empty': 'Aucune saisie de temps',
  'time.metric.total': 'Heures totales',
  'time.metric.billable': 'Facturable',
  'time.metric.open': 'Ouvert',
  'time.metric.projects': 'Projets',
  'time.col.date': 'Date',
  'time.col.employee': 'Employé',
  'time.col.hours': 'Heures',
  'time.col.billable': 'Facturable',
  'time.yes': 'Oui',
  'time.no': 'Non',
  'time.status.OPEN': 'Ouvert',
  'time.status.APPROVED': 'Approuvé',
  'time.status.REJECTED': 'Rejeté',
  'time.modal.title': 'Saisir le temps',
  'time.field.project': 'Projet',
  'time.field.task': 'Tâche (optionnel)',
  'time.field.employee': 'Employé',
  'time.field.date': 'Date',
  'time.field.hours': 'Heures',
  'time.field.hoursHint': 'p. ex. 1.5',
  'time.field.start': 'De',
  'time.field.end': 'À',
  'time.field.rate': 'Taux horaire',
  'time.field.billable': 'Facturable',
  'time.field.description': 'Description',

  // RBAC
  'roles.admin':           'Administrateur',
  'roles.accountant':      'Comptabilité',
  'roles.hr':              'Ressources humaines',
  'roles.purchaser':       'Achats/Entrepôt',
  'roles.sales':           'Ventes',
  'roles.project_manager': 'Chef de projet',
  'roles.executive':       'Direction',
  'access.denied':         "Vous n'avez pas l'autorisation pour cette action",
  'access.denied.title':   'Accès refusé',
  'access.denied.body':    "Vous n'avez pas l'autorisation pour cette zone. Contactez un administrateur.",
  'settings.users.title':      'Utilisateurs & rôles',
  'settings.users.intro':      "Attribuez des rôles métier aux utilisateurs. Les droits sont l'union de tous les rôles.",
  'settings.users.activate':   'Activer',
  'settings.users.deactivate': 'Désactiver',
  'settings.users.active':     'Actif',
  'settings.users.inactive':   'Inactif',
  'settings.users.count':      '{count} utilisateurs',
  'settings.users.search':     'Rechercher des utilisateurs…',
  'settings.users.noRoles':    'Aucun rôle',
  'settings.users.editRoles':  'Rôles',
  'settings.users.empty':      'Aucun utilisateur trouvé.',
  'settings.users.allRoles':   'Tous les rôles',
  'settings.users.countFiltered': '{shown} sur {total}',
  'settings.users.new': 'Nouvel utilisateur',
  'settings.users.create.title': 'Créer un utilisateur',
  'settings.users.firstName': 'Prénom',
  'settings.users.lastName': 'Nom',
  'settings.users.email': 'E-mail',
  'settings.users.password': 'Mot de passe',
  'settings.users.passwordHint': 'Au moins 10 caractères, majuscule/minuscule et un chiffre.',
  'settings.users.roles': 'Rôles',

  // Évaluations de performance
  'nav.reviews': 'Évaluations',
  'rev.title': 'Évaluations de performance',
  'rev.subtitle': 'Évaluer la performance par période - avec objectifs et note globale.',
  'rev.empty': 'Aucune évaluation.',
  'rev.col.number': 'N°',
  'rev.col.employee': 'Employé',
  'rev.col.period': 'Période',
  'rev.col.rating': 'Note',
  'rev.status.DRAFT': 'Brouillon',
  'rev.status.SUBMITTED': 'Soumise',
  'rev.status.ACKNOWLEDGED': 'Confirmée',
  'rev.action.new': 'Nouvelle évaluation',
  'rev.action.view': 'Ouvrir',
  'rev.action.submit': 'Soumettre',
  'rev.action.acknowledge': 'Confirmer',
  'rev.metric.total': 'Évaluations',
  'rev.metric.draft': 'Brouillons',
  'rev.metric.acknowledged': 'Confirmées',
  'rev.field.employee': 'Employé',
  'rev.field.period': 'Période',
  'rev.field.rating': 'Note globale',
  'rev.field.strengths': 'Points forts',
  'rev.field.improvements': 'Axes de progrès',
  'rev.field.goals': 'Objectifs',
  'rev.field.goalTitle': 'Objectif',
  'rev.field.addGoal': '+ Objectif',
  'rev.modal.title': 'Nouvelle évaluation',
  'rev.detail.title': 'Évaluation',
  'rev.error.required': 'Employé et période requis.',

  // Saisie des temps
  'nav.time': 'Temps de travail',
  'nav.travel': 'Frais de déplacement',

  // Notes de frais de déplacement
  'tr.title': 'Frais de déplacement',
  'tr.subtitle': 'Saisir, soumettre, approuver et rembourser les frais de déplacement.',
  'tr.empty': 'Aucune note.',
  'tr.col.number': 'N°',
  'tr.col.employee': 'Employé',
  'tr.col.purpose': 'Objet',
  'tr.col.period': 'Période',
  'tr.col.total': 'Total',
  'tr.col.category': 'Catégorie',
  'tr.status.DRAFT': 'Brouillon',
  'tr.status.SUBMITTED': 'Soumise',
  'tr.status.APPROVED': 'Approuvée',
  'tr.status.REJECTED': 'Rejetée',
  'tr.status.REIMBURSED': 'Remboursée',
  'tr.action.new': 'Nouvelle note',
  'tr.action.view': 'Ouvrir',
  'tr.action.submit': 'Soumettre',
  'tr.action.approve': 'Approuver',
  'tr.action.reject': 'Rejeter',
  'tr.action.reimburse': 'Rembourser',
  'tr.metric.submitted': 'Soumises',
  'tr.metric.approved': 'Approuvées',
  'tr.metric.reimbursed': 'Remboursées',
  'tr.field.employee': 'Employé',
  'tr.field.from': 'Du',
  'tr.field.to': 'Au',
  'tr.field.purpose': 'Objet du déplacement',
  'tr.field.items': 'Postes',
  'tr.field.description': 'Description',
  'tr.field.amount': 'Montant',
  'tr.field.addItem': '+ Poste',
  'tr.cat.MEALS': 'Repas',
  'tr.cat.LODGING': 'Hébergement',
  'tr.cat.TRANSPORT': 'Transport',
  'tr.cat.MILEAGE': 'Indemnité km',
  'tr.cat.OTHER': 'Autre',
  'tr.modal.title': 'Nouvelle note de frais',
  'tr.detail.title': 'Note de frais de déplacement',
  'tr.error.required': 'Employé et objet du déplacement requis.',
  'hrtime.title': 'Temps de travail des collaborateurs',
  'hrtime.subtitle': 'Saisir le temps de travail par employé et l’analyser par période.',
  'hrtime.empty': 'Aucune saisie.',
  'hrtime.col.date': 'Date',
  'hrtime.col.employee': 'Employé',
  'hrtime.col.type': 'Type',
  'hrtime.col.hours': 'Heures',
  'hrtime.col.note': 'Note',
  'hrtime.type.REGULAR': 'Normal',
  'hrtime.type.OVERTIME': 'Heures sup.',
  'hrtime.type.SICK': 'Maladie',
  'hrtime.type.HOLIDAY': 'Férié',
  'hrtime.type.TRAINING': 'Formation',
  'hrtime.action.add': 'Saisir',
  'hrtime.action.delete': 'Supprimer',
  'hrtime.field.employee': 'Employé',
  'hrtime.field.date': 'Date',
  'hrtime.field.hours': 'Heures',
  'hrtime.field.type': 'Type',
  'hrtime.field.note': 'Note',
  'hrtime.field.from': 'Du',
  'hrtime.field.to': 'Au',
  'hrtime.filter.employee': 'Employé',
  'hrtime.filter.all': 'Tous les employés',
  'hrtime.metric.total': 'Total',
  'hrtime.error.required': 'Employé, date et heures requis.',

  'settings.nav.ebics':        'Connexion bancaire EBICS',
  'ebics.intro':               'Récupération automatique des relevés bancaires (camt.053) via le protocole bancaire EBICS.',
  'ebics.experimental':        "Expérimental - nécessite un contrat EBICS actif avec votre banque et une activation manuelle (lettre INI). La génération des clés et la lettre INI fonctionnent localement ; l'envoi à la banque et le téléchargement des relevés ne fonctionnent qu'après l'activation de l'abonné par la banque.",
  'ebics.statusLabel':         'Statut :',
  'ebics.status.NEW':          'Nouveau',
  'ebics.status.INI_SENT':     'INI envoyé',
  'ebics.status.HIA_SENT':     'HIA envoyé',
  'ebics.status.READY':        'Prêt',
  'ebics.status.ERROR':        'Erreur',
  'ebics.masterKeyMissing':    "EBICS_MASTER_KEY n'est pas configuré. Définissez une clé de 32 octets (64 caractères hex) comme variable d'environnement avant de générer les clés.",
  'ebics.bankName':            'Nom de la banque',
  'ebics.hostId':              'Host ID',
  'ebics.partnerId':           'Partner ID (ID client)',
  'ebics.userId':              "User ID (ID d'abonné)",
  'ebics.version':             'Version EBICS',
  'ebics.url':                 'URL EBICS',
  'ebics.accountIban':         'IBAN du compte',
  'ebics.saved':               'Paramètres de connexion enregistrés.',
  'ebics.workflow':            "Procédure d'installation",
  'ebics.workflow.intro':      "Ordre : enregistrer les paramètres → générer les clés → imprimer, signer et envoyer la lettre INI à la banque → envoyer INI & HIA → attendre l'activation par la banque → récupérer les clés bancaires (HPB) → télécharger les relevés.",
  'ebics.btn.initKeys':        'Générer les clés',
  'ebics.btn.letter':          'Télécharger la lettre INI',
  'ebics.btn.ini':             'Envoyer INI',
  'ebics.btn.hia':             'Envoyer HIA',
  'ebics.btn.hpb':             'Récupérer les clés bancaires (HPB)',
  'ebics.btn.download':        'Télécharger le relevé',
  'ebics.letterHint':          'Clés générées. Téléchargez la lettre INI (bouton ci-dessus) pour obtenir les empreintes des clés.',
  'ebics.download.title':      'Télécharger le relevé (camt.053)',
  'ebics.download.from':       'Du',
  'ebics.download.to':         'Au',
  'ebics.download.imported':   '{n} écritures importées.',
  'ebics.download.goToBank':   'Vers le rapprochement',
  'ebics.letter.heading':      "Lettre d'initialisation EBICS (INI)",
  'ebics.letter.date':         'Date',
  'ebics.letter.a006':         'Signature électronique (A006)',
  'ebics.letter.x002':         'Authentification (X002)',
  'ebics.letter.e002':         'Chiffrement (E002)',
  'ebics.letter.note':         "Veuillez vérifier les empreintes des clés publiques ci-dessous et activer l'abonné. Signé par :",
  'ebics.letter.signature':    'Date, lieu, signature',

  // Credit notes / refunds
  'creditNote.title': 'Avoirs',
  'creditNote.subtitle': 'Avoirs sur factures comptabilisées - vente et achat.',
  'creditNote.empty': 'Aucun avoir.',
  'creditNote.credited': 'Crédité',
  'creditNote.col.type': 'Type',
  'creditNote.type.SALES': 'Client',
  'creditNote.type.PURCHASE': 'Fournisseur',
  'creditNote.typeFilter.all': 'Tous les types',
  'creditNote.create.title': 'Créer un avoir',
  'creditNote.create.intro': 'Choisissez les postes et la quantité à créditer.',
  'creditNote.create.creditQty': 'Quantité à créditer',
  'creditNote.create.submit': 'Créer l’avoir',
  'creditNote.create.pickLine': 'Choisissez au moins un poste avec une quantité > 0.',
  'creditNote.print.heading': 'Avoir',
  'creditNote.print.forInvoice': 'Pour la facture',
  'creditNote.print.total': 'Total de l’avoir',
  'creditNote.print.headingVendor': 'Avoir fournisseur',
  'invoice.refund.action': 'Verser le remboursement',
  'invoice.refund.amount': 'Montant du remboursement',
  'invoice.refund.balance': 'Solde créditeur / remboursement dû',
  'invoice.refund.receiveAction': 'Saisir le remboursement',
  'invoice.refund.receiveBalance': 'Avoir chez le fournisseur',

  // Multi-currency
  'currency.col.code': 'Code',
  'currency.col.name': 'Nom',
  'currency.col.active': 'Active',
  'currency.add': 'Ajouter une devise',
  'currency.baseNote': 'Le CHF est la monnaie de base.',
  'currency.rates.title': 'Cours de change',
  'currency.rates.intro': 'Cours = CHF pour 1 unité de devise étrangère.',
  'currency.rates.date': 'Date',
  'currency.rates.rate': 'Cours',
  'currency.rates.source': 'Source',
  'currency.rates.add': 'Saisir un cours',
  'currency.rates.fetch': 'Récupérer les cours (BCE)',
  'currency.rates.fetched': '{count} cours mis à jour.',
  'currency.rates.fetchFailed': 'Échec de la récupération : {reason}',
  'invoice.fx.currency': 'Devise',
  'invoice.fx.rate': 'Cours',
  'invoice.fx.chfEquivalent': 'Contre-valeur CHF',
  'invoice.fx.paymentRate': 'Cours de paiement',
  'invoice.fx.refundRate': 'Cours de remboursement',
  'invoice.fx.bankAmount': 'Banque (CHF)',
  'invoice.fx.diff': 'Différence de change',
  'invoice.fx.noRate': 'Aucun cours enregistré pour {currency} - à gérer dans les paramètres.',

  // Factures récurrentes (abonnements)
  'recurring.title': 'Factures récurrentes',
  'recurring.subtitle': 'Modèles qui génèrent automatiquement les factures dues - vérifiés toutes les heures.',
  'recurring.col.name': 'Nom',
  'recurring.col.customer': 'Client',
  'recurring.col.interval': 'Intervalle',
  'recurring.col.nextRun': 'Prochaine facture',
  'recurring.col.amount': 'Montant',
  'recurring.interval.MONTHLY': 'Mensuel',
  'recurring.interval.QUARTERLY': 'Trimestriel',
  'recurring.interval.YEARLY': 'Annuel',
  'recurring.active': 'Actif',
  'recurring.paused': 'En pause',
  'recurring.action.new': 'Nouvel abonnement',
  'recurring.action.generate': 'Générer maintenant',
  'recurring.action.pause': 'Mettre en pause',
  'recurring.action.resume': 'Reprendre',
  'recurring.action.edit': 'Modifier',
  'recurring.action.delete': 'Supprimer',
  'recurring.generated': 'Facture générée :',
  'recurring.insight.byInterval': 'Par intervalle',
  'recurring.insight.active': 'Abonnements actifs',
  'recurring.insight.monthly': 'Volume mensuel',
  'recurring.insight.due30': 'À échéance sous 30 jours',
  'recurring.form.startDate': 'Début',
  'recurring.form.endDate': 'Fin (optionnelle)',
  'recurring.form.dueDays': 'Délai de paiement (jours)',
  'recurring.form.autoPost': 'Comptabiliser automatiquement',
  'recurring.form.invalid': 'Nom, client et au moins une ligne valide sont requis.',
  'recurring.modal.editTitle': 'Modifier l’abonnement',
  'recurring.confirmDelete': 'Vraiment supprimer cet abonnement ?',
  'recurring.empty': 'Aucun abonnement pour le moment.',
  'recurring.runs.title': 'Factures générées',
  'recurring.runs.empty': 'Aucune facture générée pour le moment.',
  'recurring.toggleRuns': 'Afficher les factures générées',

  // Command palette (Ctrl+K)
  'palette.placeholder': 'Rechercher ou aller à…',
  'palette.pages': 'Pages',
  'palette.customers': 'Clients',
  'palette.products': 'Produits',
  'palette.invoices': 'Factures',
  'palette.projects': 'Projets',
  'palette.orders': 'Commandes',
  'palette.quotes': 'Devis',
  'palette.tickets': 'Tickets',
  'palette.equipment': 'Équipements',
  'palette.suppliers': 'Fournisseurs',
  'palette.employees': 'Collaborateurs',
  'palette.purchaseOrders': 'Commandes d’achat',
  'palette.noResults': 'Aucun résultat',
  'palette.hint': 'Saisissez pour rechercher clients, factures, produits et projets',
  'palette.open': 'Ouvrir la recherche',

  // Audit log (Paramètres → Journal d'audit)
  'settings.nav.audit': "Journal d'audit",
  'audit.intro': "Qui a modifié quoi et quand - chaque action d'écriture avec son utilisateur.",
  'audit.col.time': 'Heure',
  'audit.col.user': 'Utilisateur',
  'audit.col.module': 'Module',
  'audit.col.action': 'Action',
  'audit.col.entity': 'Objet',
  'audit.col.status': 'Statut',
  'audit.filter.allModules': 'Tous les modules',
  'audit.filter.allActions': 'Toutes les actions',
  'audit.filter.from': 'Du',
  'audit.filter.to': 'Au',
  'audit.toggleDetails': 'Afficher les détails',
  'audit.module.auth': 'Authentification',
  'audit.module.admin': 'Administration',
  'audit.action.create': 'Créé',
  'audit.action.update': 'Modifié',
  'audit.action.delete': 'Supprimé',
  'audit.action.login': 'Connexion',
  'audit.action.login_failed': 'Connexion échouée',
  'audit.action.logout': 'Déconnexion',
  'audit.action.register': 'Inscription',
  'audit.empty': 'Aucune entrée pour le moment.',
  'audit.pagination.of': 'sur',
  'audit.prev': 'Précédent',
  'audit.next': 'Suivant',

  // Notifications (bell)
  'notif.title': 'Notifications',
  'notif.bell': 'Ouvrir les notifications',
  'notif.markAll': 'Tout marquer lu',
  'notif.empty': 'Aucune notification.',
  'notif.stock_low': 'Stock bas : {sku} ({quantity} / seuil {reorderPoint})',
  'notif.po_approval_requested': 'La commande {poNumber} de {totalAmount} attend une approbation',
  'notif.po_approved': 'La commande {poNumber} a été approuvée',
  'notif.po_rejected': 'La commande {poNumber} a été rejetée',
  'notif.leave_requested': 'Demande de congé de {employeeName} : {days} jours à partir du {startDate}',
  'notif.leave_approved': 'La demande de congé de {employeeName} a été approuvée',
  'notif.leave_rejected': 'La demande de congé de {employeeName} a été rejetée',
  'notif.expense_requested': 'Nouvelle note de frais de {employeeName} : {amount}',
  'notif.expense_approved': 'La note de frais de {employeeName} ({amount}) a été approuvée',
  'notif.expense_rejected': 'La note de frais de {employeeName} ({amount}) a été rejetée',
  'notif.expense_reimbursed': 'La note de frais de {employeeName} ({amount}) a été remboursée',
  'notif.demo_requested': 'Nouvelle demande de démo de {name} ({company})',

  // Listes de prix & paliers de quantité
  'nav.priceLists': 'Listes de prix',
  'priceList.title': 'Listes de prix',
  'priceList.subtitle': 'Prix spécifiques aux clients avec paliers de quantité - appliqués automatiquement dans les offres et les commandes.',
  'priceList.col.products': 'Produits',
  'priceList.col.tiers': 'Lignes de palier',
  'priceList.col.customers': 'Clients',
  'priceList.action.new': 'Nouvelle liste de prix',
  'priceList.action.edit': 'Modifier',
  'priceList.action.activate': 'Activer',
  'priceList.action.deactivate': 'Désactiver',
  'priceList.action.delete': 'Supprimer',
  'priceList.confirmDelete': 'Supprimer cette liste de prix ? {count} client(s) reviendront au prix catalogue.',
  'priceList.empty': 'Aucune liste de prix pour le moment.',
  'priceList.modal.editTitle': 'Modifier la liste de prix',
  'priceList.items': 'Prix par paliers',
  'priceList.form.active': 'Active',
  'priceList.form.product': 'Produit',
  'priceList.form.minQuantity': 'Quantité minimale',
  'priceList.form.unitPrice': 'Prix unitaire',
  'priceList.form.invalid': 'Le nom est requis.',
  'priceList.tierHint': 'Plusieurs lignes par produit = paliers de quantité (à partir de la quantité minimale).',
  'priceList.applied': 'Liste de prix {name} · à partir de {minQuantity}',
  'priceList.duplicateTier': 'Palier en double : même produit avec la même quantité minimale.',
  'priceList.assign': 'Liste de prix',
  'priceList.none': 'Aucune (prix catalogue)',
  'customer.priceListSaved': 'Liste de prix enregistrée.',

  // Immobilisations
  'nav.fixedAssets': 'Immobilisations',
  'nav.maintenance': 'Maintenance',

  // Maintenance (PM)
  'pm.title': 'Maintenance',
  'pm.subtitle': 'Équipements et ordres de maintenance avec coûts et statut.',
  'pm.section.orders': 'Ordres de maintenance',
  'pm.section.equipment': 'Équipements',
  'pm.col.number': 'Ordre',
  'pm.col.equipment': 'Équipement',
  'pm.col.title': 'Titre',
  'pm.col.priority': 'Priorité',
  'pm.col.cost': 'Coût',
  'pm.status.OPEN': 'Ouvert',
  'pm.status.IN_PROGRESS': 'En cours',
  'pm.status.COMPLETED': 'Terminé',
  'pm.status.CANCELLED': 'Annulé',
  'pm.priority.LOW': 'Basse',
  'pm.priority.MEDIUM': 'Moyenne',
  'pm.priority.HIGH': 'Haute',
  'pm.priority.URGENT': 'Urgente',
  'pm.action.view': 'Ouvrir',
  'pm.action.newEquipment': 'Nouvel équipement',
  'pm.action.newOrder': 'Nouvel ordre',
  'pm.action.start': 'Démarrer',
  'pm.action.complete': 'Terminer',
  'pm.action.cancel': 'Annuler',
  'pm.metric.openOrders': 'Ordres ouverts',
  'pm.metric.down': 'En panne',
  'pm.metric.equipment': 'Équipements',
  'pm.orders.empty': 'Aucun ordre.',
  'pm.eq.number': 'N°',
  'pm.eq.name': 'Désignation',
  'pm.eq.location': 'Emplacement',
  'pm.eq.asset': 'Immobilisation',
  'pm.eq.noAsset': '- aucune -',
  'pm.eq.notes': 'Notes',
  'pm.eq.empty': 'Aucun équipement.',
  'pm.eq.markDown': 'Mettre en panne',
  'pm.eq.markUp': 'Remettre en service',
  'pm.eqStatus.OPERATIONAL': 'Opérationnel',
  'pm.eqStatus.DOWN': 'En panne',
  'pm.eqStatus.RETIRED': 'Retiré',
  'pm.eqModal.title': 'Nouvel équipement',
  'pm.orderModal.title': 'Nouvel ordre de maintenance',
  'pm.detail.title': 'Ordre de maintenance',
  'pm.field.description': 'Description',
  'pm.field.plannedDate': 'Date prévue',
  'pm.costs': 'Coûts',
  'pm.materialCost': 'Coût matériel',
  'pm.laborCost': 'Coût main-d’œuvre',
  'pm.error.name': 'Désignation requise.',
  'pm.error.order': 'Équipement et titre requis.',
  'pm.action.newPlan': 'Nouveau plan',
  'pm.action.generateDue': 'Générer les échus',
  'pm.section.plans': 'Plans de maintenance',
  'pm.plan.number': 'Plan',
  'pm.plan.interval': 'Intervalle',
  'pm.plan.days': 'jours',
  'pm.plan.nextDue': 'Prochaine échéance',
  'pm.plan.active': 'Actif',
  'pm.plan.on': 'Actif',
  'pm.plan.off': 'Inactif',
  'pm.plan.empty': 'Aucun plan de maintenance.',
  'pm.plan.generated': '{n} ordre(s) généré(s).',
  'pm.planModal.title': 'Nouveau plan de maintenance',
  'pm.error.plan': 'Équipement, titre, intervalle et échéance requis.',
  'fa.title': 'Immobilisations',
  'fa.subtitle': 'Registre des immobilisations, amortissement planifié et sorties.',
  'fa.action.new': 'Nouvelle immobilisation',
  'fa.action.dispose': 'Sortie',
  'fa.empty': 'Aucune immobilisation pour l’instant.',
  'fa.col.number': 'N°',
  'fa.col.name': 'Désignation',
  'fa.col.category': 'Catégorie',
  'fa.col.cost': 'Acquisition',
  'fa.col.accumulated': 'Amort. cumulé',
  'fa.col.nbv': 'Valeur comptable',
  'fa.status.ACTIVE': 'Active',
  'fa.status.FULLY_DEPRECIATED': 'Amortie',
  'fa.status.DISPOSED': 'Sortie',
  'fa.metric.active': 'Immobilisations actives',
  'fa.metric.cost': 'Valeur d’acquisition',
  'fa.metric.accumulated': 'Amort. cumulé',
  'fa.metric.nbv': 'Valeur comptable',
  'fa.run.period': 'Période',
  'fa.run.action': 'Cycle d’amortissement',
  'fa.run.done': '{count} immobilisation(s) amortie(s), total {total}.',
  'fa.modal.title': 'Nouvelle immobilisation',
  'fa.field.name': 'Désignation',
  'fa.field.category': 'Catégorie',
  'fa.field.acquisitionDate': 'Date d’acquisition',
  'fa.field.cost': 'Coût d’acquisition',
  'fa.field.salvage': 'Valeur résiduelle',
  'fa.field.usefulLife': 'Durée d’utilité (mois)',
  'fa.field.method': 'Méthode',
  'fa.field.decliningRate': 'Taux (% p.a.)',
  'fa.field.assetAccount': 'Compte d’immobilisation',
  'fa.field.expenseAccount': 'Compte charge d’amortissement',
  'fa.field.accumulatedAccount': 'Compte amort. cumulé',
  'fa.field.fundingAccount': 'Compte de financement (écriture d’acquisition)',
  'fa.field.fundingNone': '- aucune écriture -',
  'fa.method.LINEAR': 'Linéaire',
  'fa.method.DECLINING_BALANCE': 'Dégressif',
  'fa.preview.firstPeriod': 'Première mensualité : {amount}',
  'fa.dispose.title': 'Sortie : {name}',
  'fa.dispose.confirm': 'Comptabiliser la sortie',
  'fa.dispose.date': 'Date de sortie',
  'fa.dispose.proceeds': 'Produit de cession',
  'fa.dispose.nbv': 'Valeur comptable {amount}',
  'fa.dispose.gain': 'Gain {amount}',
  'fa.dispose.loss': 'Perte {amount}',

  // Clôture de période / d’exercice
  'nav.periodClose': 'Clôture de période',
  'period.title': 'Clôture de période et d’exercice',
  'period.subtitle': 'Les périodes closes bloquent toute écriture ; la clôture annuelle solde le compte de résultat.',
  'period.year': 'Année',
  'period.empty': 'Aucune période.',
  'period.col.period': 'Période',
  'period.col.status': 'Statut',
  'period.status.open': 'Ouverte',
  'period.status.closed': 'Close',
  'period.action.close': 'Clôturer',
  'period.action.reopen': 'Rouvrir',
  'period.yearClosed': 'Exercice clôturé',
  'period.yearEnd.action': 'Clôture annuelle',
  'period.yearEnd.confirm': 'Clôturer l’exercice {year} ? Le compte de résultat est viré au bénéfice reporté et tous les mois sont verrouillés.',
  'period.yearEnd.done': 'Clôture annuelle comptabilisée. Résultat net : {net}.',
  'period.metric.year': 'Exercice',
  'period.metric.closed': 'Mois clôturés',
  'period.metric.state': 'Statut de l’exercice',

  // TVA étendue (taux de la dette fiscale nette, impôt sur les acquisitions, eCH-0217)
  'settings.vat.title': 'Taxe sur la valeur ajoutée',
  'settings.vat.method': 'Méthode de décompte',
  'settings.vat.effective': 'Effective',
  'settings.vat.saldo': 'Taux de la dette fiscale nette',
  'settings.vat.saldoRate1': 'Taux net 1 (%)',
  'settings.vat.saldoRate2': 'Taux net 2 (%)',
  'invoice.reverseCharge': 'Impôt sur les acquisitions (prestations de l’étranger)',
  'vat.ech0217': 'XML eCH-0217',
  'vat.method.EFFECTIVE': 'Méthode effective',
  'vat.method.NET_TAX_RATE': 'Méthode des taux nets',
  'vat.row.saldo': 'Taux de la dette fiscale nette',
  'vat.row.acquisitionTax': 'Impôt sur les acquisitions',

  // Inventaire tournant
  'common.close': 'Fermer',
  'nav.cycleCounts': 'Inventaire',
  'cyc.title': 'Inventaire tournant',
  'cyc.subtitle': 'Compter les stocks et comptabiliser les écarts en ajustements.',
  'cyc.empty': 'Aucun inventaire pour l’instant.',
  'cyc.col.date': 'Date',
  'cyc.col.warehouse': 'Entrepôt',
  'cyc.status.OPEN': 'Ouvert',
  'cyc.status.POSTED': 'Comptabilisé',
  'cyc.status.CANCELLED': 'Annulé',
  'cyc.action.new': 'Nouvel inventaire',
  'cyc.action.view': 'Voir',
  'cyc.action.post': 'Comptabiliser',
  'cyc.action.addLine': '+ Ligne',
  'cyc.metric.total': 'Inventaires',
  'cyc.metric.open': 'Ouverts',
  'cyc.metric.posted': 'Comptabilisés',
  'cyc.field.warehouse': 'Entrepôt',
  'cyc.field.date': 'Date de comptage',
  'cyc.field.product': 'Produit',
  'cyc.field.expected': 'Théorique',
  'cyc.field.counted': 'Compté',
  'cyc.field.variance': 'Écart',
  'cyc.modal.title': 'Nouvel inventaire',
  'cyc.detail.title': 'Inventaire',
  'cyc.detail.willAdjust': '{count} ajustement(s) à la comptabilisation.',
  'cyc.error.required': 'Entrepôt et au moins une ligne requis.',

  // Demandes d’achat (BANF)
  'nav.requisitions': 'Demandes d’achat',
  'req.title': 'Demandes d’achat',
  'req.subtitle': 'Exprimer un besoin, le faire approuver et le convertir en commandes.',
  'req.empty': 'Aucune demande d’achat pour l’instant.',
  'req.col.number': 'N°',
  'req.col.neededBy': 'Requis pour',
  'req.status.DRAFT': 'Brouillon',
  'req.status.SUBMITTED': 'Soumise',
  'req.status.APPROVED': 'Approuvée',
  'req.status.REJECTED': 'Rejetée',
  'req.status.CONVERTED': 'Convertie',
  'req.action.new': 'Nouvelle demande',
  'req.action.view': 'Voir',
  'req.action.submit': 'Soumettre',
  'req.action.approve': 'Approuver',
  'req.action.reject': 'Rejeter',
  'req.action.convert': 'Convertir en commande',
  'req.action.addLine': '+ Ligne',
  'req.metric.total': 'Demandes',
  'req.metric.submitted': 'Soumises',
  'req.metric.approved': 'Approuvées',
  'req.field.warehouse': 'Entrepôt',
  'req.field.neededBy': 'Requis pour',
  'req.field.justification': 'Justification',
  'req.field.product': 'Produit',
  'req.field.quantity': 'Quantité',
  'req.field.estCost': 'Coût estimé',
  'req.field.supplier': 'Fournisseur',
  'req.modal.title': 'Nouvelle demande d’achat',
  'req.detail.title': 'Demande d’achat',
  'req.detail.converted': 'Convertie en commande.',
  'req.error.lines': 'Au moins une ligne avec produit et quantité est requise.',
  'req.action.autoReorder': 'Réapprovisionnement auto',
  'req.autoReorder.done': '{products} produit(s) sous le seuil → {count} demande(s) créée(s).',
  'req.autoReorder.none': 'Aucun produit sous son seuil de réapprovisionnement.',

  // Réservations de stock
  'nav.reservations': 'Réservations',
  'res.title': 'Réservations de stock',
  'res.subtitle': 'Réserver du stock ; disponible = stock moins réservé.',
  'res.empty': 'Aucune réservation.',
  'res.col.date': 'Date',
  'res.col.product': 'Produit',
  'res.col.warehouse': 'Entrepôt',
  'res.col.quantity': 'Quantité',
  'res.status.OPEN': 'Ouverte',
  'res.status.RELEASED': 'Libérée',
  'res.action.new': 'Réserver',
  'res.action.release': 'Libérer',
  'res.metric.open': 'Réservations ouvertes',
  'res.metric.reserved': 'Quantité réservée',
  'res.metric.total': 'Total',
  'res.field.product': 'Produit',
  'res.field.warehouse': 'Entrepôt',
  'res.field.quantity': 'Quantité',
  'res.field.available': 'Disponible : {qty}',
  'res.modal.title': 'Réserver du stock',
  'res.error.required': 'Produit, entrepôt et quantité requis.',

  // Suivi par lot / numéro de série
  'inv.track.tracking': 'Traçabilité',
  'inv.track.NONE': 'Aucune',
  'inv.track.BATCH': 'Lots (avec date de péremption)',
  'inv.track.SERIAL': 'Numéros de série',
  'inv.track.batchNumber': 'Numéro de lot',
  'inv.track.expiryDate': 'Date de péremption',
  'inv.track.serialNumbers': 'Numéros de série',
  'inv.track.serialHint': 'Un numéro de série par ligne (nombre = quantité).',
  'nav.lots': 'Lots',
  'lot.title': 'Lots et traçabilité',
  'lot.subtitle': 'Tracer les lots par lot/péremption ; sorties en FEFO.',
  'lot.empty': 'Aucun lot trouvé.',
  'lot.col.product': 'Produit',
  'lot.col.batch': 'Lot/série',
  'lot.col.warehouse': 'Entrepôt',
  'lot.col.expiry': 'Péremption',
  'lot.col.remaining': 'Restant',
  'lot.action.expiring': 'Bientôt périmé',
  'lot.filter.batch': 'Rechercher un lot',
  'lot.filter.inStock': 'En stock seulement',
  'lot.metric.expiring': 'Périme (30 jours)',
  'lot.metric.expired': 'Périmé',

  // Emplacements (bins)
  'nav.bins': 'Emplacements',
  'nav.quality': 'Qualité',
  'nav.consignment': 'Consignation',
  'nav.purchaseContracts': 'Contrats-cadres',
  'nav.schedulingAgreements': 'Plans de livraison',
  'nav.serials': 'Numéros de série',
  'nav.vendorEvaluation': 'Évaluation fournisseurs',
  'nav.uom': 'Unités de mesure',
  'nav.backorders': 'Reliquats',
  'nav.mrpRun': 'Calcul des besoins',

  // Calcul des besoins (MRP)
  'mr.title': 'Calcul des besoins (MRP)',
  'mr.subtitle': 'Besoin net par produit (point de commande + reliquats − stock − en commande) → propositions d’achat → DA.',
  'mr.runs': 'Exécutions',
  'mr.noRuns': 'Aucune exécution. Lancez un calcul MRP.',
  'mr.proposals': 'Propositions d’achat',
  'mr.noProposals': 'Aucune proposition - tous les besoins couverts.',
  'mr.warehouse': 'Entrepôt cible (DA)',
  'mr.col.run': 'Exécution',
  'mr.col.date': 'Date',
  'mr.col.count': 'Propositions',
  'mr.col.product': 'Produit',
  'mr.col.onHand': 'En stock',
  'mr.col.onOrder': 'En commande',
  'mr.col.backordered': 'En reliquat',
  'mr.col.reorder': 'Point de commande',
  'mr.col.net': 'Besoin net',
  'mr.col.suggested': 'Proposé',
  'mr.status.OPEN': 'Ouvert',
  'mr.status.CONVERTED': 'Converti en DA',
  'mr.action.run': 'Lancer le MRP',
  'mr.action.convert': 'Convertir en DA',
  'mr.metric.proposals': 'Propositions',

  // Reliquats (backorders)
  'bo.title': 'Reliquats',
  'bo.subtitle': 'Quantités non livrables à la confirmation ; livrer dès que le stock est disponible.',
  'bo.empty': 'Aucun reliquat.',
  'bo.all': 'Tous',
  'bo.col.product': 'Produit',
  'bo.col.order': 'Commande',
  'bo.col.quantity': 'En reliquat',
  'bo.col.available': 'Disponible',
  'bo.col.date': 'Date',
  'bo.status.OPEN': 'Ouvert',
  'bo.status.FULFILLED': 'Livré',
  'bo.status.CANCELLED': 'Annulé',
  'bo.action.fulfill': 'Livrer',
  'bo.metric.open': 'Reliquats ouverts',
  'bo.metric.ready': 'Prêts à livrer',

  // Conversion d’unités de mesure
  'uom.title': 'Unités de mesure',
  'uom.subtitle': 'Unités alternatives par produit (p. ex. 1 carton = 12 pièces) + convertisseur.',
  'uom.empty': 'Aucune unité.',
  'uom.selectProduct': 'Choisir un produit…',
  'uom.base': 'Base',
  'uom.col.unit': 'Unité',
  'uom.col.factor': 'Facteur',
  'uom.add': 'Ajouter une unité alternative',
  'uom.factorLabel': 'Facteur (× {base})',
  'uom.action.add': 'Ajouter',
  'uom.converter': 'Convertisseur',
  'uom.quantity': 'Quantité',
  'uom.from': 'De',
  'uom.to': 'Vers',
  'uom.action.convert': 'Convertir',

  // Évaluation des fournisseurs (MM)
  've.title': 'Évaluation des fournisseurs',
  've.subtitle': 'Noter les fournisseurs sur le prix, la qualité, la livraison et le service ; note globale + classement.',
  've.empty': 'Aucune évaluation.',
  've.noRanking': 'Aucune évaluation pour le moment.',
  've.col.supplier': 'Fournisseur',
  've.col.avg': 'Note moy.',
  've.col.grade': 'Note',
  've.col.latest': 'Dernière',
  've.col.count': 'Nombre',
  've.col.date': 'Date',
  've.col.price': 'Prix',
  've.col.quality': 'Qualité',
  've.col.delivery': 'Livraison',
  've.col.service': 'Service',
  've.col.overall': 'Global',
  've.action.new': 'Nouvelle évaluation',
  've.ranking': 'Classement',
  've.evaluations': 'Évaluations',
  've.modal.title': 'Nouvelle évaluation fournisseur',
  've.field.notes': 'Note',
  've.error.required': 'Fournisseur requis.',

  // Historique des numéros de série
  'sn.title': 'Numéros de série',
  'sn.subtitle': 'Registre des unités suivies par numéro de série avec cycle de vie (réception → sortie).',
  'sn.empty': 'Aucun numéro de série.',
  'sn.search': 'Rechercher un numéro…',
  'sn.allStatus': 'Tous les statuts',
  'sn.col.serial': 'Numéro de série',
  'sn.col.product': 'Produit',
  'sn.col.updated': 'Mis à jour',
  'sn.status.IN_STOCK': 'En stock',
  'sn.status.ISSUED': 'Sorti',
  'sn.action.view': 'Ouvrir',
  'sn.action.issue': 'Sortir',
  'sn.metric.inStock': 'En stock',
  'sn.metric.issued': 'Sortis',
  'sn.metric.total': 'Total',
  'sn.detail.title': 'Numéro de série',
  'sn.field.reference': 'Référence',
  'sn.lifecycle': 'Cycle de vie',
  'sn.mv.type': 'Opération',
  'sn.mv.time': 'Heure',
  'sn.mv.RECEIVED': 'Réception',
  'sn.mv.ISSUED': 'Sortie',

  // Plans de livraison (MM)
  'lp.title': 'Plans de livraison',
  'lp.subtitle': 'Plans de livraison par fournisseur/produit avec lignes datées et réception par ligne.',
  'lp.empty': 'Aucun plan de livraison.',
  'lp.col.number': 'N°',
  'lp.col.supplier': 'Fournisseur',
  'lp.col.product': 'Produit',
  'lp.col.planned': 'Planifié',
  'lp.col.received': 'Reçu',
  'lp.status.ACTIVE': 'Actif',
  'lp.status.CLOSED': 'Clôturé',
  'lp.action.new': 'Nouveau plan',
  'lp.action.view': 'Ouvrir',
  'lp.action.receive': 'EM',
  'lp.action.close': 'Clôturer',
  'lp.metric.active': 'Actifs',
  'lp.metric.total': 'Plans',
  'lp.field.price': 'Prix',
  'lp.field.from': 'Valide du',
  'lp.field.to': 'Valide au',
  'lp.field.lines': 'Lignes de planning',
  'lp.field.qty': 'Quantité',
  'lp.field.addLine': '+ Ligne',
  'lp.modal.title': 'Nouveau plan de livraison',
  'lp.error.required': 'Fournisseur et produit requis.',
  'lp.error.lines': 'Au moins une ligne avec date et quantité.',
  'lp.line.date': 'Date de livraison',
  'lp.line.planned': 'Planifié',
  'lp.line.received': 'Reçu',
  'lp.line.OPEN': 'Ouvert',
  'lp.line.PARTIAL': 'Partiel',
  'lp.line.COMPLETED': 'Terminé',
  'nav.atp': 'Disponibilité',

  // Contrôle de disponibilité (ATP)
  'atp.title': 'Contrôle de disponibilité',
  'atp.subtitle': 'Vérifie si une quantité est livrable sur tous les entrepôts (disponible = stock − réservé − bloqué).',
  'atp.field.product': 'Produit',
  'atp.field.quantity': 'Quantité',
  'atp.action.check': 'Vérifier',
  'atp.metric.requested': 'Demandé',
  'atp.metric.available': 'Disponible total',
  'atp.metric.result': 'Résultat',
  'atp.metric.shortfall': 'Manquant',
  'atp.deliverable': 'Livrable',
  'atp.notDeliverable': 'Non livrable',
  'atp.byWarehouse': 'Disponibilité par entrepôt',
  'atp.col.warehouse': 'Entrepôt',
  'atp.col.name': 'Désignation',
  'atp.col.available': 'Disponible',
  'atp.noStock': 'Aucun stock.',
  'atp.error.required': 'Produit et quantité requis.',

  // Contrats-cadres (MM)
  'ct.title': 'Contrats-cadres',
  'ct.subtitle': 'Contrats de quantité par fournisseur/produit ; les appels tirent sur la cible.',
  'ct.empty': 'Aucun contrat.',
  'ct.col.number': 'N°',
  'ct.col.supplier': 'Fournisseur',
  'ct.col.product': 'Produit',
  'ct.col.target': 'Cible',
  'ct.col.released': 'Appelé',
  'ct.col.remaining': 'Restant',
  'ct.col.time': 'Heure',
  'ct.status.ACTIVE': 'Actif',
  'ct.status.CLOSED': 'Clôturé',
  'ct.action.new': 'Nouveau contrat',
  'ct.action.view': 'Ouvrir',
  'ct.action.release': 'Appeler',
  'ct.action.close': 'Clôturer',
  'ct.metric.active': 'Actifs',
  'ct.metric.total': 'Contrats',
  'ct.field.target': 'Quantité cible',
  'ct.field.price': 'Prix',
  'ct.field.from': 'Valide du',
  'ct.field.to': 'Valide au',
  'ct.field.callOffQty': 'Qté appel',
  'ct.field.reference': 'Référence',
  'ct.modal.title': 'Nouveau contrat-cadre',
  'ct.releases': 'Appels',
  'ct.noReleases': 'Aucun appel.',
  'ct.error.required': 'Fournisseur, produit et quantité cible requis.',

  // Stock en consignation
  'cons.title': 'Stock en consignation',
  'cons.subtitle': 'Stock propriété du fournisseur chez nous ; le prélèvement crée une dette.',
  'cons.empty': 'Aucun stock en consignation.',
  'cons.col.product': 'Produit',
  'cons.col.supplier': 'Fournisseur',
  'cons.col.warehouse': 'Entrepôt',
  'cons.col.quantity': 'Quantité',
  'cons.col.price': 'Prix',
  'cons.col.value': 'Valeur',
  'cons.action.book': 'Mouvement',
  'cons.action.view': 'Ouvrir',
  'cons.metric.lines': 'Lignes',
  'cons.metric.suppliers': 'Fournisseurs',
  'cons.metric.value': 'Valeur du stock',
  'cons.op.title': 'Mouvement de consignation',
  'cons.op.type': 'Opération',
  'cons.op.receive': 'Réception (le fournisseur livre)',
  'cons.op.withdraw': 'Prélèvement (consommation)',
  'cons.field.note': 'Note',
  'cons.error.required': 'Produit, fournisseur, entrepôt et quantité requis.',
  'cons.detail.title': 'Stock en consignation',
  'cons.movements': 'Mouvements',
  'cons.noMovements': 'Aucun mouvement.',
  'cons.mv.type': 'Type',
  'cons.mv.time': 'Heure',
  'cons.mv.RECEIPT': 'Réception',
  'cons.mv.WITHDRAWAL': 'Prélèvement',

  // Gestion de la qualité (QM)
  'qm.title': 'Gestion de la qualité',
  'qm.subtitle': 'Lots d’inspection avec décision d’emploi - le rejet bloque le stock disponible.',
  'qm.empty': 'Aucun lot d’inspection.',
  'qm.col.number': 'Lot',
  'qm.col.product': 'Produit',
  'qm.col.quantity': 'Quantité',
  'qm.col.source': 'Origine',
  'qm.status.OPEN': 'Ouvert',
  'qm.status.ACCEPTED': 'Accepté',
  'qm.status.REJECTED': 'Bloqué',
  'qm.source.MANUAL': 'Manuel',
  'qm.source.GOODS_RECEIPT': 'Réception',
  'qm.source.PRODUCTION': 'Production',
  'qm.action.new': 'Nouveau lot',
  'qm.action.view': 'Ouvrir',
  'qm.action.accept': 'Accepter',
  'qm.action.reject': 'Bloquer',
  'qm.metric.open': 'Ouverts',
  'qm.metric.accepted': 'Acceptés',
  'qm.metric.rejected': 'Bloqués',
  'qm.field.product': 'Produit',
  'qm.field.warehouse': 'Entrepôt',
  'qm.field.quantity': 'Quantité',
  'qm.field.source': 'Origine',
  'qm.field.characteristics': 'Caractéristiques',
  'qm.field.charName': 'Caractéristique',
  'qm.field.addChar': '+ Caractéristique',
  'qm.result.OK': 'Conforme',
  'qm.result.NOK': 'Non conf.',
  'qm.modal.title': 'Nouveau lot d’inspection',
  'qm.detail.title': 'Lot d’inspection',
  'qm.detail.blocked': '{qty} unités bloquées - stock disponible réduit.',
  'qm.noChars': 'Aucune caractéristique.',
  'qm.error.required': 'Produit, entrepôt et quantité requis.',
  'bin.title': 'Emplacements de stockage',
  'bin.subtitle': 'Ranger, prélever et déplacer le stock au niveau de l’emplacement.',
  'bin.empty': 'Aucun stock par emplacement.',
  'bin.col.bin': 'Emplacement',
  'bin.col.product': 'Produit',
  'bin.col.quantity': 'Quantité',
  'bin.action.newBin': 'Nouvel emplacement',
  'bin.action.book': 'Mouvement',
  'bin.field.warehouse': 'Entrepôt',
  'bin.field.product': 'Produit',
  'bin.field.bin': 'Emplacement',
  'bin.field.fromBin': 'De l’emplacement',
  'bin.field.toBin': 'Vers l’emplacement',
  'bin.field.quantity': 'Quantité',
  'bin.metric.bins': 'Emplacements',
  'bin.metric.occupied': 'Occupés',
  'bin.metric.lines': 'Lignes',
  'bin.op.title': 'Mouvement d’emplacement',
  'bin.op.type': 'Opération',
  'bin.op.putaway': 'Ranger',
  'bin.op.pick': 'Prélever',
  'bin.op.move': 'Déplacer',
  'bin.create.title': 'Créer un emplacement',
  'bin.create.code': 'Code',
  'bin.create.label': 'Libellé',
  'bin.error.required': 'Produit, emplacement et quantité requis.',
  'bin.error.code': 'Code requis.',

  // Retours clients
  'nav.returns': 'Retours',
  'ret.title': 'Retours',
  'ret.subtitle': 'Enregistrer les retours clients liés à une commande ; la réception réintègre le stock.',
  'ret.empty': 'Aucun retour.',
  'ret.col.number': 'N°',
  'ret.col.date': 'Date',
  'ret.col.reason': 'Motif',
  'ret.status.REQUESTED': 'Demandé',
  'ret.status.APPROVED': 'Approuvé',
  'ret.status.RECEIVED': 'Reçu',
  'ret.status.REJECTED': 'Rejeté',
  'ret.action.new': 'Nouveau retour',
  'ret.action.view': 'Voir',
  'ret.action.approve': 'Approuver',
  'ret.action.reject': 'Rejeter',
  'ret.action.receive': 'Réceptionner',
  'ret.metric.requested': 'Demandés',
  'ret.metric.approved': 'Approuvés',
  'ret.metric.received': 'Reçus',
  'ret.field.order': 'Commande',
  'ret.field.reason': 'Motif',
  'ret.field.product': 'Produit',
  'ret.field.ordered': 'Commandé',
  'ret.field.returnQty': 'Qté retour',
  'ret.field.lineReason': 'Motif',
  'ret.modal.title': 'Nouveau retour',
  'ret.detail.title': 'Retour',
  'ret.detail.received': 'Marchandise reçue ; stock réintégré.',
  'ret.error.lines': 'Une commande et au moins une quantité de retour sont requises.',

  // Contrats de service
  'nav.contracts': 'Contrats',
  'sc.title': 'Contrats de service',
  'sc.subtitle': 'Contrats de service et de maintenance par client.',
  'sc.empty': 'Aucun contrat.',
  'sc.col.number': 'N°',
  'sc.col.customer': 'Client',
  'sc.col.title': 'Titre',
  'sc.col.period': 'Période',
  'sc.status.ACTIVE': 'Actif',
  'sc.status.CANCELLED': 'Annulé',
  'sc.status.EXPIRED': 'Expiré',
  'sc.action.new': 'Nouveau contrat',
  'sc.action.cancel': 'Annuler',
  'sc.metric.total': 'Contrats',
  'sc.metric.active': 'Actifs',
  'sc.field.customer': 'Client',
  'sc.field.title': 'Titre',
  'sc.field.start': 'Début',
  'sc.field.end': 'Fin',
  'sc.modal.title': 'Nouveau contrat de service',
  'sc.error.required': 'Client et titre requis.',

  // Tickets de support (après-vente)
  'nav.tickets': 'Tickets',
  'tk.title': 'Tickets de support',
  'tk.subtitle': 'Saisir, prioriser et traiter les demandes clients.',
  'tk.empty': 'Aucun ticket.',
  'tk.col.number': 'N°',
  'tk.col.customer': 'Client',
  'tk.col.subject': 'Objet',
  'tk.col.priority': 'Priorité',
  'tk.status.OPEN': 'Ouvert',
  'tk.status.IN_PROGRESS': 'En cours',
  'tk.status.RESOLVED': 'Résolu',
  'tk.status.CLOSED': 'Fermé',
  'tk.priority.LOW': 'Basse',
  'tk.priority.MEDIUM': 'Moyenne',
  'tk.priority.HIGH': 'Haute',
  'tk.priority.URGENT': 'Urgente',
  'tk.action.new': 'Nouveau ticket',
  'tk.action.view': 'Ouvrir',
  'tk.filter.all': 'Tous les statuts',
  'tk.metric.total': 'Tickets',
  'tk.metric.open': 'Ouverts/En cours',
  'tk.metric.urgent': 'Urgents',
  'tk.field.customer': 'Client',
  'tk.field.priority': 'Priorité',
  'tk.field.contract': 'Contrat',
  'tk.field.noContract': 'Aucun contrat',
  'tk.field.subject': 'Objet',
  'tk.field.description': 'Description',
  'tk.modal.title': 'Nouveau ticket',
  'tk.error.required': 'Client et objet requis.',
  'tk.detail.title': 'Ticket',
  'tk.move.OPEN': 'Rouvrir',
  'tk.move.IN_PROGRESS': 'Démarrer',
  'tk.move.RESOLVED': 'Résoudre',
  'tk.move.CLOSED': 'Fermer',
  'tk.comments': 'Historique',
  'tk.noComments': 'Aucun commentaire.',
  'tk.addComment': 'Ajouter un commentaire…',
  'tk.send': 'Envoyer',

  // Page d’accueil publique
  'landing.nav.login': 'Se connecter',
  'landing.hero.line1': 'La clarté pour',
  'landing.hero.line2': 'toute votre entreprise.',
  'landing.hero.sub':
    'Finances, personnel, stock et ventes dans un seul système. Prêt en quelques jours, pas en plusieurs mois.',
  'landing.hero.cta': 'Réserver une démo',
  'landing.hero.more': 'En savoir plus',
  'landing.value1.title': 'Tout dans un seul système',
  'landing.value1.text':
    'Factures, salaires, stocks et commandes s’imbriquent, sans interfaces et sans double saisie.',
  'landing.value2.title': 'Précision suisse',
  'landing.value2.text':
    'TVA, QR-facture, rappels et salaires selon les standards suisses, au centime près.',
  'landing.value3.title': 'Prêt en quelques jours',
  'landing.value3.text':
    'Pas de déploiement interminable : réserver une démo, recevoir l’accès, travailler.',
  'landing.stat1.label': 'Modules',
  'landing.stat2.label': 'Langues',
  'landing.stat3.label': 'Système',
  'landing.form.title': 'Réserver une démo',
  'landing.form.sub':
    'Dites-nous en quelques mots qui vous êtes. Nous vous répondons sous un jour ouvrable.',
  'landing.form.point1': 'Une réponse sous un jour ouvrable',
  'landing.form.point2': 'Adaptée à votre entreprise',
  'landing.form.point3': 'Sans pression commerciale, sans engagement',
  'landing.form.name.label': 'Comment vous appelez-vous ?',
  'landing.form.name.placeholder': 'Prénom et nom',
  'landing.form.company.label': 'Pour quelle entreprise travaillez-vous ?',
  'landing.form.company.placeholder': 'Nom de l’entreprise',
  'landing.form.email.label': 'Comment pouvons-nous vous joindre ?',
  'landing.form.email.placeholder': 'nom@entreprise.ch',
  'landing.form.message.label': 'Souhaitez-vous ajouter quelque chose ?',
  'landing.form.message.placeholder': 'Optionnel : que devons-nous préparer pour vous ?',
  'landing.form.next': 'Continuer',
  'landing.form.back': 'Retour',
  'landing.form.skip': 'Passer',
  'landing.form.enter': 'ou appuyez sur Entrée',
  'landing.form.review.title': 'Tout est prêt.',
  'landing.form.review.name': 'Nom',
  'landing.form.review.company': 'Entreprise',
  'landing.form.review.email': 'E-mail',
  'landing.form.review.message': 'Message',
  'landing.form.submit': 'Envoyer la demande',
  'landing.form.sending': 'Envoi en cours…',
  'landing.form.error.required': 'Veuillez remplir ce champ.',
  'landing.form.error.email': 'Veuillez saisir une adresse e-mail valide.',
  'landing.form.error.submit': 'Cela n’a pas fonctionné. Veuillez réessayer.',
  'landing.form.done.title': 'Merci beaucoup !',
  'landing.form.done.text':
    'Votre demande nous est bien parvenue. Nous vous répondons sous un jour ouvrable.',
  'landing.footer.copyright': '© {year} Recica Solutions',
  'landing.claim': 'Moins d’outils, moins de double saisie, plus de clarté.',
  'landing.modules.title': 'Tout ce qu’un ERP doit savoir faire',
  'landing.modules.sub':
    'Sept modules sur une base de données commune. Chaque chiffre est saisi une seule fois et juste partout.',
  'landing.module.finance.name': 'Finances',
  'landing.module.finance.text':
    'Comptabilité en partie double, factures avec section paiement QR, TVA, rappels, immobilisations et clôture.',
  'landing.module.hr.name': 'Personnel',
  'landing.module.hr.text':
    'Dossiers des collaborateurs, salaires, absences, notes de frais et recrutement au même endroit.',
  'landing.module.inventory.name': 'Stock & achats',
  'landing.module.inventory.text':
    'Stocks en temps réel, commandes avec validations, inventaire, lots et planification.',
  'landing.module.sales.name': 'Ventes',
  'landing.module.sales.text':
    'De l’offre à la facture en passant par la commande et la livraison, avec listes de prix et limites de crédit.',
  'landing.module.projects.name': 'Projets',
  'landing.module.projects.text':
    'Projets, saisie des temps et notes de frais, facturables jusqu’à la position.',
  'landing.module.production.name': 'Production',
  'landing.module.production.text':
    'Nomenclatures, ordres de fabrication, postes de travail et planification des capacités.',
  'landing.module.automation.name': 'Automatisation',
  'landing.module.automation.text':
    'Des règles et alertes traitent les tâches de routine avant qu’elles n’arrivent sur votre bureau.',
  'landing.feat1.title': 'De l’offre à la facture payée',
  'landing.feat1.text':
    'Un document mène au suivant : offre, commande, livraison, facture, paiement. Sans ressaisie, sans rupture.',
  'landing.feat1.point1': 'Factures avec section paiement QR suisse',
  'landing.feat1.point2': 'Rappels automatiques en trois niveaux',
  'landing.feat1.point3': 'Factures récurrentes pour abonnements et contrats',
  'landing.feat2.title': 'Des chiffres fiables',
  'landing.feat2.text':
    'Tableaux de bord et rapports directement issus de la comptabilité, au centime près et toujours à jour.',
  'landing.feat2.point1': 'Compte de résultat et bilan en un clic',
  'landing.feat2.point2': 'Centres de coûts et budgets sous contrôle',
  'landing.feat2.point3': 'Décompte TVA préparé',
  'landing.feat3.title': 'Un calendrier pour toute l’entreprise',
  'landing.feat3.text':
    'Absences, événements et échéances au même endroit - chacun voit ce qui arrive.',
  'landing.feat3.point1': 'Demandes de congé avec validation',
  'landing.feat3.point2': 'Salaires préparés en un clic',
  'landing.feat3.point3': 'Notifications dans la boîte de réception et par e-mail',
  'landing.how.title': 'Prêt en trois étapes',
  'landing.how1.title': 'Réserver une démo',
  'landing.how1.text':
    'Contactez-nous - nous vous présentons le système et créons votre accès. Sans installation, sans équipe projet.',
  'landing.how2.title': 'Saisir les données de base',
  'landing.how2.text': 'Importer ou créer clients, produits et comptes.',
  'landing.how3.title': 'Travailler',
  'landing.how3.text': 'Le premier document est prêt en quelques minutes. Votre équipe s’y retrouve sans formation.',
  'landing.module.finance.f1': 'Factures, notes de crédit & abonnements',
  'landing.module.finance.f2': 'QR-facture & rappels',
  'landing.module.finance.f3': 'Grand livre, bilan & compte de résultat',
  'landing.module.finance.f4': 'Centres de coûts, budgets & controlling',
  'landing.module.finance.f5': 'Immobilisations & clôture de période',
  'landing.module.finance.f6': 'Ordres de paiement, banque & TVA',
  'landing.module.hr.f1': 'Dossiers des collaborateurs',
  'landing.module.hr.f2': 'Saisie des temps',
  'landing.module.hr.f3': 'Absences & vacances',
  'landing.module.hr.f4': 'Salaires',
  'landing.module.hr.f5': 'Notes de frais & frais de voyage',
  'landing.module.hr.f6': 'Recrutement & entretiens',
  'landing.module.inventory.f1': 'Articles & stocks en temps réel',
  'landing.module.inventory.f2': 'Commandes avec validations',
  'landing.module.inventory.f3': 'Fournisseurs & évaluation',
  'landing.module.inventory.f4': 'Lots, numéros de série & emplacements',
  'landing.module.inventory.f5': 'Inventaire & contrôles qualité',
  'landing.module.inventory.f6': 'Planification & disponibilité',
  'landing.module.sales.f1': 'Clients & listes de prix',
  'landing.module.sales.f2': 'Offres & commandes',
  'landing.module.sales.f3': 'Bulletins de livraison & retours',
  'landing.module.sales.f4': 'Pipeline de vente en un coup d’œil',
  'landing.module.sales.f5': 'Contrats de service & tickets',
  'landing.module.sales.f6': 'Limites de crédit & rapports',
  'landing.module.projects.f1': 'Projets & tâches',
  'landing.module.projects.f2': 'Saisie des temps sur projets',
  'landing.module.projects.f3': 'Notes de frais avec validation',
  'landing.module.projects.f4': 'Facturation jusqu’à la position',
  'landing.module.production.f1': 'Nomenclatures',
  'landing.module.production.f2': 'Ordres de fabrication & confirmations',
  'landing.module.production.f3': 'Postes de travail',
  'landing.module.production.f4': 'Planification des capacités',
  'landing.module.production.f5': 'Planification des besoins en matériel',
  'landing.module.automation.f1': 'Règles automatiques',
  'landing.module.automation.f2': 'Alertes & rappels',
  'landing.module.automation.f3': 'Notifications dans la boîte de réception',
  'landing.module.automation.f4': 'Envoi d’e-mails',
  'landing.extras.title': 'Inclus dans chaque module',
  'landing.extras.i1': 'Tableau de bord personnel avec indicateurs',
  'landing.extras.i2': 'Boîte de réception & notifications',
  'landing.extras.i3': 'Calendrier d’entreprise avec événements & absences',
  'landing.extras.i4': 'Recherche globale sur tout',
  'landing.extras.i5': 'Rôles & autorisations',
  'landing.extras.i6': 'Journal des modifications complet',
  'landing.extras.i7': 'Plusieurs devises',
  'landing.extras.i8': 'Allemand, anglais, français',
  'landing.nav.modules': 'Modules',
  'landing.nav.features': 'Fonctions',
  'landing.nav.how': 'Déroulement',
  'landing.hero.eyebrow': 'Logiciel de gestion suisse',
  'landing.hero.cue': 'Faire défiler',
  'landing.hero.meta': '7 modules · 3 langues · 1 base de données',
  'landing.values.kicker': 'Pourquoi RSZ ERP',
  'landing.values.title': 'Un système au lieu de cinq solutions isolées',
  'landing.claim.note':
    'Une seule base de données pour les finances, le personnel, le stock, les ventes, les projets et la production.',
  'landing.modules.kicker': 'Modules',
  'landing.extras.kicker': 'Inclus',
  'landing.features.kicker': 'Flux de documents',
  'landing.how.kicker': 'Déroulement',
  'landing.close.text': 'Sept modules, une base de données, une interface.',
  'landing.frame.debtors': 'Débiteurs',
  'landing.frame.report': 'Compte de résultat',
  'landing.frame.calendar': 'Calendrier d’entreprise',
  'landing.frame.week': 'Sem. 31',
  'landing.kpi.open': 'Postes ouverts',
  'landing.kpi.overdue': 'En retard',
  'landing.kpi.terms': 'Délai de paiement',
  'landing.kpi.termsValue': '24 jours',
  'landing.state.open': 'Ouverte',
  'landing.state.paid': 'Payée',
  'landing.state.dunned': 'Rappel 1',
  'landing.doc.quote': 'Offre',
  'landing.doc.order': 'Commande',
  'landing.doc.invoice': 'Facture',
  'landing.doc.qr': 'Section paiement QR',

  // ----- Anbieterebene (/platform) -----
  'platform.badge': 'Vue fournisseur',
  'platform.signOut': 'Se déconnecter',
  'platform.nav.tenants': 'Mandants',
  'platform.nav.demoRequests': 'Demandes de démo',
  'platform.roles.owner': 'Accès complet',
  'platform.roles.support': 'Assistance',
  'platform.login.title': 'Connexion fournisseur',
  'platform.login.hint': 'Un compte distinct de votre connexion habituelle. Les deux sessions peuvent rester ouvertes en même temps.',
  'platform.login.cta': 'Se connecter',
  'platform.login.cta.loading': 'Connexion…',
  'platform.login.failed': 'Échec de la connexion',
  'platform.tenants.title': 'Mandants',
  'platform.tenants.subtitle': 'Toutes les entreprises qui utilisent l’ERP. À ne pas confondre avec les clients des ventes, qui sont des débiteurs.',
  'platform.tenants.col.slug': 'Code',
  'platform.tenants.col.name': 'Entreprise',
  'platform.tenants.col.contact': 'Interlocuteur',
  'platform.tenants.col.phone': 'Téléphone',
  'platform.tenants.col.created': 'Créé le',
  'platform.tenants.status.all': 'Tous les statuts',
  'platform.tenants.status.active': 'Actif',
  'platform.tenants.status.provisioning': 'En cours d’installation',
  'platform.tenants.status.blocked': 'Bloqué',
  'platform.tenants.status.failed': 'Échec',
  'platform.tenants.status.deleting': 'Démantèlement',
  'platform.tenants.status.deleted': 'Supprimé',
  'platform.tenants.block': 'Bloquer',
  'platform.tenants.unblock': 'Débloquer',
  'platform.tenants.create.cta': 'Nouvelle entreprise',
  'platform.tenants.create.title': 'Créer une entreprise',
  'platform.tenants.create.hint': 'Cree l’entreprise et la configure : ses propres bases de donnees, son plan comptable et son premier compte. Cela prend quelques secondes.',
  'platform.tenants.create.saving': 'Création…',
  'platform.tenants.create.failed': 'Impossible de créer l’entreprise',
  'platform.tenants.delete.cta': 'Supprimer l’entreprise',
  'platform.tenants.delete.title': 'Supprimer {name}',
  'platform.tenants.delete.working': 'Suppression…',
  'platform.tenants.delete.failed': 'Suppression impossible',
  'platform.tenants.delete.warning': 'Les huit bases de donnees de cette entreprise, son role de base de donnees et tous ses comptes seront supprimes. Cela ne peut pas etre annule.',
  'platform.tenants.delete.backupHint': 'Sauvegardez d’abord. La commande cree un dossier avec les huit copies et une notice de restauration :',
  'platform.tenants.delete.confirmLabel': 'Saisissez {slug} pour confirmer',
  'platform.users.title': 'Utilisateurs de l’entreprise',
  'platform.users.hint': 'Creer, bloquer et reinitialiser les mots de passe. Se connecter en tant que client est impossible : aucun chemin du programme ne le permet.',
  'platform.users.empty': 'Cette entreprise n’a encore aucun utilisateur.',
  'platform.users.loading': 'Chargement des utilisateurs…',
  'platform.users.col.name': 'Nom',
  'platform.users.col.roles': 'Roles',
  'platform.users.col.status': 'Etat',
  'platform.users.active': 'Actif',
  'platform.users.blocked': 'Bloque',
  'platform.users.block': 'Bloquer',
  'platform.users.unblock': 'Debloquer',
  'platform.users.update.failed': 'Modification impossible',
  'platform.users.create.cta': 'Creer un utilisateur',
  'platform.users.create.title': 'Creer un nouvel utilisateur',
  'platform.users.create.saving': 'Creation…',
  'platform.users.create.failed': 'L’utilisateur n’a pas pu etre cree',
  'platform.users.create.passwordHint': 'Au moins 10 caracteres. L’utilisateur devrait le changer apres la premiere connexion.',
  'platform.users.reset.cta': 'Reinitialiser le mot de passe',
  'platform.users.reset.title': 'Lien a usage unique pour definir le mot de passe',
  'platform.users.reset.explain': 'Transmettez ce lien a {email}. La personne choisit elle-meme son mot de passe : vous ne le connaitrez jamais.',
  'platform.users.reset.once': 'Le lien fonctionne exactement une fois et expire apres 24 heures. Toutes les sessions de cette personne sont deja terminees.',
  'platform.users.reset.failed': 'Reinitialisation impossible',
  'setPassword.title': 'Definir le mot de passe',
  'setPassword.hint': 'Choisissez un nouveau mot de passe. Vous pourrez ensuite vous connecter avec.',
  'setPassword.new': 'Nouveau mot de passe',
  'setPassword.repeat': 'Repeter',
  'setPassword.tooShort': 'Au moins 10 caracteres.',
  'setPassword.mismatch': 'Les deux saisies ne correspondent pas.',
  'setPassword.cta': 'Definir le mot de passe',
  'setPassword.saving': 'Enregistrement…',
  'setPassword.failed': 'Cela n’a pas fonctionne.',
  'setPassword.noToken': 'Ce lien est incomplet. Veuillez ouvrir le lien complet depuis le message.',
  'setPassword.done': 'Termine. Vous pouvez maintenant vous connecter avec {email}.',
  'setPassword.toLogin': 'Vers la connexion',
  'platform.tenants.section.company': 'Entreprise',
  'platform.tenants.section.admin': 'Premier compte',
  'platform.tenants.section.admin.hint': 'C’est avec lui que l’entreprise se connecte la premiere fois. Il n’existe aucune inscription publique qui lui permettrait d’en creer un elle-meme.',
  'platform.tenants.section.letterhead': 'En-tete',
  'platform.tenants.section.letterhead.hint': 'Figure sur les factures, les rappels et les bulletins de livraison de l’entreprise. Modifiable ensuite dans ses reglages.',
  'platform.tenants.admin.email': 'Adresse de connexion',
  'platform.tenants.admin.password': 'Mot de passe',
  'platform.tenants.admin.password.hint': 'Au moins 10 caracteres. Le client devrait le changer apres la premiere connexion.',
  'platform.tenants.admin.firstName': 'Prenom',
  'platform.tenants.admin.lastName': 'Nom',
  'platform.tenants.company.address': 'Rue et numero',
  'platform.tenants.company.zip': 'NPA',
  'platform.tenants.company.city': 'Localite',
  'platform.tenants.company.iban': 'IBAN',
  'platform.tenants.company.vat': 'Numero de TVA',
  'platform.provisioning.title': 'Configuration de l’entreprise',
  'platform.provisioning.starting': 'Prise en charge de la tache…',
  'platform.provisioning.running': 'En cours :',
  'platform.provisioning.done': 'Termine. L’entreprise est active.',
  'platform.provisioning.failed': 'La configuration a echoue.',
  'platform.provisioning.rolledBack': 'La configuration a ete annulee.',
  'platform.provisioning.rolledBack.hint': 'Aucune base de donnees ni aucun compte n’est reste. L’identifiant est de nouveau disponible immediatement.',
  'platform.provisioning.pleaseWait': 'Veuillez patienter…',
  'platform.provisioning.readyHint': 'L’entreprise peut maintenant se connecter avec {email}.',
  'platform.provisioning.step.role': 'Creer le role de base de donnees',
  'platform.provisioning.step.registry': 'Enregistrer l’affectation',
  'platform.provisioning.step.company': 'Enregistrer l’en-tete',
  'platform.provisioning.step.admin': 'Creer le premier compte',
  'platform.provisioning.step.smoke': 'Verifier',
  'platform.provisioning.step.activate': 'Activer',
  'platform.provisioning.step.db': 'Base de donnees {service}',
  'platform.provisioning.step.migrate': 'Tables {service}',
  'platform.provisioning.step.drop': 'Supprimer la base de donnees {name}',
  'platform.tenants.slug.hint': 'Minuscule au début, puis minuscules, chiffres ou tiret bas. Il forme ensuite les noms des bases de données et ne peut plus être modifié.',
  'platform.tenants.searchPlaceholder': 'Rechercher une entreprise ou un code…',
  'platform.tenants.count': '{count} entreprises',
  'platform.tenants.empty': 'Aucune entreprise créée pour l’instant',
  'platform.tenants.provisioningNote': 'Les entreprises en cours d’installation n’ont pas encore leurs propres bases de données, leurs utilisateurs ne peuvent donc pas se connecter. L’installation en un clic arrivera à une étape ultérieure.',
  'platform.demo.title': 'Demandes de démo',
  'platform.demo.subtitle': 'Demandes envoyées via le formulaire du site public. Visibles uniquement ici, jamais dans une installation client.',
  'platform.demo.col.received': 'Reçue le',
  'platform.demo.col.company': 'Entreprise',
  'platform.demo.col.name': 'Nom',
  'platform.demo.col.message': 'Message',
  'platform.demo.status.all': 'Tous les statuts',
  'platform.demo.status.new': 'Nouvelle',
  'platform.demo.status.seen': 'Vue',
  'platform.demo.status.contacted': 'Contactée',
  'platform.demo.status.closed': 'Clôturée',
  'platform.demo.searchPlaceholder': 'Rechercher entreprise, nom ou e-mail…',
  'platform.demo.count': '{count} demandes',
  'platform.demo.empty': 'Aucune demande pour l’instant',

  // ----- Entscheidung über einen Ferienantrag -----
  'hr.leave.action.cancel': 'Annuler',
  'hr.leave.decide.approve.title': 'Approuver la demande',
  'hr.leave.decide.reject.title': 'Refuser la demande',
  'hr.leave.decide.cancel.title': 'Annuler l’absence',
  'hr.leave.decide.noteRequired': 'Motif (obligatoire)',
  'hr.leave.decide.noteOptional': 'Remarque (facultatif)',

  // ----- Mandantenakte und Anbieterprotokoll -----
  'platform.tenants.masterData': 'Données de base',
  'platform.tenants.col.plan': 'Contrat',
  'platform.tenants.col.contractStart': 'Début du contrat',
  'platform.tenants.col.contractEnd': 'Fin du contrat',
  'platform.tenants.col.notes': 'Notes',
  'platform.tenants.saved': 'Enregistré.',
  'platform.tenants.save.failed': 'Enregistrement impossible',
  'platform.tenants.blockedNote': 'Cette entreprise est bloquée. Ses utilisateurs ne peuvent pas se connecter, mais toutes les données sont conservées.',
  'platform.tenants.loading': 'Chargement…',
  'platform.audit.title': 'Ce que nous avons fait sur cette entreprise',
  'platform.audit.subtitle': 'Uniquement les actions du fournisseur. Ce qui se passe dans l’entreprise figure dans son propre journal et n’est pas consultable ici.',
  'platform.audit.empty': 'Aucune action enregistrée pour l’instant',
  'platform.audit.col.when': 'Quand',
  'platform.audit.col.who': 'Qui',
  'platform.audit.col.what': 'Quoi',
  'platform.audit.col.entity': 'Concerne',
  'platform.audit.action.create': 'Créé',
  'platform.audit.action.update': 'Modifié',
  'platform.audit.action.delete': 'Supprimé',
  // ---- Clôture mensuelle et vue du responsable (paquet 7)
  'month.name.1': 'janvier',
  'month.name.2': 'février',
  'month.name.3': 'mars',
  'month.name.4': 'avril',
  'month.name.5': 'mai',
  'month.name.6': 'juin',
  'month.name.7': 'juillet',
  'month.name.8': 'août',
  'month.name.9': 'septembre',
  'month.name.10': 'octobre',
  'month.name.11': 'novembre',
  'month.name.12': 'décembre',
  'nav.myTeam': 'À ma décision',
  'month.status.DRAFT': 'En cours',
  'month.status.SUBMITTED': 'Soumis',
  'month.status.APPROVED': 'Approuvé',
  'month.status.REJECTED': 'Refusé',
  'month.target': 'Prévu',
  'month.actual': 'Effectif',
  'month.balance': 'Solde',
  'month.submit': 'Soumettre le mois',
  'month.withdraw': 'Retirer',
  'month.waiting': 'En attente d’approbation',
  'month.approvedHint': 'Approuvé - toute modification exige une réouverture',
  'month.rejectedNote': 'Refusé : {note}',
  'team.title': 'À ma décision',
  'team.subtitle': 'Demandes de congé et décomptes mensuels des personnes qui me sont rattachées.',
  'team.noReports': 'Personne ne vous est rattaché pour l’instant. Dès qu’une personne vous sera attribuée, ses demandes apparaîtront ici.',
  'team.col.who': 'Qui',
  'team.col.range': 'Période',
  'team.col.days': 'Jours',
  'team.col.reason': 'Motif',
  'team.col.month': 'Mois',
  'team.col.hours': 'Heures',
  'team.col.status': 'État',
  'team.check': 'Examiner',
  'team.approve': 'Approuver',
  'team.approveMonth': 'Approuver',
  'team.reject': 'Refuser',
  'team.daysUnit': 'jours',
  'team.leave.title': 'Demandes de congé',
  'team.leave.hint': 'Demandes ouvertes. Avant de décider, vous voyez qui d’autre est absent.',
  'team.leave.empty': 'Aucune demande de congé ouverte.',
  'team.leave.decide': 'Décider de la demande',
  'team.months.title': 'Décomptes mensuels',
  'team.months.hint': 'Mois soumis. Une fois approuvé, plus rien ne peut être modifié.',
  'team.months.empty': 'Aucun mois en attente d’approbation.',
  'team.months.decide': 'Décider du mois',
  'team.months.note': 'Remarque',
  'team.months.notePlaceholder': 'En cas de refus : que manque-t-il ?',
  'team.overlaps.title': 'Qui d’autre est absent ?',
  'team.overlaps.none': 'Personne d’autre sur cette période.',
  'hr.employees.modal.manager': 'Responsable',
  'hr.employees.modal.noManager': 'Aucun',
  'hr.employees.modal.managerHint': 'Décide des demandes de congé et des décomptes mensuels de cette personne.',
  // ---- Demi-journées, changement d’année et report (paquet 8)
  'self.leave.startHalf': 'Premier jour à moitié',
  'self.leave.endHalf': 'Dernier jour à moitié',
  'self.leave.preview.cost': 'Vous coûte',
  'self.leave.preview.year': '{cost} jours - il reste {after} sur {before}',
  'self.leave.preview.short': 'Solde insuffisant',
  'hr.leave.close.title': 'Clôture annuelle des congés',
  'hr.leave.close.subtitle': 'Reporter le solde de congés sur la nouvelle année - avec une date d’expiration.',
  'hr.leave.close.year': 'Année',
  'hr.leave.close.maxCarry': 'Reporter au maximum',
  'hr.leave.close.maxCarryHint': 'Vide signifie tout reporter. Zéro signifie rien.',
  'hr.leave.close.expires': 'Expire le',
  'hr.leave.close.preview': 'Aperçu',
  'hr.leave.close.run': 'Lancer la clôture',
  'hr.leave.close.col.carry': 'Report',
  'hr.leave.close.col.forfeited': 'Perdu',
  'hr.leave.close.col.remaining': 'Solde',
  'hr.leave.close.done': '{count} personnes clôturées, {carried} jours reportés.',
  'hr.leave.close.skipped': 'Déjà clôturé et donc ignoré : {names}',
  'hr.leave.col.carriedOver': 'Report',
  'hr.employees.modal.annualLeave': 'Jours de congé par an',
  'hr.employees.modal.annualLeaveHint': 'Vide signifie que la valeur par défaut du type de congé s’applique. Une entrée en cours d’année est calculée au prorata.',
  // ---- Types d’absence suisses et jours fériés modifiables (paquet 9)
  'nav.leaveTypes': 'Types et jours fériés',
  'leave.type.ANNUAL': 'Vacances',
  'leave.type.SICK': 'Maladie',
  'leave.type.UNFALL': 'Accident',
  'leave.type.MILITAER': 'Service militaire et civil',
  'leave.type.MUTTERSCHAFT': 'Maternité',
  'leave.type.VATERSCHAFT': 'Paternité',
  'leave.type.BETREUUNG': 'Prise en charge d’un proche',
  'leave.type.KURZABSENZ': 'Absence courte',
  'leave.type.KOMPENSATION': 'Compensation',
  'leave.type.UNPAID': 'Congé non payé',
  'leave.type.WEITERBILDUNG': 'Formation continue',
  'leave.type.PARENT': 'Congé parental (ancien)',
  'hr.types.title': 'Types d’absence et jours fériés',
  'hr.types.subtitle': 'Ce qui peut être demandé, sous quelles règles - et quels jours ne coûtent aucun solde.',
  'hr.types.tab': 'Types d’absence',
  'hr.types.new': 'Nouveau type',
  'hr.types.edit': 'Modifier le type',
  'hr.types.empty': 'Aucun type d’absence.',
  'hr.types.inactive': 'Retiré',
  'hr.types.col.name': 'Désignation',
  'hr.types.col.code': 'Code',
  'hr.types.col.quota': 'Contingent',
  'hr.types.col.rules': 'Règles',
  'hr.types.codeHint': 'Non modifiable ensuite - soldes et demandes en dépendent.',
  'hr.types.color': 'Couleur',
  'hr.types.colorHint': 'Un nom, pas une valeur. La mise en forme vient des jetons de design et connaît les deux thèmes.',
  'hr.types.color.neutral': 'Neutre',
  'hr.types.color.info': 'Bleu',
  'hr.types.color.success': 'Vert',
  'hr.types.color.warning': 'Jaune',
  'hr.types.color.danger': 'Rouge',
  'hr.types.color.accent': 'Accent',
  'hr.types.notice': 'Préavis en jours',
  'hr.types.quota': 'Jours par an',
  'hr.types.isPaid': 'Payé',
  'hr.types.active': 'Proposer au choix',
  'hr.types.activeHint': 'Les types retirés restent lisibles mais n’apparaissent plus dans aucune demande.',
  'hr.types.requiresBalance': 'Imputer sur un contingent annuel',
  'hr.types.requiresBalanceHint': 'En Suisse, la maladie n’est pas un contingent.',
  'hr.types.requiresApproval': 'Nécessite une approbation',
  'hr.types.requiresApprovalHint': 'Sans la coche, la demande s’applique aussitôt - adapté à un avis de maladie.',
  'hr.types.allowsRetroactive': 'Demande rétroactive possible',
  'hr.types.allowsRetroactiveHint': 'Les vacances se planifient, la maladie non.',
  'hr.types.requiresDocument': 'Justificatif requis',
  'hr.types.requiresDocumentHint': 'Certificat médical, ordre de marche, acte de naissance. Un rappel, pas un blocage.',
  'hr.types.flag.noApproval': 's’applique aussitôt',
  'hr.types.flag.noRetro': 'non rétroactif',
  'hr.types.flag.document': 'justificatif',
  'hr.types.flag.notice': '{days} jours de préavis',
  'hr.holidays.tab': 'Jours fériés',
  'hr.holidays.new': 'Ajouter des jours',
  'hr.holidays.empty': 'Aucune entrée.',
  'hr.holidays.emptyYear': 'Aucun jour n’est enregistré pour {year}. Tant que cela reste ainsi, chaque jour férié de cette année coûte un jour de vacances.',
  'hr.holidays.col.date': 'Date',
  'hr.holidays.col.name': 'Désignation',
  'hr.holidays.col.kind': 'Type',
  'hr.holidays.kind.PUBLIC': 'Légal',
  'hr.holidays.kind.BRIDGE': 'Pont',
  'hr.holidays.kind.COMPANY': 'Fermeture d’entreprise',
  'hr.holidays.from': 'Du',
  'hr.holidays.to': 'Au',
  'hr.holidays.toHint': 'Laisser vide pour un seul jour.',
  'self.leave.preview.document': 'Un justificatif est nécessaire.',
  'self.leave.preview.noApproval': 'S’applique aussitôt - aucune approbation nécessaire.',
  // ---- Calendrier des absences en grille mensuelle (paquet 10)
  'weekday.short.mon': 'Lu',
  'weekday.short.tue': 'Ma',
  'weekday.short.wed': 'Me',
  'weekday.short.thu': 'Je',
  'weekday.short.fri': 'Ve',
  'weekday.short.sat': 'Sa',
  'weekday.short.sun': 'Di',
  'hr.leave.calendar.loading': 'Chargement du calendrier…',
  'hr.leave.calendar.thisMonth': 'Ce mois',
  'hr.leave.calendar.showPending': 'Afficher les demandes ouvertes',
  'hr.leave.calendar.legend.approved': 'Approuvé',
  'hr.leave.calendar.legend.pending': 'Demandé',
  // ---- Export, rapport mensuel et filtres (paquet 11)
  'hrtime.report.open': 'Rapport mensuel',
  'hrtime.report.title': 'Rapport mensuel',
  'hrtime.report.employeeNumber': 'Numéro de personnel',
  'hrtime.report.sum': 'Total',
  'hrtime.report.signEmployee': 'Signature de la personne employée',
  'hrtime.report.signManager': 'Signature du responsable',
  'hrtime.report.pickEmployee': 'Un rapport concerne toujours une personne. Veuillez sélectionner une collaboratrice ou un collaborateur ci-dessus.',
  'hrtime.truncated': '{shown} lignes sur {total} affichées. Restreignez la période pour voir l’ensemble.',
  'hr.leave.filter.status': 'État',
  'hr.leave.filter.all': 'Tous',
  'hr.leave.filter.count': '{shown} sur {total} affichés',
  'hrtime.type.ABSENCE': 'Absence',
  'hrtime.report.pickRange': 'Un rapport nécessite une période. Veuillez définir Du et Au sur la page des temps.',
  'hrtime.report.unknownEmployee': 'Inconnu',
  'hrtime.exportBlocked': 'La liste est tronquée. Restreignez la période pour obtenir un fichier complet.',
  // ---- Rappels au lieu de relances (paquet 12)
  'notif.time_submitted': 'Mois {month}/{year} de {employeeName} soumis - en attente d’approbation',
  'notif.time_approved': 'Votre mois {month}/{year} a été approuvé',
  'notif.time_rejected': 'Votre mois {month}/{year} a été refusé - veuillez le corriger',
  'notif.time_gaps': '{missingCount} jour(s) sans saisie de temps entre le {from} et le {to}',
  'notif.time_approval_due': 'Le mois {month}/{year} de {employeeName} attend depuis {waitingDays} jours',
  'notif.leave_approval_due': 'La demande de congé de {employeeName} attend depuis {waitingDays} jours',
  'platform.tenants.delete.mustBlockFirst': 'Cette entreprise est encore active. Elle ne peut être supprimée qu’une fois bloquée - cela laisse un temps de réflexion entre la décision et l’acte.',
  // ---- Le compte d’heures (paquet 13)
  'timeAccount.title': 'Compte d’heures',
  'timeAccount.unit': 'h',
  'timeAccount.asOf': 'Au {date}',
  'timeAccount.opening': 'Solde initial',
  'timeAccount.closedOne': 'Un mois approuvé',
  'timeAccount.closed': '{count} mois approuvés',
  'timeAccount.open': 'En cours depuis le {from}',
  'timeAccount.compensated': 'Dont {hours} h de récupération prises. Elles ne comptent pas comme temps travaillé - le solde est donc consommé.',
  'timeAccount.gap': 'Approbation non continue : {months}. Le chiffre est juste, il ne provient simplement pas d’une suite ininterrompue de mois clos.',
  'timeAccount.noStart': 'Aucun début enregistré pour cette personne. Sans date d’entrée ni date de référence, aucun solde ne peut être calculé.',
  'timeAccount.col.total': 'Compte',
  'timeAccount.col.opening': 'Initial',
  'timeAccount.col.closed': 'Approuvé',
  'timeAccount.col.open': 'En cours',
  'timeAccount.team.title': 'Comptes d’heures',
  'timeAccount.team.hint': 'Le solde global de mon équipe. Un jour de récupération le consomme - qui décide devrait le voir avant.',
  'timeAccount.team.empty': 'Pas encore de compte d’heures.',
  'timeAccount.forDecision': 'Compte d’heures : {hours} h',
  'time.week.compensated': '{hours} h récupérées',
  'time.balance.compensated': 'Récupéré',
  'hr.types.countsAsWorktime': 'Compte comme temps travaillé',
  'hr.types.countsAsWorktimeHint': 'Activé : un jour de ce type compte comme un jour travaillé, le compte d’heures reste inchangé. Désactivé : il consomme le solde, comme pour la récupération.',
  'hr.types.flag.consumesTime': 'consomme le compte',
  'timeAccount.setOpening': 'Définir le solde initial',
  'timeAccount.openingHint': 'Qui met ce système en place apporte des heures existantes. La date de référence indique à partir de quand le système calcule lui-même - avant elle, seul le solde initial compte.',
  'timeAccount.openingField': 'Solde initial (h)',
  'timeAccount.startField': 'Calcule dès le',
  // ---- Documents sur plus d’une feuille (paquet 1)
  'pdf.page': 'Page {n} sur {total}',
  // ---- Changer et réinitialiser un mot de passe (paquet 1)
  'common.saving': 'Enregistrement…',
  'common.copy': 'Copier',
  'common.copied': 'Copié',
  'settings.password.title': 'Changer le mot de passe',
  'settings.password.hint': 'Après le changement, vous êtes déconnecté sur tous les appareils, y compris celui-ci.',
  'settings.password.current': 'Mot de passe actuel',
  'settings.password.new': 'Nouveau mot de passe',
  'settings.password.repeat': 'Répéter le nouveau mot de passe',
  'settings.password.mismatch': 'Les deux saisies ne correspondent pas.',
  'settings.password.submit': 'Changer le mot de passe',
  'settings.password.done': 'Mot de passe changé. Vous devrez vous reconnecter.',
  'settings.password.ruleLength': 'au moins 10 caractères',
  'settings.password.ruleLower': 'une minuscule',
  'settings.password.ruleUpper': 'une majuscule',
  'settings.password.ruleDigit': 'un chiffre',
  'settings.users.resetPassword': 'Réinitialiser le mot de passe',
  'settings.users.resetTitle': 'Lien à usage unique pour définir un mot de passe',
  'settings.users.resetDone': 'Un lien à usage unique est prêt pour {email}. Toutes ses sessions ont pris fin.',
  'settings.users.resetLink': 'Lien',
  'settings.users.resetExpires': 'Valable brièvement, utilisable une seule fois.',
  'settings.users.resetWarning': 'Le lien n’apparaît que maintenant. Remettez-le en personne - qui le lit peut définir le mot de passe.',
  // ---- Production : un état intermédiaire honnête et la recherche d’articles (paquet 3)
  'production.status.COMPLETING': 'En cours d’imputation',
  'production.orders.completing': 'La clôture est lancée. L’ordre n’est terminé qu’une fois que le stock a consommé les composants et reçu le produit.',
  'production.orders.stockError': 'Rien n’a été imputé : {reason}',
  'production.boms.search': 'Rechercher des articles',
  'production.boms.searchHint': 'Numéro ou désignation',
  'production.boms.truncated': '{shown} articles sur {total} chargés - utilisez la recherche pour trouver les autres.',
  'production.boms.noProducts': 'Aucun article n’existe. Sans articles, aucune nomenclature n’est possible.',
  'production.boms.productsFailed': 'La liste des articles n’a pas pu être chargée : {message}',

  // ----- Journal (Belegliste und Storno)
  'nav.journal': 'Journal',
  'journal.title': 'Journal',
  'journal.subtitle': 'Toutes les écritures avec leurs lignes - et le moyen d’en annuler une.',
  'journal.empty': 'Rien n’est comptabilisé pour cette période.',
  'journal.filter.from': 'Du',
  'journal.filter.to': 'Au',
  'journal.filter.account': 'Compte',
  'journal.filter.allAccounts': 'Tous les comptes',
  'journal.col.account': 'Compte',
  'journal.col.debit': 'Débit',
  'journal.col.credit': 'Crédit',
  'journal.badge.isReversal': 'Extourne',
  'journal.badge.reversedBy': 'extournée par {number}',
  'journal.action.reverse': 'Extourner',
  'journal.reverse.title': 'Extourner l’écriture {number}',
  'journal.reverse.explain': 'Une contre-écriture sera créée au {date}, le jour de l’écriture d’origine. Les deux restent au journal - rien n’est supprimé.',
  'journal.reverse.reason': 'Motif',
  'journal.reverse.reasonHint': 'Pourquoi cette extourne ?',
  'journal.pager.previous': 'Retour',
  'journal.pager.next': 'Suivant',
  'journal.pager.position': '{from}-{to} sur {total}',

  // ----- Berichte: Zeitraum, Kontozeilen, Ausfuhr
  'finance.reports.empty': 'Aucun compte mouvementé sur cette période.',
  'finance.reports.asOf': 'Au {date}',
  'finance.reports.action.export': 'Exporter',
  'finance.reports.col.amount': 'Montant',
  'finance.reports.col.balance': 'Solde',
  'finance.reports.section.revenue': 'Produits',
  'finance.reports.section.expenses': 'Charges',
  'finance.reports.section.assets': 'Actifs',
  'finance.reports.section.liabilities': 'Passifs',
  'finance.reports.section.equity': 'Fonds propres',
  'finance.reports.range.thisYear': 'Année en cours',
  'finance.reports.range.lastYear': 'Année précédente',
  'finance.reports.range.thisQuarter': 'Trimestre en cours',
  'finance.reports.range.thisMonth': 'Mois en cours',
  'finance.reports.file.income': 'compte-de-resultat',
  'finance.reports.file.balanceSheet': 'bilan',
  'finance.reports.retainedEarnings': 'Y compris : bénéfice ou perte de l’exercice de {amount}. Il ne figure sur aucun compte - c’est la différence entre produits et charges à la date de clôture.',

  // ----- Kassabuch: Gegenkonto und Datum
  'cb.field.counterAccount': 'Contrepartie',
  'cb.field.counterAccountPick': 'Choisir un compte',
  'cb.field.entryDate': 'Date',
  'cb.error.counterAccountRequired': 'Veuillez choisir un compte de contrepartie. Une écriture de caisse est comptabilisée au grand livre, et une écriture a deux côtés.',
  'cb.hint.receipt': 'Recette : débit caisse, crédit contrepartie.',
  'cb.hint.payment': 'Dépense : débit contrepartie, crédit caisse.',
  'cb.field.account': 'Compte de caisse',
  'cb.field.accountDefault': 'Compte de caisse par défaut',

  // ----- Kontoblatt
  'journal.sheet.opening': 'Report',
  'journal.sheet.closing': 'Solde final',
  'journal.sheet.openingRow': 'Solde reporté',
  'journal.sheet.closingRow': 'Totaux et solde final',
  'journal.sheet.running': 'Solde',
  'journal.sheet.counterAccount': 'Contrepartie',
  'journal.sheet.split': '{count} contreparties',
  'journal.sheet.truncated': 'La liste est tronquée. Le solde final ne porte que sur les lignes affichées - veuillez restreindre la période.',

  // ----- Lohn: Arbeitgeberbeitraege
  'hr.payroll.col.employer': 'Charges patronales',
  'hr.payroll.employerHint': 'Les charges patronales (AVS, AC, CAF, AAP, LPP) ne sont pas déduites du salaire - elles constituent un coût supplémentaire pour l’entreprise.',

  // ----- Personalstamm: Quellensteuer, BVG, Kinder
  'hr.employees.modal.birthDate': 'Date de naissance',
  'hr.employees.modal.birthDateHint': 'Pour les bonifications LPP échelonnées par âge. Sans elle, un taux fixe s’applique.',
  'hr.employees.modal.children': 'Enfants',
  'hr.employees.modal.workCanton': 'Canton de travail',
  'hr.employees.modal.workCantonHint': 'Là où le travail s’effectue, pas le domicile.',
  'hr.employees.modal.qstLiable': 'Soumis à l’impôt à la source',
  'hr.employees.modal.qstCode': 'Code tarifaire',
  'hr.employees.modal.qstCodeHint': 'Code AFC, par exemple A0N ou B2Y.',

  // ----- Quellensteuertarife
  'nav.withholdingTax': 'Données salariales',
  'hr.qst.title': 'Données salariales cantonales',
  'hr.qst.subtitle': 'Barèmes de l’impôt à la source et allocations familiales - cantonaux tous les deux, livrés ni l’un ni l’autre.',
  'hr.qst.current': 'Barèmes enregistrés',
  'hr.qst.empty': 'Aucun barème enregistré. Sans barème, aucun salaire ne peut être calculé pour une personne imposée à la source - c’est voulu : un taux inventé serait pire que pas de taux du tout.',
  'hr.qst.import': 'Importer un fichier de barèmes',
  'hr.qst.importIntro': 'Les barèmes ne sont pas livrés avec le logiciel. Ils sont cantonaux, changent chaque année, et un taux inventé a l’air officiel, calcule sans contradiction et prélève chaque mois le mauvais montant - jusqu’à une reprise.',
  'hr.qst.format': 'Format',
  'hr.qst.format.csv': 'CSV avec noms de colonnes',
  'hr.qst.format.estv': 'Fichier de barèmes AFC',
  'hr.qst.source': 'Source',
  'hr.qst.sourceHint': 'p. ex. barèmes AFC 2026, édition de janvier',
  'hr.qst.csvHeader': 'Colonnes attendues : Kanton;Tarifcode;Jahr;von;bis;Satz',
  'hr.qst.fileContent': 'Contenu du fichier',
  'hr.qst.filePlaceholder': 'Coller ici le contenu du fichier de barèmes',
  'hr.qst.action.preview': 'Lire et afficher',
  'hr.qst.action.import': 'Appliquer',
  'hr.qst.action.importAnyway': 'Appliquer malgré les constats',
  'hr.qst.imported': '{tarife} barèmes avec {stufen} tranches appliqués.',
  'hr.qst.preview.tariffs': 'Barèmes',
  'hr.qst.preview.brackets': 'Tranches',
  'hr.qst.preview.rateRange': 'Plage de taux',
  'hr.qst.preview.samples': 'Premières lignes',
  'hr.qst.col.canton': 'Canton',
  'hr.qst.col.code': 'Code tarifaire',
  'hr.qst.col.year': 'Année',
  'hr.qst.col.brackets': 'Tranches',
  'hr.qst.col.rateRange': 'Taux',
  'hr.qst.col.source': 'Source',
  'hr.qst.col.imported': 'Importé',
  'hr.qst.col.from': 'De',
  'hr.qst.col.to': 'À',
  'hr.qst.col.rate': 'Taux',

  // ----- Lohnlauf stornieren
  'hr.payroll.col.withholding': 'Impôt à la source',
  'hr.payroll.action.cancel': 'Annuler',
  'hr.payroll.cancel.title': 'Annuler la paie {period}',
  'hr.payroll.cancel.explain': 'La paie n’est pas supprimée mais reprise - les deux restent au dossier. Le mois peut ensuite être recalculé, et la comptabilité extourne son écriture d’elle-même.',
  'hr.payroll.cancel.reason': 'Motif',
  'hr.payroll.cancel.reasonHint': 'Pourquoi cette paie est-elle reprise ?',
  'hr.fam.title': 'Allocations familiales',
  'hr.fam.intro': 'Ces montants sont également cantonaux. La Confédération fixe un minimum et la plupart des cantons le dépassent - une valeur par défaut silencieuse sous-paierait durablement la personne concernée, sans que personne ne s’en aperçoive.',
  'hr.fam.empty': 'Aucun montant enregistré. Sans montant, aucun salaire ne peut être calculé pour une personne avec enfants.',
  'hr.fam.col.child': 'Allocation pour enfant',
  'hr.fam.col.education': 'Allocation de formation',
  'hr.fam.action.save': 'Enregistrer',
  'hr.fam.educationNote': 'L’allocation de formation est enregistrée mais pas encore appliquée : cela demande l’âge de chaque enfant, et le dossier du personnel n’en indique que le nombre. La deviner serait faux dans les deux sens.',

  // --- Erreurs que le serveur ne peut pas expliquer lui-meme ------------
  'fehler.abgebrochen': 'La requête a été annulée.',
  'fehler.keineVerbindung': 'Pas de connexion au serveur. Vérifiez votre réseau et réessayez.',
  'fehler.zeitueberschreitung': 'Le serveur n’a pas répondu à temps. Veuillez réessayer.',
  'fehler.zuVieleAnfragen': 'Trop de tentatives en peu de temps. Patientez un instant puis réessayez.',
  'fehler.zuVieleAnfragen.warten': 'Trop de tentatives en peu de temps. Réessayez dans {sekunden} secondes.',
  'fehler.zuGross': 'Le fichier est trop volumineux pour être envoyé.',
  'fehler.dienstNichtErreichbar': 'Ce domaine n’est pas joignable pour l’instant. Réessayez dans un moment.',
  'fehler.serverfehler': 'Une erreur est survenue sur le serveur. L’opération n’a pas été effectuée.',
  'fehler.unbekannt': 'La requête a échoué (statut {status}).',

  // --- Limite d'erreur --------------------------------------------------
  'fehler.grenze.titel': 'Cette vue n’a pas pu être affichée',
  'fehler.grenze.text': 'L’erreur ne concerne que cette page. Vos données sont intactes et le reste de l’application continue de fonctionner.',
  'fehler.grenze.neuLaden': 'Recharger la page',
  'fehler.grenze.zurueck': 'Retour à l’aperçu',
  'fehler.grenze.details': 'Détails techniques',

  // --- Listes tronquees -------------------------------------------------
  'insight.gekuerzt': 'Les indicateurs portent sur {gezeigt} lignes sur {gesamt}. Restreignez la période ou le filtre pour qu’ils soient complets.',
  'tabelle.fehler': 'La liste n’a pas pu être chargée',
  'tabelle.gekuerzt': '{gezeigt} sur {gesamt} lignes. Restreignez la période ou le filtre pour voir les autres.',

  // --- Ce que le serveur reproche a un formulaire -----------------------
  // Les noms de regles viennent de Joi et forment un petit ensemble fixe.

  // --- Feldnamen fuer Formularfehler ------------------------------------
  'feld.name': 'Nom',
  'feld.code': 'Code',
  'feld.status': 'Statut',
  'feld.type': 'Type',
  'feld.notes': 'Notes',
  'feld.note': 'Note',
  'feld.comment': 'Commentaire',
  'feld.description': 'Description',
  'feld.reason': 'Motif',
  'feld.title': 'Titre',
  'feld.email': 'E-mail',
  'feld.phone': 'Téléphone',
  'feld.password': 'Mot de passe',
  'feld.firstName': 'Prénom',
  'feld.lastName': 'Nom de famille',
  'feld.amount': 'Montant',
  'feld.unitPrice': 'Prix unitaire',
  'feld.quantity': 'Quantité',
  'feld.currency': 'Monnaie',
  'feld.taxRate': 'Taux d’imposition',
  'feld.lines': 'Postes',
  'feld.items': 'Postes',
  'feld.hours': 'Heures',
  'feld.months': 'Mois',
  'feld.month': 'Mois',
  'feld.year': 'Année',
  'feld.fiscalYear': 'Exercice',
  'feld.canton': 'Canton',
  'feld.breakMinutes': 'Pause en minutes',
  'feld.position': 'Fonction',
  'feld.stage': 'Étape',
  'feld.priority': 'Priorité',
  'feld.category': 'Catégorie',
  'feld.source': 'Origine',
  'feld.reference': 'Référence',
  'feld.filename': 'Nom du fichier',
  'feld.probability': 'Probabilité',
  'feld.limit': 'Nombre de lignes',
  'feld.offset': 'Ligne de départ',
  'feld.productId': 'Article',
  'feld.customerId': 'Client',
  'feld.supplierId': 'Fournisseur',
  'feld.employeeId': 'Collaborateur',
  'feld.warehouseId': 'Entrepôt',
  'feld.accountId': 'Compte',
  'feld.invoiceId': 'Facture',
  'feld.projectId': 'Projet',
  'feld.leaveTypeId': 'Type d’absence',
  'feld.costCenterId': 'Centre de coûts',
  'feld.departmentId': 'Département',
  'feld.managerId': 'Responsable',
  'feld.ownerId': 'Responsable',
  'feld.assigneeId': 'Attribué à',
  'feld.equipmentId': 'Équipement',
  'feld.positionId': 'Poste',
  'feld.parentId': 'Parent',

  'feldfehler.mehrere': '{anzahl} champs ne sont pas encore corrects.',
  'feldfehler.unbekannt': 'La valeur n’est pas valide.',
  'feldfehler.any.required': '{feld} est obligatoire.',
  'feldfehler.any.only': '{feld} n’a pas une valeur autorisée.',
  'feldfehler.any.invalid': '{feld} n’a pas une valeur autorisée.',
  'feldfehler.string.empty': '{feld} ne doit pas être vide.',
  'feldfehler.string.base': '{feld} doit être du texte.',
  'feldfehler.string.email': '{feld} n’est pas une adresse e-mail valide.',
  'feldfehler.string.uri': '{feld} n’est pas une adresse valide.',
  'feldfehler.string.guid': '{feld} n’est pas un identifiant valide.',
  'feldfehler.string.min': '{feld} demande au moins {grenze} caractères.',
  'feldfehler.string.max': '{feld} peut avoir au plus {grenze} caractères.',
  'feldfehler.string.length': '{feld} doit avoir exactement {grenze} caractères.',
  'feldfehler.string.pattern.base': '{feld} n’a pas la forme attendue.',
  'feldfehler.string.isoDate': '{feld} n’est pas une date valide.',
  'feldfehler.number.base': '{feld} doit être un nombre.',
  'feldfehler.number.min': '{feld} doit valoir au moins {grenze}.',
  'feldfehler.number.max': '{feld} peut valoir au plus {grenze}.',
  'feldfehler.number.integer': '{feld} doit être un nombre entier.',
  'feldfehler.number.positive': '{feld} doit être supérieur à zéro.',
  'feldfehler.number.greater': '{feld} doit être supérieur à {grenze}.',
  'feldfehler.number.less': '{feld} doit être inférieur à {grenze}.',
  'feldfehler.number.unsafe': '{feld} est trop grand.',
  'feldfehler.date.base': '{feld} n’est pas une date valide.',
  'feldfehler.date.min': '{feld} est trop tôt.',
  'feldfehler.date.max': '{feld} est trop tard.',
  'feldfehler.array.base': '{feld} doit être une liste.',
  'feldfehler.array.min': '{feld} demande au moins {grenze} entrées.',
  'feldfehler.array.max': '{feld} peut avoir au plus {grenze} entrées.',
  'feldfehler.array.includesRequiredUnknowns': '{feld} est incomplet.',
  'feldfehler.object.base': '{feld} n’a pas la forme attendue.',
  'feldfehler.object.unknown': '{feld} n’est pas prévu ici.',
  'feldfehler.boolean.base': '{feld} doit être oui ou non.',
  'feldfehler.object.missing': 'Au moins un champ doit être rempli.',

  // --- "Das gibt es nicht" ----------------------------------------------
  'fehler.nichtGefunden.account': 'Ce compte n’existe pas.',
  'fehler.nichtGefunden.attachment': 'Cette pièce jointe n’existe pas.',
  'fehler.nichtGefunden.backorder': 'Ce reliquat n’existe pas.',
  'fehler.nichtGefunden.bankTransaction': 'Cette écriture bancaire n’existe pas.',
  'fehler.nichtGefunden.bin': 'Cet emplacement n’existe pas.',
  'fehler.nichtGefunden.bom': 'Cette nomenclature n’existe pas.',
  'fehler.nichtGefunden.candidate': 'Ce candidat n’existe pas.',
  'fehler.nichtGefunden.cashJournal': 'Ce livre de caisse n’existe pas.',
  'fehler.nichtGefunden.company': 'Cette entreprise n’existe pas.',
  'fehler.nichtGefunden.consignment': 'Ce stock en consignation n’existe pas.',
  'fehler.nichtGefunden.contract': 'Ce contrat n’existe pas.',
  'fehler.nichtGefunden.costCenter': 'Ce centre de coûts n’existe pas.',
  'fehler.nichtGefunden.creditNote': 'Cet avoir n’existe pas.',
  'fehler.nichtGefunden.currency': 'Cette monnaie n’existe pas.',
  'fehler.nichtGefunden.customer': 'Ce client n’existe pas.',
  'fehler.nichtGefunden.cycleCount': 'Ce comptage n’existe pas.',
  'fehler.nichtGefunden.delivery': 'Ce bon de livraison n’existe pas.',
  'fehler.nichtGefunden.demoRequest': 'Cette demande n’existe pas.',
  'fehler.nichtGefunden.downPayment': 'Cet acompte n’existe pas.',
  'fehler.nichtGefunden.dunningNotice': 'Ce rappel n’existe pas.',
  'fehler.nichtGefunden.employee': 'Cette personne ne figure pas au registre du personnel.',
  'fehler.nichtGefunden.equipment': 'Cet équipement n’existe pas.',
  'fehler.nichtGefunden.expense': 'Cette dépense n’existe pas.',
  'fehler.nichtGefunden.fixedAsset': 'Cette immobilisation n’existe pas.',
  'fehler.nichtGefunden.inspectionLot': 'Ce lot de contrôle n’existe pas.',
  'fehler.nichtGefunden.holiday': 'Ce jour férié n’existe pas.',
  'fehler.nichtGefunden.companyEvent': 'Cet événement n’existe pas.',
  'fehler.termin.nurUrheberDarfLoeschen': 'Seule la personne qui a créé l’événement peut le supprimer - ou une personne disposant des droits d’administration.',
  'fehler.datenbank.schonVorhanden': 'Cette entrée existe déjà.',
  'fehler.datenbank.verweistAufNichts': 'L’entrée renvoie à quelque chose qui n’existe pas.',
  'fehler.nichtGefunden.invoice': 'Cette facture n’existe pas.',
  'fehler.nichtGefunden.item': 'Ce poste n’existe pas.',
  'fehler.nichtGefunden.jobPosting': 'Cette offre d’emploi n’existe pas.',
  'fehler.nichtGefunden.journal': 'Cette écriture n’existe pas.',
  'fehler.nichtGefunden.leaveRequest': 'Cette demande n’existe pas.',
  'fehler.nichtGefunden.leaveType': 'Ce type d’absence n’existe pas.',
  'fehler.nichtGefunden.maintenanceOrder': 'Cet ordre de maintenance n’existe pas.',
  'fehler.nichtGefunden.maintenancePlan': 'Ce plan de maintenance n’existe pas.',
  'fehler.nichtGefunden.month': 'Ce mois n’existe pas.',
  'fehler.nichtGefunden.mrpRun': 'Ce calcul des besoins n’existe pas.',
  'fehler.nichtGefunden.notification': 'Cette notification n’existe pas.',
  'fehler.nichtGefunden.opportunity': 'Cette opportunité n’existe pas.',
  'fehler.nichtGefunden.paymentRun': 'Ce lot de paiement n’existe pas.',
  'fehler.nichtGefunden.paymentTerm': 'Cette condition de paiement n’existe pas.',
  'fehler.nichtGefunden.payrollRun': 'Ce cycle de paie n’existe pas.',
  'fehler.nichtGefunden.payslip': 'Cette fiche de salaire n’existe pas.',
  'fehler.nichtGefunden.priceList': 'Cette liste de prix n’existe pas.',
  'fehler.nichtGefunden.product': 'Cet article n’existe pas.',
  'fehler.nichtGefunden.profitCenter': 'Ce centre de profit n’existe pas.',
  'fehler.nichtGefunden.project': 'Ce projet n’existe pas.',
  'fehler.nichtGefunden.provisioningJob': 'Cette tâche de mise en place n’existe pas.',
  'fehler.nichtGefunden.purchaseOrder': 'Cette commande n’existe pas.',
  'fehler.nichtGefunden.quote': 'Cette offre n’existe pas.',
  'fehler.nichtGefunden.recurringInvoice': 'Cette facture récurrente n’existe pas.',
  'fehler.nichtGefunden.recurringJournal': 'Cette écriture récurrente n’existe pas.',
  'fehler.nichtGefunden.report': 'Ce rapport n’existe pas.',
  'fehler.nichtGefunden.requisition': 'Cette demande d’achat n’existe pas.',
  'fehler.nichtGefunden.reservation': 'Cette réservation n’existe pas.',
  'fehler.nichtGefunden.review': 'Cet entretien n’existe pas.',
  'fehler.nichtGefunden.rule': 'Cette règle n’existe pas.',
  'fehler.nichtGefunden.run': 'Cette exécution n’existe pas.',
  'fehler.nichtGefunden.salesOrder': 'Cette commande n’existe pas.',
  'fehler.nichtGefunden.salesReturn': 'Ce retour n’existe pas.',
  'fehler.nichtGefunden.scheduleLine': 'Cette ligne d’échelonnement n’existe pas.',
  'fehler.nichtGefunden.schedulingAgreement': 'Ce plan de livraison n’existe pas.',
  'fehler.nichtGefunden.serialUnit': 'Ce numéro de série n’existe pas.',
  'fehler.nichtGefunden.supplier': 'Ce fournisseur n’existe pas.',
  'fehler.nichtGefunden.tenant': 'Cette entreprise n’existe pas.',
  'fehler.nichtGefunden.ticket': 'Ce ticket n’existe pas.',
  'fehler.nichtGefunden.timeEntry': 'Cette saisie de temps n’existe pas.',
  'fehler.nichtGefunden.travelReport': 'Ce décompte de frais n’existe pas.',
  'fehler.nichtGefunden.user': 'Ce compte utilisateur n’existe pas.',
  'fehler.nichtGefunden.warehouse': 'Cet entrepôt n’existe pas.',
  'fehler.nichtGefunden.workCenter': 'Ce poste de travail n’existe pas.',
  'fehler.nichtGefunden.workOrder': 'Cet ordre de fabrication n’existe pas.',
  'fehler.nichtGefunden.workSchedule': 'Aucun horaire hebdomadaire n’est enregistré pour cette personne.',

  'fehler.anmeldung.falsch': 'L’e-mail ou le mot de passe n’est pas correct.',
  'fehler.anmeldung.abgelaufen': 'Votre session a expiré. Veuillez vous reconnecter.',
  'fehler.anmeldung.abgelaufen': 'Votre session a expiré. Veuillez vous reconnecter.',
  'fehler.anmeldung.abgelaufen': 'Votre session a expiré. Veuillez vous reconnecter.',
  'fehler.anmeldung.abgelaufen': 'Votre session a expiré. Veuillez vous reconnecter.',
  'fehler.anmeldung.abgelaufen': 'Votre session a expiré. Veuillez vous reconnecter.',
  'fehler.anmeldung.abgelaufen': 'Votre session a expiré. Veuillez vous reconnecter.',
  'fehler.anmeldung.kontoGesperrt': 'Ce compte est bloqué. Adressez-vous à l’administration de votre entreprise.',
  'fehler.anmeldung.kontoGesperrt': 'Ce compte est bloqué. Adressez-vous à l’administration de votre entreprise.',
  'fehler.zugriff.fehlendeBerechtigung': 'Vous n’avez pas l’autorisation pour ce domaine.',
  'fehler.zugriff.keinAnbietertoken': 'Ce domaine est réservé au fournisseur.',
  'fehler.zugriff.adresseNichtErlaubt': 'L’accès n’est pas autorisé depuis cette adresse réseau.',
  'fehler.benutzer.letzteVerwaltung': 'C’est le dernier compte disposant des droits d’administration. Sans lui, personne ne pourrait plus accéder aux réglages.',
  'fehler.benutzer.adresseVergeben': 'Cette adresse e-mail est déjà utilisée.',
  'fehler.benutzer.adresseVergeben': 'Cette adresse e-mail est déjà utilisée.',
  'fehler.benutzer.adresseVergeben': 'Cette adresse e-mail est déjà utilisée.',
  'fehler.kennwort.gleichWieBisher': 'Le nouveau mot de passe doit être différent de l’actuel.',
  'fehler.kennwort.linkAbgelaufen': 'Ce lien n’est plus valable. Demandez-en un nouveau.',
  'fehler.kennwort.zuruecksetzenNichtEingerichtet': 'La réinitialisation du mot de passe n’est pas configurée dans cette installation.',
  'fehler.firma.kuerzelVergeben': 'Cet identifiant est déjà attribué.',
  'fehler.firma.kuerzelStimmtNicht': 'L’identifiant saisi ne correspond pas à celui de l’entreprise.',
  'fehler.firma.nurAktivOderGesperrt': 'Une entreprise ne peut être qu’active ou bloquée.',

  'fehler.eingabe.ungueltig': 'La saisie est incomplète ou non valide.',
  'fehler.regel.unbekanntesEreignis': 'Cet événement n’existe pas - une règle ne peut pas s’y abonner.',
  'fehler.regel.bedingungOhneVergleich': 'Un champ doit aussi indiquer COMMENT la comparaison se fait.',
  'fehler.firma.anlageNichtVerfuegbar': 'Aucune entreprise ne peut être créée sur ce serveur.',
  'fehler.firma.entfernenNichtVerfuegbar': 'Aucune entreprise ne peut être supprimée sur ce serveur.',
  'fehler.firma.erstSperrenDannEntfernen': 'Une entreprise ne peut être supprimée que si elle est bloquée. Bloquez-la d’abord, puis supprimez-la.',
  'fehler.firma.gesperrt': 'Cette entreprise est bloquée. Adressez-vous au fournisseur.',
  'fehler.firma.statusUnbekannt': 'L’état de cette entreprise ne peut pas être déterminé pour l’instant. Réessayez dans un moment.',
  'fehler.route.gibtEsNicht': 'Il n’y a rien à cette adresse.',
  'fehler.kennwort.eigenesWirdGewechselt': 'Votre propre mot de passe se change, il ne se réinitialise pas - utilisez "Changer le mot de passe".',
  'fehler.anmeldung.mehrereFirmen': 'Cette adresse existe dans plusieurs entreprises. Veuillez indiquer l’identifiant de l’entreprise.',
  'fehler.datei.artNichtErlaubt': 'Ce type de fichier ne peut pas être joint.',
  'fehler.datei.leer': 'Ce fichier est vide.',
  'fehler.datei.zuGross': 'Ce fichier est trop volumineux pour être joint.',
  'fehler.projekt.nichtsAusgewaehlt': 'Rien n’est sélectionné qui puisse être facturé.',
  'fehler.betrag.groesserNull': 'Le montant doit être supérieur à zéro.',
  'fehler.status.ungueltig': 'Ce statut n’existe pas.',
  'fehler.status.ungueltig': 'Ce statut n’existe pas.',
  'fehler.status.ungueltig': 'Ce statut n’existe pas.',
  'fehler.status.ungueltig': 'Ce statut n’existe pas.',
  'fehler.status.wechselNichtMoeglich': 'Ce changement de statut n’est pas possible depuis ici.',
  'fehler.zeit.keineStunden': 'Indiquez des heures - ou un début et une fin qui donnent plus de zéro.',

  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.falscherStatus': 'Cela n’est pas possible dans cet état - ce document est {status}.',
  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.falscherStatus': 'Cela n’est pas possible dans cet état - ce document est {status}.',
  'fehler.beleg.falscherStatus': 'Cela n’est pas possible dans cet état - ce document est {status}.',
  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.nurImStatus': 'Cela n’est possible qu’au statut {erlaubt} - ce document est {status}.',
  'fehler.beleg.schonEntschieden': 'Ce retour a déjà été traité.',
  'fehler.beleg.schonEingegangen': 'Ce retour est déjà arrivé.',
  'fehler.beleg.falscherStatus': 'Cela n’est pas possible dans cet état - ce document est {status}.',
  'fehler.beleg.statuswechselNichtMoeglich': 'Il n’est pas possible de passer directement de {von} à {nach}.',
  'fehler.kunde.falscherStatus': 'Ce client est {status} - cela ne permet pas cette action.',
  'fehler.kunde.falscherStatus': 'Ce client est {status} - cela ne permet pas cette action.',
  'fehler.kunde.nummerVergeben': 'Ce numéro de client est déjà attribué.',
  'fehler.kunde.kreditlimitUeberschritten': 'La limite de crédit de ce client est atteinte : {offen} en cours plus {dazu} dépasse la limite de {limit}.',
  'fehler.verkaufschance.unbekannteStufe': 'Cette étape n’existe pas dans le pipeline.',
  'fehler.verkaufschance.schonAufStufe': 'Cette opportunité est déjà à {stufe}.',
  'fehler.kommentar.leer': 'Un commentaire a besoin de texte.',
  'fehler.beleg.ohnePositionen': 'Ce document a besoin d’au moins un poste.',
  'fehler.beleg.ohnePositionen': 'Ce document a besoin d’au moins un poste.',
  'fehler.position.nichtImAuftrag': 'Cet article ne figure pas sur la commande.',
  'fehler.position.nichtImAuftrag': 'Cet article ne figure pas sur la commande.',
  'fehler.position.mehrAlsBestellt': 'Impossible de retourner {menge} - seuls {bestellt} ont été commandés.',
  'fehler.menge.groesserNull': 'La quantité doit être supérieure à zéro.',
  'fehler.menge.mehrAlsOffen': '{menge} dépasse les {offen} encore en attente.',
  'fehler.preisliste.doppelteStaffel': 'Le même article a ce palier de quantité en double.',
  'fehler.menge.groesserNull': 'La quantité doit être supérieure à zéro.',
  'fehler.menge.groesserNull': 'La quantité doit être supérieure à zéro.',
  'fehler.fertigung.ohneLager': 'Un ordre de fabrication a besoin d’un entrepôt - c’est là que le matériel est prélevé et le produit enregistré.',
  'fehler.stueckliste.nummerVergeben': 'Ce code de nomenclature est déjà attribué.',
  'fehler.arbeitsplatz.nummerVergeben': 'Ce code de poste de travail est déjà attribué.',
  'fehler.stueckliste.stillgelegt': 'Cette nomenclature est désactivée et ne peut plus être utilisée.',
  'fehler.fertigung.ohneArtikelOderStueckliste': 'Sans nomenclature, l’ordre a besoin au moins d’un article.',
  'fehler.beleg.statuswechselNichtMoeglich': 'Il n’est pas possible de passer directement de {von} à {nach}.',
  'fehler.beleg.falscherStatus': 'Cela n’est pas possible dans cet état - ce document est {status}.',
  'fehler.beleg.falscherStatus': 'Cela n’est pas possible dans cet état - ce document est {status}.',
  'fehler.fertigung.teilrueckmeldungenLaufen': 'Cet ordre est confirmé par quantités partielles - terminez-le via les confirmations.',
  'fehler.menge.mehrAlsOffen': '{menge} dépasse les {offen} encore en attente.',
  'fehler.fertigung.abschlussNichtAngestossen': 'La clôture n’a pas pu être lancée - rien n’a été comptabilisé. Veuillez réessayer plus tard.',

  'fehler.person.adresseVergeben': 'Cette adresse e-mail appartient déjà à quelqu’un d’autre.',
  'fehler.person.adresseVergeben': 'Cette adresse e-mail appartient déjà à quelqu’un d’autre.',
  'fehler.person.schonAusgetreten': 'Cette personne a déjà quitté l’entreprise.',
  'fehler.person.austrittVorEintritt': 'La date de départ ne peut pas précéder la date d’entrée.',
  'fehler.person.keinAntragMoeglich': 'Cette personne est {status} - aucune demande ne peut être faite.',
  'fehler.beleg.inzwischenGeaendert': 'Quelqu’un d’autre a modifié ce document entre-temps. Rechargez-le et réessayez.',
  'fehler.gespraech.ohneZeitraum': 'Un entretien a besoin de la période qu’il couvre.',
  'fehler.spesen.ohneZweck': 'Un décompte de frais a besoin d’un motif de voyage.',
  'fehler.stelle.geschlossen': 'Cette offre d’emploi est close.',
  'fehler.lohn.laufSchonVorhanden': 'Il existe déjà un cycle de paie pour ce mois.',
  'fehler.zeit.schonStorniert': 'Cette ligne a déjà été annulée.',
  'fehler.zeitraum.unvollstaendig': 'Un début et une fin sont tous deux nécessaires.',
  'fehler.zeitraum.endeVorBeginn': 'La fin précède le début.',
  'fehler.zeitraum.ohneJahr': 'L’année est requise.',
  'fehler.zeitraum.ohneJahrUndMonat': 'L’année et le mois sont tous deux requis.',
  'fehler.zeit.ohnePersonUndZeitraum': 'Une personne et une période sont toutes deux requises.',
  'fehler.zeit.stempelungUnvollstaendig': 'Un pointage a besoin de l’heure d’arrivée ET de départ.',
  'fehler.zeit.stundenAusserhalb': 'Les heures doivent être comprises entre 0 et 24.',
  'fehler.datum.unlesbar': 'Cette date ne peut pas être lue.',
  'fehler.zeit.gehoertZuAbwesenheit': 'Cette ligne relève d’une absence approuvée. Pour la supprimer, annulez la demande de congé.',
  'fehler.monat.abschlussNichtEingerichtet': 'La clôture mensuelle n’est pas configurée dans cette installation.',
  'fehler.monat.nichtsEingereicht': 'Rien n’a été soumis pour ce mois.',
  'fehler.beleg.inzwischenGeaendert': 'Quelqu’un d’autre a modifié ce document entre-temps. Rechargez-le et réessayez.',
  'fehler.lohn.soebenStorniert': 'Quelqu’un d’autre vient d’annuler ce cycle de paie.',
  'fehler.handlung.unbekannt': 'Cette action n’existe pas.',
  'fehler.antrag.nichtUeberSichSelbst': 'On ne décide pas de sa propre demande. C’est le responsable ou les RH qui s’en chargent.',
  'fehler.antrag.andereZustaendig': 'Cette demande relève du responsable, ou des RH à défaut.',
  'fehler.antrag.nurOffeneZurueckziehen': 'Seule une demande en attente peut être retirée. Pour une absence approuvée, adressez-vous au responsable ou aux RH.',
  'fehler.person.keinePersonalakte': 'Aucun dossier du personnel n’est lié à ce compte. Les RH doivent établir le lien.',
  'fehler.antrag.keinArbeitstag': 'Cette période ne contient aucun jour ouvré - il n’y a rien à demander.',
  'fehler.antrag.schonVorhanden': 'Une demande existe déjà pour cette période.',
  'fehler.abwesenheitsart.stillgelegt': 'Le type d’absence "{art}" n’est plus utilisé. Veuillez en choisir un actuel.',
  'fehler.abwesenheitsart.nichtRueckwirkend': '{art} ne peut pas être demandé rétroactivement. Le début le plus tôt possible est aujourd’hui.',
  'fehler.abwesenheitsart.brauchtVorlauf': '{art} demande un préavis de {tage} jours. Le début le plus tôt possible est le {ab}.',
  'fehler.abwesenheitsart.kuerzelVergeben': 'Ce type d’absence existe déjà.',

  'fehler.lohn.zulageOhneKanton': '{person} a {kinder} enfant(s) mais aucun canton de travail. Les allocations familiales sont cantonales - sans canton, le montant ne peut pas être déterminé.',
  'fehler.lohn.quellensteuerOhneAngaben': '{person} est soumis à l’impôt à la source mais n’a ni canton de travail ni code de tarif. Les deux doivent figurer au dossier du personnel.',

  'fehler.einheit.faktorGroesserNull': 'Le facteur de conversion doit être supérieur à zéro.',
  'fehler.artikel.dienstleistungOhneBestand': 'Il s’agit d’une prestation - elle n’a pas de stock.',
  'fehler.artikel.nochBestandVorhanden': 'Cet article a encore du stock - il ne peut pas devenir une prestation.',
  'fehler.artikel.stillgelegt': 'Cet article est désactivé et ne peut plus être mouvementé.',
  'fehler.artikel.chargeGebraucht': 'Cet article est suivi par lot - un numéro de lot est requis.',
  'fehler.artikel.seriennummernGebraucht': 'Cet article est suivi par numéro de série - exactement {anzahl} numéro(s) requis.',
  'fehler.bestand.zuWenig': 'Stock insuffisant : {vorhanden} disponibles, {gewuenscht} demandés.',
  'fehler.bestand.zuWenig': 'Stock insuffisant : {vorhanden} disponibles, {gewuenscht} demandés.',
  'fehler.bestand.zuWenig': 'Stock insuffisant : {vorhanden} disponibles, {gewuenscht} demandés.',
  'fehler.bestand.zuWenig': 'Stock insuffisant : {vorhanden} disponibles, {gewuenscht} demandés.',
  'fehler.bestand.zuWenigWegenReservation': 'Seuls {frei} peuvent être sortis - {reserviert} sont réservés, {gewuenscht} demandés.',
  'fehler.bestand.fifoFehlbetrag': 'Le stock est insuffisant selon le premier entré, premier sorti : il manque {fehlt}.',
  'fehler.lagerplatz.zuWenig': 'Cet emplacement ne contient que {vorhanden} - impossible de prélever {gewuenscht}.',
  'fehler.lagerplatz.zuWenig': 'Cet emplacement ne contient que {vorhanden} - impossible de prélever {gewuenscht}.',
  'fehler.lagerplatz.nichtsEinzulagern': 'Seuls {frei} articles sont sans emplacement - impossible d’en ranger davantage.',
  'fehler.lagerplatz.gleicherPlatz': 'L’origine et la destination doivent être des emplacements différents.',
  'fehler.lagerplatz.verschiedeneLager': 'Les deux emplacements doivent appartenir au même entrepôt.',
  'fehler.lager.gleichesLager': 'L’origine et la destination doivent être des entrepôts différents.',
  'fehler.bestand.korrekturNull': 'Un ajustement de zéro ne change rien.',
  'fehler.bestand.korrekturOhnePreis': 'Une entrée a besoin d’un prix de revient - sinon la valorisation du stock ne tient plus.',
  'fehler.freigabe.nichtEigene': 'On n’approuve pas sa propre demande. Une autre personne doit le faire.',
  'fehler.freigabe.nichtEigene': 'On n’approuve pas sa propre demande. Une autre personne doit le faire.',
  'fehler.freigabe.nichtEigene': 'On n’approuve pas sa propre demande. Une autre personne doit le faire.',
  'fehler.freigabe.nurVerwaltung': 'Seule une personne disposant des droits d’administration peut décider d’une approbation.',
  'fehler.freigabe.nurVerwaltung': 'Seule une personne disposant des droits d’administration peut décider d’une approbation.',
  'fehler.position.nichtImBeleg': 'Ce poste n’appartient pas à ce document.',
  'fehler.bedarfsmeldung.ohneLieferant': 'Sans fournisseur, cela ne peut pas devenir une commande.',
  'fehler.abrufposition.unvollstaendig': 'Chaque ligne d’échelonnement a besoin d’une date de livraison et d’une quantité supérieure à zéro.',
  'fehler.abrufposition.unvollstaendig': 'Chaque ligne d’échelonnement a besoin d’une date de livraison et d’une quantité supérieure à zéro.',
  'fehler.bedarfslauf.keineVorschlaege': 'Il n’y a aucune proposition d’approvisionnement ouverte à reprendre.',
  'fehler.einheit.basiseinheitFest': 'C’est l’unité de base - son facteur est toujours 1.',
  'fehler.einheit.schonVorhanden': 'Cette unité existe déjà pour cet article.',
  'fehler.einheit.unbekannt': 'Cette unité n’existe pas pour cet article.',
  'fehler.einheit.unbekannt': 'Cette unité n’existe pas pour cet article.',
  'fehler.bedarfsmeldung.geaendertWaehrendUebernahme': 'La demande d’achat a changé pendant la reprise. La commande {bestellung} a été créée mais n’est pas liée - à vérifier manuellement.',

  'fehler.betrag.nichtNegativ': 'Le montant ne doit pas être négatif.',
  'fehler.systemkonto.nichtHinterlegt': 'Aucun compte n’est attribué pour "{zweck}". Attribuez-en un sous Comptes système dans le plan comptable.',
  'fehler.systemkonto.stillgelegt': 'Le compte {konto} pour "{zweck}" est désactivé et ne peut pas être mouvementé.',
  'fehler.konto.stillgelegtAlsSystemkonto': 'Le compte {konto} est désactivé et ne peut pas servir de compte système.',
  'fehler.konto.stillgelegt': 'Le compte {konto} est désactivé et ne peut pas être mouvementé.',
  'fehler.konto.nummerVergeben': 'Ce numéro de compte est déjà attribué.',
  'fehler.konto.nummerVergebenAn': 'Le numéro {nummer} appartient déjà à "{name}".',
  'fehler.konto.artWieUebergeordnet': 'Un compte subordonné doit avoir le même type que son compte parent.',
  'fehler.konto.artNichtMehrAenderbar': '"{name}" a {buchungen} écritures. Le type de compte ne peut plus être modifié - tous les soldes changeraient.',
  'fehler.konto.falscheArt': 'Le compte {konto} devrait être de type {erwartet} mais est {ist}.',
  'fehler.position.kontoartPasstNicht': 'Le type de compte de ce poste ne convient pas au document (il est {ist}).',
  'fehler.position.kontoartPasstNicht': 'Le type de compte de ce poste ne convient pas au document (il est {ist}).',
  'fehler.position.kontoartPasstNicht': 'Le type de compte de ce poste ne convient pas au document (il est {ist}).',
  'fehler.budget.nurErfolgskonten': 'Un budget n’existe que sur les comptes de produits et de charges - celui-ci est {ist}.',
  'fehler.budget.ueberschritten': 'Cette écriture dépasserait le budget de {konto}.',
  'fehler.buchung.zuWenigeZeilen': 'Une écriture a besoin d’au moins deux lignes - un débit et un crédit.',
  'fehler.buchung.zuWenigeZeilen': 'Une écriture a besoin d’au moins deux lignes - un débit et un crédit.',
  'fehler.buchung.zuWenigeZeilen': 'Une écriture a besoin d’au moins deux lignes - un débit et un crédit.',
  'fehler.buchung.nichtAusgeglichen': 'Le débit et le crédit ne correspondent pas : {soll} contre {haben}.',
  'fehler.buchung.nichtAusgeglichen': 'Le débit et le crédit ne correspondent pas : {soll} contre {haben}.',
  'fehler.periode.geschlossen': 'La période {periode} est clôturée. Rouvrez-la pour y comptabiliser.',
  'fehler.periode.schonGeschlossen': 'La période {periode} est déjà clôturée.',
  'fehler.periode.nichtGeschlossen': 'La période {periode} n’est pas clôturée.',
  'fehler.geschaeftsjahr.schonAbgeschlossen': 'L’exercice {jahr} est déjà clôturé.',
  'fehler.geschaeftsjahr.nichtsAbzuschliessen': 'Il n’y a aucune écriture de résultat à clôturer pour {jahr}.',
  'fehler.buchung.soebenStorniert': 'Quelqu’un d’autre vient d’annuler cette écriture.',
  'fehler.buchung.schonStorniert': 'L’écriture {beleg} a déjà été annulée par {storno}.',
  'fehler.buchung.jahresabschlussNichtStornierbar': 'C’est la clôture annuelle. Elle ne peut pas être annulée seule - rouvrez plutôt l’exercice.',
  'fehler.buchung.gehoertZuBeleg': 'Cette écriture relève d’un document. Un document s’annule sur le document lui-même, pas sur son écriture.',
  'fehler.buchung.ohneZeilen': 'Cette écriture n’a aucune ligne.',
  'fehler.beleg.schonVerarbeitet': 'Ce document a déjà été traité.',
  'fehler.beleg.summePasstNicht': 'Le total {gesamt} ne correspond pas à la somme des postes ({positionen}).',
  'fehler.rechnung.schonBeglichen': 'Cette facture est déjà entièrement réglée.',
  'fehler.rechnung.schonBeglichen': 'Cette facture est déjà entièrement réglée.',
  'fehler.zahlung.mehrAlsOffen': 'Le montant dépasse le solde ouvert de {offen}.',
  'fehler.zahlung.mehrAlsGuthaben': 'Le montant dépasse l’avoir de {guthaben}.',
  'fehler.rechnung.keinGuthaben': 'Il n’y a aucun avoir à rembourser sur cette facture.',
  'fehler.rechnung.hatZahlungen': 'Cette facture a des paiements. Annulez d’abord le paiement.',
  'fehler.rechnung.hatGutschriften': 'Cette facture a des avoirs. Annulez d’abord les avoirs.',
  'fehler.rechnung.ueberWareneingang': 'La facture dépasse la réception de {differenz}. Confirmez explicitement pour payer quand même.',
  'fehler.rechnung.keineDebitorenrechnung': 'Ce n’est pas une facture de vente.',
  'fehler.rechnung.andererKunde': 'Cette facture appartient à un autre client.',
  'fehler.sammelrechnung.zuWenige': 'Le regroupement nécessite au moins deux factures.',
  'fehler.sammelrechnung.verschiedeneWaehrungen': 'Toutes les factures doivent avoir la même monnaie.',
  'fehler.gutschrift.mehrAlsOffen': 'Impossible de créditer {menge} - il ne reste que {offen}.',
  'fehler.gutschrift.ueberRechnungsbetrag': '{neu} plus les {bisher} existants dépassent le total de la facture de {gesamt}.',
  'fehler.anzahlung.ohneRechnung': 'Un acompte ne peut pas être imputé sans facture.',
  'fehler.anzahlung.ohneNamen': 'Le nom de la partie manque.',
  'fehler.mahnung.hoechsteStufe': 'Le niveau de rappel le plus élevé est déjà atteint.',
  'fehler.waehrung.kursGebraucht': 'Une facture en {waehrung} a besoin d’un taux de change.',
  'fehler.waehrung.kursGebraucht': 'Une facture en {waehrung} a besoin d’un taux de change.',
  'fehler.waehrung.kursGebraucht': 'Une facture en {waehrung} a besoin d’un taux de change.',
  'fehler.waehrung.kursNurBeiFremdwaehrung': 'Un taux de change ne concerne qu’une facture en devise étrangère.',
  'fehler.waehrung.kursNurBeiFremdwaehrung': 'Un taux de change ne concerne qu’une facture en devise étrangère.',
  'fehler.waehrung.stillgelegt': 'La monnaie {waehrung} est désactivée.',
  'fehler.waehrung.unbekannt': 'La monnaie {waehrung} n’est pas enregistrée.',
  'fehler.waehrung.schonVorhanden': 'Cette monnaie existe déjà.',
  'fehler.waehrung.keinKurs': 'Il n’y a aucun taux pour {waehrung} au {datum}.',
  'fehler.waehrung.chfIstBasis': 'Le CHF est la monnaie de base et n’a pas de taux de change.',
  'fehler.waehrung.chfNichtStilllegbar': 'Le CHF est la monnaie de base et ne peut pas être désactivé.',
  'fehler.waehrung.kursdienstFehler': 'Le service de taux n’a pas répondu comme prévu. Réessayez plus tard.',
  'fehler.waehrung.kursdienstFehler': 'Le service de taux n’a pas répondu comme prévu. Réessayez plus tard.',
  'fehler.bankabgleich.waehrungenVerschieden': 'Un mouvement bancaire en {bank} ne correspond pas à une facture en {rechnung}.',
  'fehler.bankabgleich.keineFremdwaehrung': 'Une facture en devise étrangère ne peut pas être réglée par le rapprochement bancaire - payez-la directement avec un taux de change.',
  'fehler.kasse.ohneKonto': 'Aucun compte du grand livre n’est configuré pour la caisse.',
  'fehler.kasse.ohneKonto': 'Aucun compte du grand livre n’est configuré pour la caisse.',
  'fehler.kasse.ohneGegenkonto': 'Une écriture de caisse a besoin d’une contrepartie - matériel, port et prélèvements privés sont des choses différentes.',
  'fehler.kasse.zuWenigBargeld': 'La caisse ne contient que {bestand} - impossible de décaisser {betrag}.',
  'fehler.kasse.kuerzelVergeben': 'Ce code de caisse est déjà attribué.',
  'fehler.kontenrahmen.umstellungNichtMoeglich': 'Le plan comptable ne peut pas être converti ainsi. Consultez l’aperçu - il en indique la raison.',
  'fehler.anlage.restwertZuHoch': 'La valeur résiduelle doit être inférieure au coût d’acquisition.',
  'fehler.anlage.abschreibungssatzFehlt': 'L’amortissement dégressif a besoin d’un taux supérieur à zéro.',
  'fehler.anlage.schonAbgegangen': 'Cette immobilisation est déjà sortie.',
  'fehler.firma.gleicheFirma': 'L’origine et la destination doivent être des entreprises différentes.',
  'fehler.zahlungsbedingung.kuerzelVergeben': 'Ce code de condition de paiement est déjà attribué.',
  'fehler.profitcenter.kuerzelVergeben': 'Ce code de centre de profit est déjà attribué.',
  'fehler.abo.hatRechnungen': '{anzahl} facture(s) proviennent déjà de ce modèle. Désactivez-le au lieu de le supprimer.',
  'fehler.abo.stillgelegt': 'Ce modèle est désactivé.',
  'fehler.abo.nochNichtFaellig': 'Ce modèle n’est dû que le {faellig}. Confirmez explicitement pour le générer plus tôt.',
  'fehler.abo.laufSchonVorhanden': 'Il existe déjà une exécution de ce modèle pour le {datum}.',
  'fehler.abo.ohneNaechstenTermin': 'Une facture récurrente a besoin d’une prochaine échéance.',
  'fehler.auswertung.unbekannteQuelle': 'Cette source de données n’existe pas.',
  'fehler.auswertung.unbekanntesFeld': 'Ce champ n’existe pas dans ce rapport.',
  'fehler.auswertung.unbekanntesFeld': 'Ce champ n’existe pas dans ce rapport.',
  'fehler.auswertung.vergleichNichtErlaubt': 'Cette comparaison ne convient pas à ce champ.',
  'fehler.auswertung.gruppierungNichtMoeglich': 'Il n’est pas possible de grouper par cela.',
  'fehler.auswertung.nichtAusfuehrbar': 'Ce rapport n’a pas pu être exécuté avec les filtres choisis.',
  'fehler.mail.nichtEingerichtet': 'L’envoi d’e-mails n’est pas configuré. Renseignez-le sous Réglages → Entreprise.',
  'fehler.mail.ohneAbsender': 'L’adresse de l’expéditeur pour l’envoi d’e-mails manque.',
  'fehler.mail.versandGescheitert': 'L’e-mail n’a pas pu être envoyé. Vérifiez les réglages de messagerie.',
  'fehler.ebics.nichtEingerichtet': 'La connexion bancaire n’est pas configurée.',
  'fehler.ebics.ohneHauptschluessel': 'La clé principale de la connexion bancaire manque. Sans elle, les clés bancaires ne peuvent pas être stockées en sécurité.',
  'fehler.ebics.ohneHauptschluessel': 'La clé principale de la connexion bancaire manque. Sans elle, les clés bancaires ne peuvent pas être stockées en sécurité.',
  'fehler.ebics.ohneHauptschluessel': 'La clé principale de la connexion bancaire manque. Sans elle, les clés bancaires ne peuvent pas être stockées en sécurité.',
  'fehler.ebics.hauptschluesselFalscheLaenge': 'La clé principale de la connexion bancaire a une longueur incorrecte - elle doit faire exactement 32 octets.',
  'fehler.ebics.schluesselUnlesbar': 'La clé bancaire enregistrée ne peut pas être lue.',
  'fehler.ebics.versionUngueltig': 'Seuls H004 ou H005 sont possibles pour la connexion bancaire.',
  'fehler.ebics.nochNichtBereit': 'La connexion bancaire n’est pas encore prête. Soumettez d’abord les clés, faites-les activer par la banque et récupérez la clé bancaire.',
  'fehler.ebics.schluesselFehlen': 'Générez d’abord les clés de la connexion bancaire.',
  'fehler.ebics.angabenUnvollstaendig': 'Les informations de la connexion bancaire sont incomplètes - adresse, identifiants d’hôte, de partenaire et d’utilisateur sont tous requis.',

  'fehler.tarifimport.keinBetrag': '{wo} : "{wert}" n’est pas un montant.',
  'fehler.tarifimport.keinSteuersatz': '{wo} : "{wert}" n’est pas un taux d’imposition.',
  'fehler.tarifimport.satzAusserhalb': '{wo} : le taux {wert} est en dehors de 0 à 100.',
  'fehler.tarifimport.keinKanton': '{wo} : "{wert}" n’est pas un code de canton.',
  'fehler.tarifimport.keinTarifcode': '{wo} : "{wert}" n’est pas un code de tarif - on attend par exemple A0N ou B2Y.',
  'fehler.tarifimport.keinJahr': '{wo} : "{wert}" n’est pas une année de validité.',
  'fehler.import.keineZeilen': 'Ce fichier ne contient aucune ligne de données.',
  'fehler.import.spalteFehlt': 'La colonne {spalte} manque. Trouvé : {gefunden}.',
  'fehler.tarifimport.keineSaetze': 'Aucun taux n’a été trouvé dans ce fichier. Les limites de champs sont-elles correctes ?',
  'fehler.tarifimport.mitBefunden': 'Le tarif présente {anzahl} anomalies et n’a PAS été repris. Consultez l’aperçu.',
  'fehler.quellensteuer.keinSatzFuerEinkommen': 'Ce tarif ne prévoit aucun taux pour un revenu mensuel de {einkommen}.',
  'fehler.quellensteuer.keinTarif': 'Aucun tarif d’impôt à la source n’est enregistré pour {kanton}/{tarif}/{jahr}. Importez-le avant de lancer la paie.',
  'fehler.zulage.keinAnsatz': 'Aucun montant d’allocation familiale n’est enregistré pour {kanton}/{jahr}. Saisissez-le avant de lancer la paie.',
  'fehler.abwesenheitsart.nochVerwendet': '"{art}" est encore utilisé ({antraege} demandes). Désactivez-le au lieu de le supprimer - sinon les anciennes demandes deviennent illisibles.',
  'fehler.abwesenheitsart.grundbestand': '"{art}" fait partie du jeu standard et ne peut pas être supprimé. La désactivation est possible.',
  'fehler.antrag.schonVorhandenMitZeitraum': 'Une demande existe déjà pour cette période ({von} à {bis}, {status}).',
  'fehler.ferien.guthabenReichtNicht': 'Le solde {jahr} ne suffit pas : {beantragt} jours demandés, {verfuegbar} disponibles.',
  'fehler.farbe.unbekannt': 'Cette couleur n’existe pas. Sont autorisées : {erlaubt}.',
  'fehler.lohn.schonStorniert': 'Ce cycle de paie a déjà été annulé.',
  'fehler.monat.geschlossen': 'Le mois {monat}/{jahr} est {zustand} et donc clos. Les temps n’y sont plus modifiables.',

  'fehler.monat.falscherZustand': 'Le mois est {zustand} - plus rien ne peut y être modifié.',

  /* ---- Pointeuse, liaison du compte et le choix de l’entreprise ---- */

  'hr.employees.col.konto': 'Compte',
  'hr.employees.action.link': 'Compte',
  'hr.employees.link.title': 'Lier un compte au dossier du personnel',
  'hr.employees.link.hinweis': 'Quel compte appartient à {name} ? Sans ce lien, la personne ne voit ni son temps, ni ses vacances, ni son décompte.',
  'hr.employees.link.konto': 'Compte',
  'hr.employees.link.keins': 'Aucun compte',
  'hr.employees.link.belegt': 'déjà attribué',
  'hr.employees.link.loesen': 'Délier',
  'hr.employees.link.ja': 'lié',
  'hr.employees.link.nein': 'ouvert',

  'platform.provisioning.step.adminEmployee': 'Dossier du personnel du premier compte',

  'stempel.title': 'Pointeuse',
  'stempel.bereit': 'Prêt. Un clic sur démarrer et le temps court.',
  'stempel.seit': 'depuis {zeit}',
  'stempel.pauseGesamt': '{minuten} min de pause',
  'stempel.pausiert': 'en pause',
  'stempel.start': 'Démarrer',
  'stempel.pause': 'Pause',
  'stempel.weiter': 'Reprendre',
  'stempel.stopp': 'Arrêter',
  'stempel.vergessen': 'Ce pointage tourne depuis plus de {stunden} heures. Il ne se ferme pas tout seul - l’arrêt demandera l’heure de fin exacte.',
  'stempel.korrektur.title': 'Quand avez-vous terminé ?',
  'stempel.korrektur.hinweis': 'Commencé le {datum} à {zeit}. Deviner une heure de fin serait pire que de la demander - elle resterait durablement dans votre temps de travail.',
  'stempel.korrektur.ende': 'Fin',

  'settings.nav.zeit': 'Saisie du temps',
  'settings.zeit.title': 'Comment cette entreprise saisit-elle le temps ?',
  'settings.zeit.intro': 'Vous décidez des voies dont vos collaborateurs disposent pour LEUR propre temps. Les RH peuvent toujours corriger - sinon un pointage oublié ne pourrait plus jamais être rectifié.',
  'settings.zeit.beides': 'Les deux',
  'settings.zeit.beides.desc': 'Pointeuse et saisie manuelle. Adapté quand tout le monde n’est pas devant un écran au début du travail.',
  'settings.zeit.nurStempel': 'Pointeuse seulement',
  'settings.zeit.nurStempel.desc': 'Démarrer, pause, arrêter - rien d’autre. Qui peut taper des heures après coup peut aussi les inventer.',
  'settings.zeit.nurManuell': 'Saisie manuelle seulement',
  'settings.zeit.nurManuell.desc': 'On inscrit le service au lieu de le pointer. Adapté au service externe et aux chantiers.',
  'settings.zeit.maxStunden': 'À partir de quand un pointage est-il oublié ?',
  'settings.zeit.maxStunden.hint': 'Heures. Ensuite il n’est pas fermé : l’arrêt demande l’heure de fin.',
  'settings.zeit.gespeichert': 'Enregistré.',

  'fehler.person.kontoSchonVerknuepft': 'Ce compte appartient déjà à un autre dossier du personnel. Déliez-le là-bas d’abord.',
  'fehler.zeit.stempeluhrAus': 'Cette entreprise saisit le temps manuellement. La pointeuse est désactivée.',
  'fehler.zeit.handerfassungAus': 'Cette entreprise saisit le temps avec la pointeuse. Seuls les RH peuvent inscrire des heures à la main.',
  'fehler.zeit.stempelungLaeuftSchon': 'Un pointage est déjà en cours. Peut-être sur un autre appareil.',
  'fehler.zeit.keineStempelungOffen': 'Aucun pointage n’est en cours.',
  'fehler.zeit.pauseLaeuftSchon': 'La pause est déjà en cours.',
  'fehler.zeit.keinePauseOffen': 'Aucune pause n’est en cours.',
  'fehler.zeit.stempelZuLang': 'Ce pointage tourne depuis plus de {stunden} heures. Indiquez l’heure de fin exacte - elle ne sera pas devinée.',
  'fehler.zeit.stempelZuKurz': 'Moins d’une minute n’est pas un service.',
  'fehler.zeit.endeVorBeginn': 'La fin est avant le début.',
  'fehler.zeit.endeInDerZukunft': 'La fin est dans le futur.',
  'fehler.zeit.endeUnlesbar': 'Cette heure de fin est illisible.',
  'fehler.zeit.zeitzoneUnbekannt': 'Le fuseau horaire {zone} est inconnu.',
  'fehler.einstellung.fehlt': 'Les réglages de cette entreprise manquent. L’installation n’est pas à jour.',

  /* La recherche de « temps » trouve trois pages. Ces demi-phrases disent
     laquelle est visée - avant, il n’y avait que le chemin en anglais. */
  'nav.myTime.hint': 'pointer ou saisir son propre temps de travail',
  'nav.time.hint': 'consulter et corriger le temps de travail de tous les collaborateurs',
  'nav.projectsTime.hint': 'imputer des heures à un projet, pour la facturation',

};
